var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
let CultureInfo = {
  "ru-Ru": {
    Lang: {
      Change: "Изменить",
      Remove: "Удалить",
      GetMore: "Загрузить еще",
      GetAll: "Загрузить все",
      Refresh: "Обновить",
      YouHaveNoPermission: "Недостаточно прав",
      Ok: "Ок",
      Cancel: "Отмена",
      ListEmpty: "нет элементов для отображения",
      SelectEmpty: "Не выбрано",
      ChoosePeriod: "Выберите период"
    },
    DateFormat: "DD.MM.YYYY",
    DateFormatTime: "HH:mm:ss",
    DateFormatFull: "DD.MM.YYYY HH:mm:ss",
    MonthNames: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
    MonthNamesInclined: ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"],
    MonthNamesShort: ["янв.", "фев.", "мар.", "апр.", "май", "июн.", "июл.", "авг.", "сен.", "окт.", "ноя.", "дек."],
    WeekDays: ["Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота", "Воскресенье"],
    WeekDaysShort: ["пн", "вт", "ср", "чт", "пт", "сб", "вс"],
    MonthDict: {
      январь: 0,
      февраль: 1,
      март: 2,
      апрель: 3,
      май: 4,
      июнь: 5,
      июль: 6,
      август: 7,
      сентябрь: 8,
      октябрь: 9,
      ноябрь: 10,
      декабрь: 11,
      января: 0,
      февраля: 1,
      марта: 2,
      апреля: 3,
      мая: 4,
      июня: 5,
      июля: 6,
      августа: 7,
      сентября: 8,
      октября: 9,
      ноября: 10,
      декабря: 11,
      янв: 0,
      фев: 1,
      мар: 2,
      апр: 3,
      //["май"]: 4,
      июн: 5,
      июл: 6,
      авг: 7,
      сен: 8,
      окт: 9,
      ноя: 10,
      дек: 11
    }
  },
  "en-Us": {
    Lang: {
      Change: "Change",
      Remove: "Remove",
      GetMore: "Get more",
      GetAll: "Get all",
      Refresh: "Refresh",
      YouHaveNoPermission: "You have no permission",
      Ok: "Ok",
      Cancel: "Cancel",
      ListEmpty: "list empty",
      SelectEmpty: "Not chosen",
      ChoosePeriod: "Choose period"
    },
    DateFormat: "MM.DD.YYYY",
    DateFormatTime: "HH:mm:ss",
    DateFormatFull: "MM.DD.YYYY HH:mm:ss",
    MonthNames: ["January", "February", "March", "April", "May", "June", "Jule", "August", "September", "October", "November", "December"],
    MonthNamesInclined: ["January", "February", "March", "April", "May", "June", "Jule", "August", "September", "October", "November", "December"],
    MonthNamesShort: ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"],
    WeekDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    WeekDaysShort: ["mo", "tu", "we", "th", "fr", "sa", "su"],
    MonthDict: {
      january: 0,
      february: 1,
      march: 2,
      april: 3,
      may: 4,
      june: 5,
      jule: 6,
      august: 7,
      september: 8,
      october: 9,
      november: 10,
      december: 11,
      jan: 0,
      feb: 1,
      mar: 2,
      apr: 3,
      //"may":4,
      jun: 5,
      jul: 6,
      aug: 7,
      sep: 8,
      oct: 9,
      nov: 10,
      dec: 11
    }
  }
}, Culture = {
  Dict: CultureInfo,
  Current: CultureInfo["ru-Ru"]
};
const _DayCountByMonthNum = {
  0: 31,
  1: 28,
  2: 31,
  3: 30,
  4: 31,
  5: 30,
  6: 31,
  7: 31,
  8: 30,
  9: 31,
  10: 30,
  11: 31
}, _RegexJsonStringify = new RegExp("^([\\+-]?\\d{4}(?!\\d{2}\\b))((-?)((0[1-9]|1[0-2])(\\3([12]\\d|0[1-9]|3[01]))?|W([0-4]\\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\\d|[12]\\d{2}|3([0-5]\\d|6[1-6])))([T\\s]((([01]\\d|2[0-3])((:?)[0-5]\\d)?|24\\:?00)([\\.,]\\d+(?!:))?)?(\\17[0-5]\\d([\\.,]\\d+)?)?([zZ]|([\\+-])([01]\\d|2[0-3]):?([0-5]\\d)?)?)?)?$"), _regexDateCs = new RegExp("Date\\((-?[\\d]+)(([+-]\\d+)\\))?");
function isDateValid(date) {
  return Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date.getTime());
}
__name(isDateValid, "isDateValid");
function _GetCountDays(date) {
  let month = date.getMonth();
  if (month !== 1)
    return _DayCountByMonthNum[month];
  let year = date.getFullYear();
  return new Date(year, month + 1, 0).getDate();
}
__name(_GetCountDays, "_GetCountDays");
const _LuffDate = class _LuffDate {
  static From(date, format, refDate) {
    return date || (date = /* @__PURE__ */ new Date()), new _LuffDate(date, format, refDate);
  }
  Format(format = Culture.Current.DateFormatFull) {
    let date = this._Date;
    if (date === null || typeof date > "u")
      return "";
    let day = date.getDay();
    day = day !== 0 ? day - 1 : 6;
    const data = date.getDate(), mo = date.getMonth() + 1, year = date.getFullYear(), hour = date.getHours(), min = date.getMinutes(), sec = date.getSeconds();
    let timeZoneValue = date.getTimezoneOffset() / -0.6, timeZone = String(Math.abs(timeZoneValue)), zeroCount = 4 - timeZone.toString().length;
    return zeroCount > 0 && (timeZone = "0".repeat(zeroCount) + timeZone), format = format.replace(/[DdMmYyHhSsZz]/g, "%$&"), format.replace(/%D%D/g, data.toString().length < 2 ? `0${data}` : data.toString()).replace(/%D/g, data.toString()).replace(/%d%d%d%d/g, Culture.Current.WeekDays[day]).replace(/%d%d%d/g, Culture.Current.WeekDaysShort[day]).replace(/%M%M%M%M%M/g, Culture.Current.MonthNamesInclined[mo - 1]).replace(/%M%M%M%M/g, Culture.Current.MonthNames[mo - 1]).replace(/%M%M%M/g, Culture.Current.MonthNamesShort[mo - 1]).replace(/%M%M/g, mo.toString().length < 2 ? `0${mo}` : mo.toString()).replace(/%M/g, mo.toString()).replace(/%Y%Y%Y%Y/g, year.toString()).replace(/%Y%Y/g, year.toString().substring(2, 4)).replace(/%Y/g, year.toString()).replace(/%H%H/g, hour.toString().length < 2 ? `0${hour}` : hour.toString()).replace(/%h%h/g, (hour % 12).toString().length < 2 ? `0${hour % 12}` : (hour % 12).toString()).replace(/%H/g, hour.toString()).replace(/%h/g, (hour % 12).toString()).replace(/%m%m/g, min.toString().length < 2 ? `0${min}` : min.toString()).replace(/%m/g, min.toString()).replace(/%s%s/g, sec.toString().length < 2 ? `0${sec}` : sec.toString()).replace(/%s/g, sec.toString()).replace(/%Z/g, `${timeZoneValue < 0 ? "-" : "+"}${timeZone}`);
  }
  toString() {
    return this.Format();
  }
  valueOf() {
    return this._Date.valueOf();
  }
  get TotalMilliseconds() {
    return this._Date.valueOf();
  }
  /*    Diff(Date: Date | _luffDate) : number[] {
              let ms = Math.abs(this.Value - Date.Value);
              let diffs = [];
              let div = [1000, 60, 60, 24];
              let res = ms;
              for (let d of [86400000, 3600000, 60000, 1000]){
                  let val = Math.floor(res / d);
                  let rest = res % d;
                  console.log(res, d, val, rest);
                  diffs.push(val);
                  res = rest;
              }
              console.warn('[Luff.Date().Diff] is experimental method');
              return diffs;
          }
          DiffFull(Date: _luffDate | Date){
              Date = luffDate(Date);
  
              let FullMilliseconds = Date.Value;
  
              let DateMin = this;
              let DateMax = Date;
              if (this.Value > Date.Value){
                  DateMin = Date;
                  DateMax = this;
              }
              let Cursor  = DateMax.Clone();
              let Compars = Date.Date < this._Date ? Date : this;
  
              let DF = {
                  Years: 0,
                  Months: 0,
                  Days: 0,
                  Hours: 0,
                  Minutes: 0,
                  Seconds: 0,
                  Milliseconds: 0
              };
  
              DF.Years = Cursor.Year - DateMin.Year;
              if (DF.Years > 0 && Cursor.Month < DateMin.Month){
                  DF.Years--;
                  DF.Months = Cursor.Month+1;
                  Cursor.SetMonth(11)
              }
              DF.Months += Cursor.Month - DateMin.Month;
              if (DF.Months > 0 && Cursor.Day < DateMin.Day){
                  DF.Months--;
                  DF.Days = Cursor.Day+1;
                  Cursor.SetDay(Cursor.CountDays);
              }
              DF.Days += Cursor.Day - DateMin.Day;
              if (DF.Days > 0 && Cursor.Hours < DateMin.Hours){
                  DF.Days--;
                  DF.Hours = Cursor.Hours+1;
                  Cursor.SetHours(23);
              }
              DF.Hours += Cursor.Hours - DateMin.Hours;
              if (DF.Hours > 0 && Cursor.Minutes < DateMin.Minutes){
                  DF.Hours--;
                  DF.Minutes = Cursor.Minutes+1;
                  Cursor.SetMinutes(59);
              }
              DF.Minutes += Cursor.Minutes - DateMin.Minutes;
              if (DF.Minutes > 0 && Cursor.Seconds < DateMin.Seconds){
                  DF.Minutes--;
                  DF.Seconds = Cursor.Seconds+1;
                  Cursor.SetSeconds(59);
              }
              DF.Seconds += Cursor.Seconds - DateMin.Seconds;
              if (DF.Seconds > 0 && Cursor.Milliseconds < DateMin.Milliseconds){
                  DF.Seconds--;
                  DF.Milliseconds = Cursor.Milliseconds+1;
                  Cursor.SetMilliseconds(999);
              }
              DF.Milliseconds += Cursor.Milliseconds - DateMin.Milliseconds;
              return DF;
          }*/
  get CountDays() {
    return _GetCountDays(this._Date);
  }
  get DayStart() {
    let d = new Date(this._Date.getTime());
    return d.setHours(0, 0, 0, 0), luffDate(d);
  }
  get DayEnd() {
    let d = new Date(this._Date.getTime());
    return d.setHours(23, 59, 59, 997), luffDate(d);
  }
  get WeekStart() {
    let wd = this._Date.getDay();
    return wd = wd !== 0 ? wd - 1 : 6, this.AddDays(-wd).DayStart;
  }
  get WeekEnd() {
    let wd = this._Date.getDay();
    return wd = wd !== 0 ? wd - 1 : 6, luffDate(this._Date).AddDays(6 - wd).DayEnd;
  }
  get MonthStart() {
    let d = new Date(this._Date.getTime());
    return d.setDate(1), d.setHours(0, 0, 0, 0), luffDate(d);
  }
  get MonthEnd() {
    let d = new Date(this._Date.getTime());
    return d.setDate(luffDate(d).CountDays), d.setHours(23, 59, 59, 997), luffDate(d);
  }
  get QuarterStart() {
    let d = new Date(this._Date.getTime()), quart = Math.floor(d.getMonth() / 3);
    return d.setMonth(quart * 3), d.setDate(1), d.setHours(0, 0, 0, 0), luffDate(d);
  }
  get QuarterEnd() {
    let d = new Date(this._Date.getTime()), quart = Math.floor(d.getMonth() / 3);
    return d.setMonth(quart * 3 + 2), d.setDate(_GetCountDays(d)), d.setHours(23, 59, 59, 997), luffDate(d);
  }
  get YearStart() {
    return luffDate(new Date(this._Date.getFullYear(), 0, 1));
  }
  get YearEnd() {
    return luffDate(new Date(this._Date.getFullYear(), 11, 31, 23, 59, 59, 997));
  }
  AddMilliseconds(count) {
    return this._Date.setMilliseconds(this._Date.getMilliseconds() + count), this;
  }
  AddSeconds(count) {
    return this._Date.setSeconds(this._Date.getSeconds() + count), this;
  }
  AddMinutes(count) {
    return this._Date.setMinutes(this._Date.getMinutes() + count), this;
  }
  AddHours(count) {
    return this._Date.setHours(this._Date.getHours() + count), this;
  }
  AddDays(count) {
    return this._Date.setDate(this._Date.getDate() + count), this;
  }
  AddMonths(count) {
    let DtDays = this._Date.getDate(), DtTargetDays = new Date(this._Date.getFullYear(), this._Date.getMonth() + count + 1, 0).getDate();
    return DtTargetDays >= DtDays ? this._Date.setMonth(this._Date.getMonth() + count) : (this._Date.setMonth(this._Date.getMonth() + count), this.AddDays(DtTargetDays - DtDays)), this;
  }
  AddQuarters(count) {
    return this.AddMonths(count * 3), this;
  }
  AddYears(count) {
    let DtMonths = this._Date.getMonth(), DtTargetMonths = new Date(this._Date.getFullYear() + count, 0, 0).getMonth();
    return DtTargetMonths >= DtMonths ? this._Date.setFullYear(this._Date.getFullYear() + count) : (this._Date.setFullYear(this._Date.getFullYear() + count), this.AddMonths(DtTargetMonths - DtMonths)), this;
  }
  get Date() {
    return this._Date;
  }
  get Int() {
    return this._Date.valueOf();
  }
  get Value() {
    return this._Date.valueOf();
  }
  get DateCs() {
    return "/Date(" + +this.Value + this.Format("Z") + ")/";
  }
  get Milliseconds() {
    return this._Date.getMilliseconds();
  }
  get Seconds() {
    return this._Date.getSeconds();
  }
  get Minutes() {
    return this._Date.getMinutes();
  }
  get Hours() {
    return this._Date.getHours();
  }
  get Day() {
    return this._Date.getDate();
  }
  /**
   * @description returns from 1 to 7 where monday is 1, saturday is 7
   * */
  get DayOfWeek() {
    let d = this._Date.getDay();
    return d === 0 ? 7 : d;
  }
  get Month() {
    return this._Date.getMonth();
  }
  get Quarter() {
    const month = this._Date.getMonth() + 1;
    let quarter = 1;
    return month > 3 && quarter++, month > 6 && quarter++, month > 9 && quarter++, quarter;
  }
  get Year() {
    return this._Date.getFullYear();
  }
  SetMilliseconds(milliseconds) {
    return this._Date.setMilliseconds(milliseconds), this;
  }
  SetSeconds(seconds) {
    return this._Date.setSeconds(seconds), this;
  }
  SetMinutes(minutes) {
    return this._Date.setMinutes(minutes), this;
  }
  SetHours(hours) {
    return this._Date.setHours(hours), this;
  }
  SetDay(day) {
    return this._Date.setDate(day), this;
  }
  SetMonth(month) {
    return this._Date.setMonth(month), this;
  }
  SetQuarter(quarter) {
    const quarterMonth = quarter * 3 - 3;
    return this.SetMonth(quarterMonth), this;
  }
  SetYear(year) {
    return this._Date.setFullYear(year), this;
  }
  SetDayStart() {
    return this._Date.setHours(0, 0, 0, 0), this;
  }
  SetDayEnd() {
    return this._Date.setHours(23, 59, 59, 997), this;
  }
  SetWeekStart() {
    let wd = this._Date.getDay();
    return wd = wd !== 0 ? wd - 1 : 6, this._Date = this.AddDays(-wd).DayStart.Date, this;
  }
  SetWeekEnd() {
    let weekDay = this._Date.getDay();
    return weekDay = weekDay !== 0 ? weekDay - 1 : 6, this._Date = this.AddDays(6 - weekDay).DayEnd.Date, this;
  }
  SetMonthStart() {
    return this._Date.setDate(1), this._Date.setHours(0, 0, 0, 0), this;
  }
  SetMonthEnd() {
    return this._Date.setDate(this.CountDays), this._Date.setHours(23, 59, 59, 997), this;
  }
  SetQuarterStart() {
    let quart = Math.floor(this.Month / 3);
    return this._Date.setMonth(quart * 3), this._Date.setDate(1), this._Date.setHours(0, 0, 0, 0), this;
  }
  SetQuarterEnd() {
    let quart = Math.floor(this.Month / 3);
    return this._Date.setMonth(quart * 3 + 2), this._Date.setDate(this.CountDays), this._Date.setHours(23, 59, 59, 997), this;
  }
  SetYearStart() {
    return this._Date = new Date(this._Date.getFullYear(), 0, 1), this;
  }
  SetYearEnd() {
    return this._Date = new Date(this._Date.getFullYear(), 11, 31, 23, 59, 59, 997), this;
  }
  Clone() {
    return luffDate(this._Date);
  }
  CopyTime(luffDate2) {
    this.SetHours(luffDate2.Hours), this.SetMinutes(luffDate2.Minutes), this.SetSeconds(luffDate2.Seconds), this.SetMilliseconds(luffDate2.Milliseconds);
  }
  IsSameDate(luffDate2) {
    return this.Year === luffDate2.Year && this.Month === luffDate2.Month && this.Day === luffDate2.Day;
  }
  get IsToday() {
    return this.IsCurrentDay;
  }
  get IsCurrentDay() {
    const today = /* @__PURE__ */ new Date(), day = this._Date.getDate(), month = this._Date.getMonth(), year = this._Date.getFullYear();
    return day === today.getDate() && month === today.getMonth() && year === today.getFullYear();
  }
  get IsCurrentMonth() {
    const month = this._Date.getMonth(), year = this._Date.getFullYear(), today = /* @__PURE__ */ new Date();
    return month === today.getMonth() && year === today.getFullYear();
  }
  constructor(date, format = Culture.Current.DateFormatFull, refDate = /* @__PURE__ */ new Date()) {
    if (date === null || typeof date > "u")
      return console.error(new Error("[Luff.Date] Input Date is undefined or null")), null;
    if (date instanceof Date)
      this._Date = new Date(date.valueOf());
    else if (date instanceof _LuffDate)
      this._Date = date._Date;
    else if (!isNaN(parseFloat(date)) && isFinite(date))
      this._Date = new Date(parseInt(date));
    else if (typeof date == "string" && _RegexJsonStringify.test(date))
      this._Date = new Date(date);
    else {
      let errorSum = 0;
      const dags = "DDMMYYYYHHmmss";
      let legacy = [];
      format = format || Culture.Current.DateFormatFull, format.indexOf("MMM") > -1 && (format = format.replace(/[M]{3,}/g, "M"), date = date.replace(/[a-zA-Zа-я-А-Я\\w]+\.?/, function(match, index) {
        if (match = match.replace(".", "").toLowerCase(), Culture.Current.MonthDict[match] !== void 0)
          return Culture.Current.MonthDict[match] + 1;
        errorSum++;
      }));
      const rgx = format.replace(/[DMYHms]+/g, function(match, index) {
        if (legacy.push(match.substring(0, 1)), dags.indexOf(match) > -1) {
          let len = match.length < 2 ? "0,2" : match.length;
          return match === "Y" && (len = "2,4"), `(\\d{${len}})?`;
        }
      }).replace(/[.-/ :;]/g, function(match) {
        return match + "?";
      });
      let C = {
        Y: 0,
        M: 0,
        D: 0,
        H: 0,
        m: 0,
        s: 0
      };
      if (date.replace(new RegExp(rgx), function(match, a, b, c, d, e, f, g, h) {
        let x = [a, b, c, d, e, f, g, h];
        for (let i = 0; i < legacy.length; i++)
          C[legacy[i]] = x[i] ? x[i] : C[legacy[i]], (x[i] === "" || x[i] === "0") && errorSum++;
      }), C.Y || (C.Y = refDate.getFullYear()), C.M || (C.M = refDate.getMonth() + 1), C.D || (C.D = refDate.getDate()), !C.M && (C.D || C.H || C.m || C.s) && errorSum++, (C.M > 12 || C.H > 23 || C.m > 59 || C.s > 59) && errorSum++, this._Date = new Date(C.Y, C.M - 1, C.D, C.H, C.m, C.s), !isDateValid(this._Date) || errorSum > 0) {
        let dateParts = _regexDateCs.exec(date);
        if (dateParts) {
          let [match, timeStr, matchTz, timeZoneOffsetStr] = dateParts;
          const totalMilliseconds = parseInt(timeStr);
          if (this._Date = new Date(totalMilliseconds), timeZoneOffsetStr) {
            const tzHours = parseInt(timeZoneOffsetStr.substring(1, 2)), tzMinutes = parseInt(timeZoneOffsetStr.substring(3)), timeZoneOffset = tzHours * 60 + tzMinutes;
            this._Date.setMinutes(this._Date.getMinutes() + timeZoneOffset);
          }
        }
        errorSum = 0;
      }
      (!isDateValid(this._Date) || errorSum > 0) && (this._Date = new Date(date)), (!isDateValid(this._Date) || errorSum > 0) && console.error(`[Luff.Data] Parse Error. Can not parse properly input Data "${date}"`);
    }
  }
};
__name(_LuffDate, "LuffDate");
let LuffDate = _LuffDate;
function luffDate(date, format, refDate) {
  return LuffDate.From(date, format, refDate);
}
__name(luffDate, "luffDate");
var DateDiffUpTo;
(function(DateDiffUpTo2) {
  DateDiffUpTo2[DateDiffUpTo2.Seconds = 0] = "Seconds", DateDiffUpTo2[DateDiffUpTo2.Minutes = 1] = "Minutes", DateDiffUpTo2[DateDiffUpTo2.Hours = 2] = "Hours", DateDiffUpTo2[DateDiffUpTo2.Days = 3] = "Days", DateDiffUpTo2[DateDiffUpTo2.Months = 4] = "Months", DateDiffUpTo2[DateDiffUpTo2.Years = 5] = "Years";
})(DateDiffUpTo || (DateDiffUpTo = {}));
luffDate.DiffType = DateDiffUpTo;
luffDate.Sum = function(date1, date2, sumUpTo) {
  let res = luffDate(date1);
  const d = luffDate(date2);
  return res.AddMilliseconds(d.Milliseconds), res.AddSeconds(d.Seconds), sumUpTo >= DateDiffUpTo.Minutes && (res.AddMinutes(d.Minutes), sumUpTo >= DateDiffUpTo.Hours && (res.AddHours(d.Hours), sumUpTo >= DateDiffUpTo.Days && (res.AddDays(d.Day), sumUpTo >= DateDiffUpTo.Months && (res.AddMonths(d.Month), sumUpTo >= DateDiffUpTo.Years && res.AddYears(d.Year))))), res.Date;
};
luffDate.Diff = function(date1, date2, diffUntil) {
  let res = luffDate(date1);
  const d = luffDate(date2);
  return res.AddMilliseconds(-d.Milliseconds), res.AddSeconds(-d.Seconds), diffUntil >= DateDiffUpTo.Minutes && (res.AddMinutes(-d.Minutes), diffUntil >= DateDiffUpTo.Hours && (res.AddHours(-d.Hours), diffUntil >= DateDiffUpTo.Days && (res.AddDays(-d.Day), diffUntil >= DateDiffUpTo.Months && (res.AddMonths(-d.Month), diffUntil >= DateDiffUpTo.Years && res.AddYears(-d.Year))))), res.Date;
};
var LibraryNumber;
(function(LibraryNumber2) {
  let idCounter2 = 0;
  function GetRandom(max = 100, min = 0) {
    return Math.round(Math.random() * (max - min) + min);
  }
  __name(GetRandom, "GetRandom"), LibraryNumber2.GetRandom = GetRandom;
  function RoundBy(number2, divider, mode = "ceil") {
    let b = number2 % divider;
    return b === 0 ? number2 : mode === "ceil" ? number2 - b + divider : mode === "floor" ? number2 - b : number2 - b + (b / divider < 0.5 ? 0 : divider);
  }
  __name(RoundBy, "RoundBy"), LibraryNumber2.RoundBy = RoundBy;
  function IsNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }
  __name(IsNumeric, "IsNumeric"), LibraryNumber2.IsNumeric = IsNumeric;
  function GetID() {
    return idCounter2++, idCounter2;
  }
  __name(GetID, "GetID"), LibraryNumber2.GetID = GetID;
  function GetLastID() {
    return idCounter2;
  }
  __name(GetLastID, "GetLastID"), LibraryNumber2.GetLastID = GetLastID;
  function GetNumberOrder(num) {
    let strNumber = num.toString().split(".");
    if (parseInt(strNumber[0]) !== 0)
      return strNumber[0].length - 1;
    {
      let p = strNumber[1] ? strNumber[1].match(/[^0]/) : void 0;
      return -(p ? p.index + 1 : 1);
    }
  }
  __name(GetNumberOrder, "GetNumberOrder"), LibraryNumber2.GetNumberOrder = GetNumberOrder;
})(LibraryNumber || (LibraryNumber = {}));
let fn = {
  Number: /* @__PURE__ */ __name(function(Value, PropertyName) {
    let n = parseFloat(Value);
    return (Number.isNaN(n) || !isFinite(n)) && (console.warn(`[Luff.PropTypes] ${PropertyName} ${Value} is not a Number`), n = 0), n;
  }, "number"),
  Int: /* @__PURE__ */ __name(function(Value, PropertyName) {
    let n = parseInt(Value);
    return (Number.isNaN(n) || !isFinite(n)) && (console.warn(`[Luff.PropTypes] ${PropertyName} ${Value} is not an Int`), n = 0), n;
  }, "int"),
  UInt: /* @__PURE__ */ __name(function(Value, PropertyName) {
    let n = parseInt(Value);
    return (Number.isNaN(n) || n < 0 || !isFinite(n)) && (console.warn(`[Luff.PropTypes] ${PropertyName} ${Value} is not an UInt`), n = 0), n;
  }, "uint"),
  String: /* @__PURE__ */ __name(function(Value, PropertyName) {
    return String(Value);
  }, "string"),
  StringRich: /* @__PURE__ */ __name(function(Value, PropertyName) {
    return String(Value);
  }, "text"),
  Bool: /* @__PURE__ */ __name(function(Value, PropertyName) {
    return Value === "true" && (Value = !0), Value === "false" && (Value = !1), Value !== !0 && Value !== !1 && (console.warn(`[Luff.PropTypes] ${PropertyName} ${Value} is not a Bool`), Value = !1), Value;
  }, "boolean"),
  Date: /* @__PURE__ */ __name(function(value, propertyName) {
    return value.constructor.name === "LuffDate" ? value : new LuffDate(value).Date;
  }, "boolean2")
};
const _PropTypes = class _PropTypes {
  static GetType(obj) {
    return obj instanceof Array || obj instanceof NodeList ? "array" : LibraryNumber.IsNumeric(obj) ? "number" : obj instanceof Date || obj instanceof LuffDate ? "date" : obj instanceof Function ? "function" : obj instanceof Node ? "node" : obj instanceof Object ? "object" : obj === null ? null : typeof obj;
  }
};
__name(_PropTypes, "PropTypes");
let PropTypes = _PropTypes;
PropTypes.Number = {
  JS: "number",
  Type: "float",
  TryParse: fn.Number
};
PropTypes.Float = {
  JS: "number",
  Type: "float",
  TryParse: fn.Number
};
PropTypes.Int = {
  JS: "number",
  Type: "int",
  TryParse: fn.Int
};
PropTypes.UInt = {
  JS: "number",
  Type: "uint",
  TryParse: fn.UInt
};
PropTypes.Bool = {
  JS: "boolean",
  Type: "boolean",
  TryParse: fn.Bool
};
PropTypes.String = {
  JS: "string",
  Type: "string",
  TryParse: fn.String
};
PropTypes.Date = {
  JS: "date",
  Type: "date",
  TryParse: fn.Date
};
PropTypes.DateTime = {
  JS: "date",
  Type: "datetime",
  TryParse: fn.Date
};
PropTypes.Any = {
  JS: "any",
  Type: "any",
  TryParse: fn.Int
};
const collator$1 = new Intl.Collator("en", { numeric: !0, sensitivity: "base" });
function sortComparer(a, b, fieldName) {
  let valueA = a[fieldName], valueB = b[fieldName];
  return valueA && valueA.localeCompare ? collator$1.compare(valueA, valueB) : valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
}
__name(sortComparer, "sortComparer");
var LibraryArray;
(function(LibraryArray2) {
  function Remove(list, predicate) {
    let removedCount = 0;
    for (let i = list.length - 1; i >= 0; --i)
      predicate(list[i], i) && (list.splice(i, 1), removedCount++);
    return removedCount;
  }
  __name(Remove, "Remove"), LibraryArray2.Remove = Remove;
  function MoveByIndex(list, indexFrom, indexTo) {
    if (indexFrom === indexTo)
      return;
    const item = list[indexFrom];
    list.splice(indexFrom, 1), list.splice(indexTo, 0, item);
  }
  __name(MoveByIndex, "MoveByIndex"), LibraryArray2.MoveByIndex = MoveByIndex;
  function MoveByItem(list, item1, item2) {
    const indexFrom = list.indexOf(item1), indexTo = list.indexOf(item2);
    MoveByIndex(list, indexFrom, indexTo);
  }
  __name(MoveByItem, "MoveByItem"), LibraryArray2.MoveByItem = MoveByItem;
  function SortByField(list, fieldName) {
    return list.sort((a, b) => sortComparer(a, b, fieldName));
  }
  __name(SortByField, "SortByField"), LibraryArray2.SortByField = SortByField;
  function FlattenObjects(arr, flatFn, subKey) {
    return arr.reduce((resultArr, obj) => resultArr.concat(obj[subKey].map(flatFn)), arr.map(flatFn));
  }
  __name(FlattenObjects, "FlattenObjects"), LibraryArray2.FlattenObjects = FlattenObjects;
})(LibraryArray || (LibraryArray = {}));
var LibraryBlob;
(function(LibraryBlob2) {
  function DoSave(fileName, href) {
    let a = document.createElement("a");
    a.style.display = "none", document.body.appendChild(a), a.href = href, a.download = fileName, a.click(), window.URL.revokeObjectURL(a.href), a.remove();
  }
  __name(DoSave, "DoSave");
  function SaveAs(blob, fileName) {
    DoSave(fileName, window.URL.createObjectURL(blob));
  }
  __name(SaveAs, "SaveAs"), LibraryBlob2.SaveAs = SaveAs;
  function SaveAsByBase64(base64Full, fileName) {
    DoSave(fileName, base64Full);
  }
  __name(SaveAsByBase64, "SaveAsByBase64"), LibraryBlob2.SaveAsByBase64 = SaveAsByBase64;
  function ToBase64(blob, isRawBase64 = !1) {
    return new Promise((res, rej) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob), reader.onloadend = function() {
        if (isRawBase64)
          return res(reader.result.split(",")[1]);
        res(reader.result);
      }, reader.onerror = rej;
    });
  }
  __name(ToBase64, "ToBase64"), LibraryBlob2.ToBase64 = ToBase64;
  function ToBase64FromArrayBuffer(bytes, base64Prefix = "") {
    let binaryStr = "", len = bytes.length;
    for (let i = 0; i < len; i++)
      binaryStr += String.fromCharCode(bytes[i]);
    return base64Prefix + window.btoa(binaryStr);
  }
  __name(ToBase64FromArrayBuffer, "ToBase64FromArrayBuffer"), LibraryBlob2.ToBase64FromArrayBuffer = ToBase64FromArrayBuffer;
  function ToByteArrayBuffer(blob) {
    return new Promise((res, rej) => {
      const reader = new FileReader();
      reader.onloadend = function() {
        res(reader.result);
      }, reader.onerror = rej, reader.readAsArrayBuffer(blob);
    });
  }
  __name(ToByteArrayBuffer, "ToByteArrayBuffer"), LibraryBlob2.ToByteArrayBuffer = ToByteArrayBuffer;
  function ToByteArrayUInt8(blob) {
    return ToByteArrayBuffer(blob).then((x) => new Uint8Array(x));
  }
  __name(ToByteArrayUInt8, "ToByteArrayUInt8"), LibraryBlob2.ToByteArrayUInt8 = ToByteArrayUInt8;
  function ToBlobFromByteArray(byteArray) {
    let bytes = new Uint8Array(byteArray.length);
    for (let i = 0; i < bytes.length; i++)
      bytes[i] = byteArray[i];
    return new Blob([bytes]);
  }
  __name(ToBlobFromByteArray, "ToBlobFromByteArray"), LibraryBlob2.ToBlobFromByteArray = ToBlobFromByteArray;
})(LibraryBlob || (LibraryBlob = {}));
var LibraryObject;
(function(LibraryObject2) {
  function isEmpty(obj, isStrict = !1) {
    return isStrict && typeof obj != "object" ? !1 : !(obj && Object.keys(obj).length > 0);
  }
  __name(isEmpty, "isEmpty"), LibraryObject2.isEmpty = isEmpty;
  function Clone(object) {
    let obj = object;
    if (typeof obj != "object" || obj === null || object instanceof File)
      return obj;
    if (obj instanceof LuffDate)
      return new LuffDate(obj.TotalMilliseconds);
    if (obj instanceof Date)
      return new Date(obj.getTime());
    if (obj instanceof Array)
      return obj.reduce((arr, item, i) => (arr[i] = Clone(item), arr), []);
    if (obj instanceof Object)
      return Object.getOwnPropertyNames(obj).reduce((newObj, key) => (newObj[key] = Clone(obj[key]), newObj), {});
  }
  __name(Clone, "Clone"), LibraryObject2.Clone = Clone;
  function Copy(ObjectCopyFrom, ObjectCopyTo) {
    let Keys = Object.getOwnPropertyNames(ObjectCopyFrom);
    for (let p in Keys)
      ObjectCopyFrom.hasOwnProperty(p) && (ObjectCopyTo[p] = ObjectCopyFrom[p]);
    return ObjectCopyTo;
  }
  __name(Copy, "Copy"), LibraryObject2.Copy = Copy;
  function GetProperty(Obj, Prop) {
    if (Prop === "")
      return Obj;
    let Way = Prop.replace(/\[([^\]]+)\]/g, ".$1");
    Way = Way.substring(0, 1) === "." ? Way.substring(1) : Way;
    let Ways = Way.split("."), i = 0, Dest = Obj;
    for (i; i < Way.length - 1; i++)
      Dest = Dest[Ways[i]];
    return Dest == null ? (console.warn(`[Luff.Object.GetProperty] Property '${Prop}' is unreachable`, Obj), null) : Dest[Ways[i]];
  }
  __name(GetProperty, "GetProperty"), LibraryObject2.GetProperty = GetProperty;
  function SetProperty(Obj, Prop, Value) {
    if (Prop === "")
      return Obj = Value, Obj;
    let Way = Prop.replace(/\[([^\]]+)\]/g, ".$1");
    Way = Way.substring(0, 1) === "." ? Way.substring(1) : Way;
    let Ways = Way.split("."), i = 0, Dest = Obj;
    for (i; i < Way.length - 1; i++)
      Dest = Dest[Ways[i]];
    return Dest[Ways[i]] = Value, Obj;
  }
  __name(SetProperty, "SetProperty"), LibraryObject2.SetProperty = SetProperty;
  function CheckDirty(Obj1, Obj2, isStrict = !0) {
    if (!Obj1 || !Obj2)
      return !1;
    let isEqual = !0;
    if (Obj1 instanceof Array) {
      if (isStrict && Obj1.length !== Obj2.length)
        return !1;
      for (let i = 0; i < Obj1.length; i++) {
        if (Obj1[i] instanceof Object) {
          if (isEqual = LibraryObject2.CheckDirty(Obj1[i], Obj2[i], isStrict), !isEqual)
            return !1;
          continue;
        }
        if (Obj1[i] !== Obj2[i])
          return !1;
      }
    } else if (Obj1 instanceof Object) {
      if (isStrict && Object.keys(Obj1).length !== Object.keys(Obj2).length)
        return !1;
      for (let i in Obj1) {
        if (Obj1[i] instanceof Object) {
          if (isEqual = LibraryObject2.CheckDirty(Obj1[i], Obj2[i], isStrict), !isEqual)
            return !1;
          continue;
        }
        if (Obj1[i] !== Obj2[i])
          return !1;
      }
    } else
      return Obj1 === Obj2;
    return isEqual;
  }
  __name(CheckDirty, "CheckDirty"), LibraryObject2.CheckDirty = CheckDirty;
})(LibraryObject || (LibraryObject = {}));
var LibraryString;
(function(LibraryString2) {
  const collator2 = new Intl.Collator("en", { numeric: !0, sensitivity: "base" }), _KeyBD = {
    En: [
      "q",
      "w",
      "e",
      "r",
      "t",
      "y",
      "u",
      "i",
      "o",
      "p",
      "[",
      "]",
      "a",
      "s",
      "d",
      "f",
      "g",
      "h",
      "j",
      "k",
      "l",
      ";",
      "'",
      "z",
      "x",
      "c",
      "v",
      "b",
      "n",
      "m",
      ",",
      ".",
      "/",
      "Q",
      "W",
      "E",
      "R",
      "T",
      "Y",
      "U",
      "I",
      "O",
      "P",
      "{",
      "}",
      "A",
      "S",
      "D",
      "F",
      "G",
      "H",
      "J",
      "K",
      "L",
      ":",
      '"',
      "|",
      "Z",
      "X",
      "C",
      "V",
      "B",
      "N",
      "M",
      "<",
      ">",
      "?"
    ],
    Ru: [
      "й",
      "ц",
      "у",
      "к",
      "е",
      "н",
      "г",
      "ш",
      "щ",
      "з",
      "х",
      "ъ",
      "ф",
      "ы",
      "в",
      "а",
      "п",
      "р",
      "о",
      "л",
      "д",
      "ж",
      "э",
      "я",
      "ч",
      "с",
      "м",
      "и",
      "т",
      "ь",
      "б",
      "ю",
      ".",
      "Й",
      "Ц",
      "У",
      "К",
      "Е",
      "Н",
      "Г",
      "Ш",
      "Щ",
      "З",
      "Х",
      "Ъ",
      "Ф",
      "Ы",
      "В",
      "А",
      "П",
      "Р",
      "О",
      "Л",
      "Д",
      "Ж",
      "Э",
      "/",
      "Я",
      "Ч",
      "С",
      "М",
      "И",
      "Т",
      "Ь",
      "Б",
      "Ю",
      ","
    ]
  };
  function Capitalize(string2) {
    return string2.charAt(0).toUpperCase() + string2.slice(1);
  }
  __name(Capitalize, "Capitalize"), LibraryString2.Capitalize = Capitalize;
  function Contains(string2, part, isIgnoreCase = !1) {
    return isIgnoreCase && string2.toLowerCase().indexOf(part.toLowerCase()) > -1 || string2.indexOf(part) > -1;
  }
  __name(Contains, "Contains"), LibraryString2.Contains = Contains;
  function QuoteScreen(string2, isHTML = !1) {
    return typeof string2 != "string" ? string2 : isHTML ? string2.replace(/"/g, "&quot;") : string2.replace(/"/g, '"');
  }
  __name(QuoteScreen, "QuoteScreen"), LibraryString2.QuoteScreen = QuoteScreen;
  function ReplaceAsync(string2, searchValue, callback) {
    string2 = String(string2);
    let parts = [], i = 0;
    if (Object.prototype.toString.call(searchValue) === "[object RegExp]") {
      const regex = searchValue;
      regex.global && (regex.lastIndex = i);
      let m;
      for (; m = regex.exec(string2); ) {
        let args = m.concat([m.index, m.input]);
        if (parts.push(string2.slice(i, m.index), callback.apply(null, args)), i = regex.lastIndex, !regex.global)
          break;
        m[0].length === 0 && regex.lastIndex++;
      }
    } else
      searchValue = String(searchValue), i = string2.indexOf(searchValue), parts.push(string2.slice(0, i), callback.apply(null, [searchValue, i, string2])), i += searchValue.length;
    return parts.push(string2.slice(i)), Promise.all(parts).then(function(strings) {
      return strings.join("");
    });
  }
  __name(ReplaceAsync, "ReplaceAsync"), LibraryString2.ReplaceAsync = ReplaceAsync;
  function KeyboardSwitch(string2, langFrom = "En", langTo = "Ru", isReverseSwitch = !0) {
    if (langFrom = Capitalize(langFrom), langTo = Capitalize(langTo), !string2)
      return "";
    let x = "";
    for (let i = 0; i < string2.length; i++) {
      let Index = _KeyBD[langFrom].indexOf(string2[i]);
      Index > -1 ? x += _KeyBD[langTo][Index] : Index < 0 && isReverseSwitch ? (Index = _KeyBD[langTo].indexOf(string2[i]), x += Index > -1 ? _KeyBD[langFrom][Index] : string2[i]) : Index < 0 && !isReverseSwitch && (x += string2[i]);
    }
    return x;
  }
  __name(KeyboardSwitch, "KeyboardSwitch"), LibraryString2.KeyboardSwitch = KeyboardSwitch;
  function Random(strLength, isRandomCase = !1) {
    let randomString = "";
    for (let i = 0; i < strLength; i++) {
      let number2 = LibraryNumber.GetRandom(35, 0), l = number2.toString(36);
      isRandomCase && number2 > 23 && (l = l.toUpperCase()), randomString += l;
    }
    return randomString;
  }
  __name(Random, "Random"), LibraryString2.Random = Random;
  function GetTextWidth(text2, fontname = "", fontsize = "") {
    return this.canvas === void 0 && (this.canvas = document.createElement("canvas"), this.canvasCtx = this.canvas.getContext("2d")), this.canvasCtx.font = fontsize + " " + fontname, this.canvasCtx.measureText(text2).width;
  }
  __name(GetTextWidth, "GetTextWidth"), LibraryString2.GetTextWidth = GetTextWidth;
  function IsTextIncludes(searchText, searchWhereText, isKeyBoardSwitch = !0) {
    const text2 = searchText.toLowerCase();
    if (isKeyBoardSwitch) {
      const textAlt = KeyboardSwitch(text2);
      return text2.length === 0 || searchWhereText.toLowerCase().includes(text2) || searchWhereText.toLowerCase().includes(textAlt);
    }
    return text2.length === 0 || searchWhereText.toLowerCase().includes(text2);
  }
  __name(IsTextIncludes, "IsTextIncludes"), LibraryString2.IsTextIncludes = IsTextIncludes;
  function SortPredicate(valueA, valueB) {
    return valueA && valueA.localeCompare ? collator2.compare(valueA, valueB) : valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
  }
  __name(SortPredicate, "SortPredicate"), LibraryString2.SortPredicate = SortPredicate;
  const _DummyTextGen = class _DummyTextGen {
    static pick(pool, avoid) {
      const n = pool.length;
      if (n === 0)
        return "";
      let w = pool[LibraryNumber.GetRandom(n - 1, 0)], guard = 0;
      for (; avoid !== null && w === avoid && guard++ < 24; )
        w = pool[LibraryNumber.GetRandom(n - 1, 0)];
      return w;
    }
    /** Простое смещение по роли внутри предложения: подлежащее → группа → глагол → дополнение → обстоятельство → связка */
    static pickWord(sentencePos, avoid) {
      const r = sentencePos % 6;
      return r === 0 ? _DummyTextGen.pick(LibraryNumber.GetRandom(100) < 52 ? _DummyTextGen.Adjectives : _DummyTextGen.Nouns, avoid) : r === 1 ? _DummyTextGen.pick(LibraryNumber.GetRandom(100) < 78 ? _DummyTextGen.Nouns : _DummyTextGen.Adjectives, avoid) : r === 2 ? _DummyTextGen.pick(_DummyTextGen.Verbs, avoid) : r === 3 ? _DummyTextGen.pick(_DummyTextGen.Nouns, avoid) : r === 4 ? _DummyTextGen.pick(LibraryNumber.GetRandom(100) < 55 ? _DummyTextGen.Adverbs : _DummyTextGen.Nouns, avoid) : _DummyTextGen.pick(_DummyTextGen.Glue, avoid);
    }
    static Generate(length) {
      if (length <= 0)
        return "";
      const minWords = 6, maxWords = 14, parts = [];
      let sentencePos = 0, prev = null;
      for (let i = 0; i < length; i++) {
        let w = _DummyTextGen.pickWord(sentencePos, prev);
        sentencePos === 0 && (w = Capitalize(w)), parts.push(w), prev = w, sentencePos++;
        const canBreak = length - i - 1 > 0 && sentencePos >= minWords, mustBreak = sentencePos >= maxWords, randomBreak = canBreak && !mustBreak && LibraryNumber.GetRandom(100) > 67;
        if (mustBreak || randomBreak) {
          const last = parts[parts.length - 1];
          parts[parts.length - 1] = last.replace(/[.,]$/, "") + ".", sentencePos = 0, prev = null;
        }
      }
      let text2 = parts.join(" ");
      return /\.\s*$/.test(text2) || (text2 = text2.replace(/[.,]$/, "") + "."), text2;
    }
  };
  __name(_DummyTextGen, "DummyTextGen");
  let DummyTextGen = _DummyTextGen;
  DummyTextGen.Nouns = [
    "система",
    "модуль",
    "проект",
    "сервис",
    "интерфейс",
    "пользователь",
    "документ",
    "данные",
    "таблица",
    "форма",
    "список",
    "окно",
    "панель",
    "отчёт",
    "задача",
    "версия",
    "файл",
    "запись",
    "параметр",
    "результат",
    "сообщение",
    "ошибка",
    "команда",
    "приложение",
    "библиотека",
    "компонент",
    "виджет",
    "контейнер",
    "ресурс",
    "процесс",
    "поток",
    "сессия",
    "транзакция",
    "метод",
    "класс",
    "объект",
    "структура",
    "модель",
    "элемент",
    "строка",
    "столбец",
    "ячейка",
    "значение",
    "ключ",
    "токен",
    "запрос",
    "ответ",
    "страница",
    "раздел",
    "разметка",
    "шаблон",
    "стиль",
    "тема",
    "стек",
    "очередь",
    "кластер",
    "узел",
    "сервер",
    "клиент",
    "шлюз",
    "канал",
    "пакет",
    "фреймворк",
    "архитектура",
    "слой",
    "схема",
    "политика",
    "роль",
    "профиль",
    "база данных",
    "индекс",
    "кеш",
    "буфер",
    "лог",
    "архив",
    "резервная копия",
    "сборка",
    "релиз",
    "патч",
    "коммит",
    "ветка",
    "фича",
    "багфикс",
    "тест-кейс",
    "ребёнок",
    "родитель",
    "наследник",
    "корень",
    "лист",
    "вершина",
    "граф",
    "секция",
    "вкладка",
    "меню",
    "кнопка",
    "иконка",
    "подсказка",
    "уведомление",
    "подписка",
    "права",
    "группа",
    "организация",
    "отдел",
    "процедура",
    "скрипт",
    "хук",
    "плагин",
    "расширение",
    "модификатор",
    "флаг",
    "бит",
    "байт",
    "хэш",
    "человек",
    "семья",
    "друг",
    "сосед",
    "гость",
    "коллега",
    "начальник",
    "учитель",
    "день",
    "ночь",
    "утро",
    "вечер",
    "время",
    "минута",
    "час",
    "неделя",
    "месяц",
    "год",
    "весна",
    "лето",
    "осень",
    "зима",
    "погода",
    "солнце",
    "дождь",
    "снег",
    "ветер",
    "небо",
    "море",
    "река",
    "озеро",
    "лес",
    "поле",
    "гора",
    "пляж",
    "парк",
    "сад",
    "улица",
    "город",
    "деревня",
    "дом",
    "квартира",
    "комната",
    "кухня",
    "двор",
    "лестница",
    "дорога",
    "мост",
    "остановка",
    "площадь",
    "рынок",
    "магазин",
    "кафе",
    "ресторан",
    "работа",
    "отдых",
    "каникулы",
    "праздник",
    "вечеринка",
    "свадьба",
    "родители",
    "детство",
    "мечта",
    "мысль",
    "чувство",
    "голос",
    "тишина",
    "музыка",
    "песня",
    "танец",
    "книга",
    "рассказ",
    "стих",
    "театр",
    "кино",
    "картина",
    "фото",
    "цветок",
    "дерево",
    "трава",
    "камень",
    "песок",
    "огонь",
    "вода",
    "еда",
    "хлеб",
    "суп",
    "чай",
    "кофе",
    "собака",
    "кошка",
    "птица",
    "рыба",
    "лошадь",
    "корова",
    "заяц",
    "медведь",
    "одежда",
    "платье",
    "пальто",
    "обувь",
    "шапка",
    "сумка",
    "кошелёк",
    "деньги",
    "игрушка",
    "мяч",
    "коньки",
    "лыжи",
    "велосипед",
    "машина",
    "автобус",
    "трамвай"
  ], DummyTextGen.Verbs = [
    "работает",
    "создаёт",
    "отображает",
    "сохраняет",
    "обновляет",
    "получает",
    "отправляет",
    "проверяет",
    "фильтрует",
    "сортирует",
    "удаляет",
    "импортирует",
    "экспортирует",
    "настраивает",
    "загружает",
    "выгружает",
    "обрабатывает",
    "кэширует",
    "выполняет",
    "запускает",
    "останавливает",
    "перезапускает",
    "блокирует",
    "разблокирует",
    "соединяет",
    "разъединяет",
    "слушает",
    "ожидает",
    "повторяет",
    "пропускает",
    "отменяет",
    "подключается",
    "отключается",
    "авторизуется",
    "регистрируется",
    "логирует",
    "сериализует",
    "десериализует",
    "парсит",
    "валидирует",
    "инициализирует",
    "закрывает",
    "открывает",
    "расшифровывает",
    "шифрует",
    "подписывает",
    "верифицирует",
    "строит",
    "вычисляет",
    "пересчитывает",
    "копирует",
    "вырезает",
    "вставляет",
    "заменяет",
    "склеивает",
    "делит",
    "группирует",
    "распределяет",
    "балансирует",
    "масштабируется",
    "сжимается",
    "распаковывается",
    "архивирует",
    "восстанавливается",
    "мигрирует",
    "переименовывает",
    "перемещает",
    "назначает",
    "снимает",
    "повышает",
    "ограничивает",
    "агрегирует",
    "нормализует",
    "сопоставляет",
    "сводит",
    "разворачивает",
    "сворачивает",
    "мониторит",
    "профилирует",
    "сэмплирует",
    "трассирует",
    "отлаживается",
    "переключается",
    "живёт",
    "идёт",
    "бежит",
    "сидит",
    "лежит",
    "спит",
    "ест",
    "пьёт",
    "готовит",
    "моет",
    "видит",
    "слышит",
    "чувствует",
    "думает",
    "грезит",
    "верит",
    "сомневается",
    "надеется",
    "забывает",
    "помнит",
    "молчит",
    "говорит",
    "шепчет",
    "кричит",
    "смеётся",
    "плачет",
    "любит",
    "обижается",
    "прощает",
    "ждёт",
    "торопится",
    "опаздывает",
    "возвращается",
    "уезжает",
    "приезжает",
    "приходит",
    "уходит",
    "заходит",
    "выходит",
    "жарит",
    "варит",
    "печёт",
    "режет",
    "мешает",
    "помогает",
    "учит",
    "учится",
    "читает",
    "пишет",
    "рисует",
    "поёт",
    "танцует",
    "играет",
    "гуляет",
    "ловит",
    "бросает",
    "берёт",
    "дарит",
    "просит",
    "благодарит",
    "хвалит",
    "ругает",
    "спорит",
    "соглашается",
    "покупает",
    "продаёт",
    "торгуется",
    "платит",
    "считает",
    "мечтает",
    "будит",
    "засыпает",
    "зевает",
    "тянется",
    "заряжается",
    "разряжается"
  ], DummyTextGen.Adjectives = [
    "новый",
    "быстрый",
    "удобный",
    "важный",
    "полный",
    "текущий",
    "выбранный",
    "доступный",
    "основной",
    "корректный",
    "стабильный",
    "гибкий",
    "простой",
    "надёжный",
    "актуальный",
    "внешний",
    "внутренний",
    "локальный",
    "общий",
    "урезанный",
    "расширенный",
    "унаследованный",
    "виртуальный",
    "эффективный",
    "безопасный",
    "уязвимый",
    "закрытый",
    "открытый",
    "пустой",
    "ненулевой",
    "единственный",
    "множественный",
    "параллельный",
    "последовательный",
    "синхронный",
    "асинхронный",
    "активный",
    "пассивный",
    "включённый",
    "выключенный",
    "явный",
    "неявный",
    "публичный",
    "приватный",
    "временный",
    "постоянный",
    "критический",
    "низкий",
    "высокий",
    "оптимальный",
    "минимальный",
    "максимальный",
    "средний",
    "ранний",
    "поздний",
    "угловой",
    "типовой",
    "кастомный",
    "совместимый",
    "обратимый",
    "необратимый",
    "повторный",
    "первый",
    "следующий",
    "прикладной",
    "служебный",
    "боевой",
    "тестовый",
    "заготовленный",
    "разрешённый",
    "запрещённый",
    "устаревший",
    "экспериментальный",
    "предварительный",
    "финальный",
    "тёплый",
    "холодный",
    "светлый",
    "тёмный",
    "мягкий",
    "жёсткий",
    "густой",
    "редкий",
    "большой",
    "маленький",
    "длинный",
    "короткий",
    "широкий",
    "узкий",
    "тонкий",
    "красивый",
    "милый",
    "забавный",
    "грустный",
    "весёлый",
    "злой",
    "добрый",
    "ласковый",
    "строгий",
    "спокойный",
    "нервный",
    "сонный",
    "бодрый",
    "голодный",
    "сытый",
    "жадный",
    "щедрый",
    "честный",
    "хитрый",
    "глупый",
    "умный",
    "смелый",
    "трусливый",
    "сильный",
    "слабый",
    "здоровый",
    "больной",
    "усталый",
    "свежий",
    "вялый",
    "молодой",
    "старый",
    "чистый",
    "грязный",
    "ровный",
    "кривой",
    "гладкий",
    "шероховатый",
    "мокрый",
    "сухой",
    "праздничный",
    "будничный",
    "домашний",
    "уличный",
    "звонкий",
    "глухой"
  ], DummyTextGen.Adverbs = [
    "быстро",
    "корректно",
    "постепенно",
    "автоматически",
    "регулярно",
    "параллельно",
    "последовательно",
    "немедленно",
    "частично",
    "полностью",
    "визуально",
    "логически",
    "тихо",
    "громко",
    "строго",
    "мягко",
    "грубо",
    "аккуратно",
    "приблизительно",
    "точно",
    "грубо говоря",
    "по факту",
    "иногда",
    "часто",
    "редко",
    "всегда",
    "никогда",
    "вдруг",
    "вновь",
    "снова",
    "заранее",
    "затем",
    "далее",
    "впоследствии",
    "одновременно",
    "независимо",
    "явно",
    "неявно",
    "косвенно",
    "напрямую",
    "локально",
    "удалённо",
    "бесшовно",
    "прозрачно",
    "надёжно",
    "стабильно",
    "динамически",
    "статически",
    "оперативно",
    "раньше",
    "позже",
    "сразу",
    "вовремя",
    "вчера",
    "сегодня",
    "завтра",
    "теперь",
    "потом",
    "здесь",
    "там",
    "везде",
    "редко где",
    "очень",
    "чуть",
    "едва",
    "весьма",
    "слишком",
    "вдосталь",
    "дома",
    "вполголоса",
    "охотно",
    "неохотно",
    "радостно",
    "горько",
    "мило",
    "вежливо",
    "нетерпеливо",
    "без умолку",
    "вслух",
    "про себя",
    "случайно",
    "нарочно",
    "еле",
    "ровно"
  ], DummyTextGen.Glue = [
    "и",
    "или",
    "в",
    "на",
    "для",
    "при",
    "с",
    "без",
    "к",
    "ко",
    "о",
    "об",
    "у",
    "из",
    "под",
    "над",
    "перед",
    "через",
    "вокруг",
    "внутри",
    "вне",
    "около",
    "после",
    "до",
    "вместо",
    "вопреки",
    "вследствие",
    "благодаря",
    "согласно",
    "между",
    "среди",
    "вроде",
    "как",
    "чем",
    "хотя",
    "пускай",
    "ежели",
    "также",
    "тоже",
    "уже",
    "ещё",
    "не",
    "ни",
    "только",
    "лишь",
    "даже",
    "всё же",
    "если",
    "когда",
    "пока",
    "раз",
    "чтобы",
    "дабы",
    "однако",
    "зато",
    "кстати",
    "поэтому",
    "иначе",
    "итак",
    "впрочем",
    "между тем",
    "тем не менее",
    "в частности",
    "будто",
    "словно",
    "например",
    "скажем",
    "типа",
    "дескать",
    "мол",
    "вестимо",
    "подобно"
  ], LibraryString2.DummyTextGen = DummyTextGen;
})(LibraryString || (LibraryString = {}));
var LibraryCSS;
(function(LibraryCSS) {
  function GetStylesBySelector(query) {
    for (let i = 0; i < document.styleSheets.length; i++) {
      let Sheet = document.styleSheets[i];
      if (document.styleSheets[i].href) {
        let rules;
        if (Sheet.rules ? rules = Sheet.rules : Sheet.cssRules && (rules = Sheet.cssRules), !rules)
          continue;
        for (let j = 0; j < rules.length; j++) {
          let Rule = rules[j];
          if (Rule.selectorText === query)
            return Rule.style;
        }
      }
    }
    return null;
  }
  __name(GetStylesBySelector, "GetStylesBySelector"), LibraryCSS.GetStylesBySelector = GetStylesBySelector;
  function GetDurationAnimation(CSSAnimation, HTMLElement = null) {
    let isNull = !1;
    HTMLElement || (isNull = !0, HTMLElement = document.createElement("div"), document.body.appendChild(HTMLElement)), CSSAnimation && HTMLElement.classList.add(CSSAnimation);
    let Style = window.getComputedStyle(HTMLElement), Duration = eval(Style.transitionDuration.replace("ms", "*1").replace("s", "*1000")), DurationAnim = eval(Style.animationDuration.replace("ms", "*1").replace("s", "*1000"));
    return Duration < DurationAnim && (Duration = DurationAnim), CSSAnimation && HTMLElement.classList.remove(CSSAnimation), isNull && HTMLElement.remove(), Duration;
  }
  __name(GetDurationAnimation, "GetDurationAnimation"), LibraryCSS.GetDurationAnimation = GetDurationAnimation;
})(LibraryCSS || (LibraryCSS = {}));
function _IsVisible(element) {
  let Style2 = window.getComputedStyle(element), isVisible = Style2.display !== "none" && Style2.visibility !== "hidden" && parseFloat(Style2.opacity) !== 0 && parseFloat(Style2.height) + parseFloat(Style2.minHeight) !== 0 && parseFloat(Style2.width) + parseFloat(Style2.minWidth) !== 0;
  if (Style2.position !== "fixed" || !isVisible)
    return isVisible;
  let rect = element.getBoundingClientRect();
  return rect.left + rect.width > 0 && rect.left < document.body.clientWidth && rect.top + rect.height > 0 && rect.top < document.body.clientHeight;
}
__name(_IsVisible, "_IsVisible");
const _ClonedEvent = class _ClonedEvent {
};
__name(_ClonedEvent, "ClonedEvent");
let ClonedEvent = _ClonedEvent;
var LibraryDOM;
(function(LibraryDOM2) {
  LibraryDOM2.GetDurationAnimation = LibraryCSS.GetDurationAnimation;
  function Select2(query, parent = document) {
    return query === "" || query === null ? null : query instanceof Node ? query : parent.querySelector(query);
  }
  __name(Select2, "Select"), LibraryDOM2.Select = Select2;
  function SelectAll(query, parent = document) {
    if (typeof query === void 0)
      return [];
    if (typeof query.tagName < "u" || query === document)
      return [query];
    let nodes = parent.querySelectorAll(query);
    return Array.from(nodes);
  }
  __name(SelectAll, "SelectAll"), LibraryDOM2.SelectAll = SelectAll;
  function IsQuery(element, query) {
    if (!element || element === document)
      return !1;
    let Elem = element.cloneNode();
    const Tag = Elem.tagName.toLowerCase();
    let TagParent = "div";
    ["tr, th"].indexOf(Tag) > -1 ? TagParent = "tr" : Tag === "tr" ? TagParent = "tbody" : ["tbody, thead"].indexOf(Tag) > -1 && (TagParent = "table");
    const p = document.createElement(TagParent);
    return p.appendChild(Elem), LibraryDOM2.Select(query, p) !== null;
  }
  __name(IsQuery, "IsQuery"), LibraryDOM2.IsQuery = IsQuery;
  function IsElement(obj) {
    return typeof obj == "object" && obj.nodeType === 1 && typeof obj.style == "object" && typeof obj.ownerDocument == "object";
  }
  __name(IsElement, "IsElement"), LibraryDOM2.IsElement = IsElement;
  function ShowWithAnimation(element, cssAnimation) {
    let Duration2 = LibraryDOM2.GetDurationAnimation(cssAnimation, element);
    element.style.display = "", element.classList.add(cssAnimation), setTimeout(function() {
      element.classList.remove(cssAnimation);
    }, Duration2);
  }
  __name(ShowWithAnimation, "ShowWithAnimation"), LibraryDOM2.ShowWithAnimation = ShowWithAnimation;
  function HideWithAnimation(element, cssAnimation) {
    let Duration2 = LibraryDOM2.GetDurationAnimation(cssAnimation, element);
    element.classList.add(cssAnimation), setTimeout(function() {
      element.style.display = "none", element.classList.remove(cssAnimation);
    }, Duration2);
  }
  __name(HideWithAnimation, "HideWithAnimation"), LibraryDOM2.HideWithAnimation = HideWithAnimation;
  function GetLineID(element) {
    return parseInt(element.dataset.line);
  }
  __name(GetLineID, "GetLineID"), LibraryDOM2.GetLineID = GetLineID;
  function Print(element, CSSPrint = "") {
    let printWindow = window.open("", "PRINT"), styles = "";
    for (let i = 0; i < document.styleSheets.length; i++) {
      let Sheet = document.styleSheets[i];
      if (Sheet.href) {
        let rules;
        if (Sheet.rules ? rules = Sheet.rules : Sheet.cssRules && (rules = Sheet.cssRules), !rules)
          continue;
        for (let j = 0; j < rules.length; j++)
          rules[j].cssText.indexOf("@") < 0 && (styles += rules[j].cssText);
      }
    }
    styles = `@media print{
                        ${styles}
                        .button-print{display:none!important}
                        ${CSSPrint}
                    }
                    @media screen{
                        ${styles}
                        .button-print{display:none!important}
                        ${CSSPrint}
                    }`, element.querySelectorAll("input").forEach((inp) => {
      inp.setAttribute("value", inp.value), inp.checked ? inp.setAttribute("checked", "checked") : inp.removeAttribute("checked");
    }), printWindow.document.write("<html><head><title>" + document.title + "</title>"), printWindow.document.write(`<style>${styles}</style>`), printWindow.document.write("</head><body>"), printWindow.document.write(element.outerHTML), printWindow.document.write("</body></html>"), printWindow.document.close(), printWindow.focus(), printWindow.print(), printWindow.close();
  }
  __name(Print, "Print"), LibraryDOM2.Print = Print;
  function Swap(element1, element2) {
    const t = element1.parentNode.insertBefore(document.createTextNode(""), element1);
    element2.parentNode.insertBefore(element1, element2), t.parentNode.insertBefore(element2, t), t.parentNode.removeChild(t);
  }
  __name(Swap, "Swap"), LibraryDOM2.Swap = Swap;
  function CreateElementFromString(htmlString, parentElementTagName = "div") {
    let frag = document.createDocumentFragment(), elem = document.createElement(parentElementTagName);
    for (elem.innerHTML = htmlString; elem.childNodes[0]; )
      frag.appendChild(elem.childNodes[0]);
    return Array.from(frag.childNodes).find((x) => x.nodeName.indexOf("text") < 0);
  }
  __name(CreateElementFromString, "CreateElementFromString"), LibraryDOM2.CreateElementFromString = CreateElementFromString;
  function InsertAfter(element, referenceNode) {
    referenceNode.parentNode.insertBefore(element, referenceNode.nextSibling);
  }
  __name(InsertAfter, "InsertAfter"), LibraryDOM2.InsertAfter = InsertAfter;
  function CreateElementsFromString(htmlString, parentElementTagName = "div") {
    let frag = document.createDocumentFragment(), elem = document.createElement(parentElementTagName);
    for (elem.innerHTML = htmlString; elem.childNodes[0]; )
      frag.appendChild(elem.childNodes[0]);
    if (frag.childNodes.length > 0) {
      let nodes = [];
      for (let i = 0; i < frag.childNodes.length; i++)
        nodes.push(frag.childNodes[i]);
      return nodes.filter((x) => x.nodeName.indexOf("text") < 0);
    }
    return null;
  }
  __name(CreateElementsFromString, "CreateElementsFromString"), LibraryDOM2.CreateElementsFromString = CreateElementsFromString;
  function IsDescendant(childElement, ancestor) {
    if (childElement.isSameNode(ancestor))
      return !0;
    let ParentCursor = childElement;
    for (; ParentCursor; ) {
      if (ParentCursor.isSameNode(ancestor))
        return !0;
      ParentCursor = ParentCursor.parentElement;
    }
    return !1;
  }
  __name(IsDescendant, "IsDescendant"), LibraryDOM2.IsDescendant = IsDescendant;
  function IsVisible(htmlElement) {
    let isVisible = _IsVisible(htmlElement);
    if (isVisible)
      for (; htmlElement.parentElement; ) {
        if (!_IsVisible(htmlElement))
          return !1;
        htmlElement = htmlElement.parentElement;
      }
    return isVisible;
  }
  __name(IsVisible, "IsVisible"), LibraryDOM2.IsVisible = IsVisible;
  function Closest(element, query) {
    let ElementCursor = element;
    for (; ElementCursor; ) {
      if (LibraryDOM2.IsQuery(ElementCursor, query))
        return ElementCursor;
      ElementCursor = ElementCursor.parentElement;
    }
    return null;
  }
  __name(Closest, "Closest"), LibraryDOM2.Closest = Closest;
  function EventClone(e) {
    let clone = new ClonedEvent();
    for (let p in e) {
      let d = Object.getOwnPropertyDescriptor(e, p);
      d && (!d.writable || !d.configurable || !d.enumerable || d.get || d.set) ? Object.defineProperty(clone, p, d) : clone[p] = e[p];
    }
    return Object.setPrototypeOf(clone, e), clone;
  }
  __name(EventClone, "EventClone"), LibraryDOM2.EventClone = EventClone;
  function AddEventListenerGlobal(eventName, selector, handler, parent = document, thisArg) {
    parent.addEventListener(eventName, function(e) {
      let target = e.target, isIt = !1, event = EventClone(e), elems = parent.querySelectorAll(selector);
      if (elems[0] === target && (event.currentTarget = target, isIt = !0), !isIt) {
        for (let i = 0; i < elems.length; i++)
          if (elems[i].contains(target)) {
            isIt = !0, event.currentTarget = target.closest(selector);
            break;
          }
      }
      if (event.target.classList.contains("l-edit-editor") && eventName === "click") {
        e.stopPropagation();
        return;
      }
      if (isIt) {
        let p = {
          ID: null,
          LineID: null
        }, ID = event.currentTarget.dataset.id, LineID = event.currentTarget.dataset.line;
        if (ID && (p.ID = parseInt(ID)), LineID)
          p.LineID = parseInt(LineID);
        else {
          let TemplatorLine = event.currentTarget.closest(".l-t-line");
          TemplatorLine && (p.LineID = parseInt(TemplatorLine.dataset.line));
        }
        handler.call(thisArg || event.currentTarget, event, p);
      }
    });
  }
  __name(AddEventListenerGlobal, "AddEventListenerGlobal"), LibraryDOM2.AddEventListenerGlobal = AddEventListenerGlobal;
  function AsyncToggle(thisArg, eventArg, targetElement, before, after, cssBefore, cssAnimate, duration, timeout) {
    return timeout && clearTimeout(timeout), before.call(thisArg, eventArg), cssBefore && targetElement.classList.remove(cssBefore), cssBefore === cssAnimate ? (cssAnimate && targetElement.classList.add(cssAnimate), timeout = setTimeout(() => {
      after.call(thisArg, eventArg);
    }, duration), timeout) : (cssAnimate && targetElement.classList.add(cssAnimate), timeout = setTimeout(() => {
      after.call(thisArg, eventArg);
    }, duration), timeout);
  }
  __name(AsyncToggle, "AsyncToggle"), LibraryDOM2.AsyncToggle = AsyncToggle;
  function GetGlobalElementPositionOverAnother(elementToPosition, elementOver, margin = { x: 0, y: 0 }) {
    const rectOver = elementOver.getBoundingClientRect(), rectPosition = elementToPosition.getBoundingClientRect(), rectBody = document.body.getBoundingClientRect();
    let x = 0, xDir = "left", y = 0, yDir = "top";
    return rectOver.x + rectOver.width + margin.x + rectPosition.width <= rectBody.width ? (x = rectOver.x + rectOver.width + margin.x, xDir = "left") : (x = rectOver.x - margin.x - rectPosition.width, xDir = "right"), rectOver.y + rectOver.height + margin.y + rectPosition.height <= rectBody.height - 50 ? (y = rectOver.y + rectOver.height + margin.y, yDir = "top") : (y = rectOver.y - margin.y - rectPosition.height, yDir = "bottom"), {
      x,
      y,
      direction: `${xDir}-${yDir}`
    };
  }
  __name(GetGlobalElementPositionOverAnother, "GetGlobalElementPositionOverAnother"), LibraryDOM2.GetGlobalElementPositionOverAnother = GetGlobalElementPositionOverAnother;
  function GetGlobalElementPositionByCoords(elementToPosition, pos) {
    const rectHint = elementToPosition.getBoundingClientRect(), rectBody = document.body.getBoundingClientRect();
    let xDir = "left", yDir = "top";
    return pos.x + rectHint.width > rectBody.width && (pos.x = pos.x - rectHint.width, xDir = "right"), pos.y + rectHint.height > rectBody.height && (pos.y = pos.y - rectHint.height, yDir = "bottom"), Object.assign(Object.assign({}, pos), { direction: `${xDir}-${yDir}` });
  }
  __name(GetGlobalElementPositionByCoords, "GetGlobalElementPositionByCoords"), LibraryDOM2.GetGlobalElementPositionByCoords = GetGlobalElementPositionByCoords;
  function _GetPos(direction, relRect, thisRect, MARGIN_X, MARGIN_Y) {
    let PosX = 0, PosY = 0;
    return direction === "below-righter" ? (PosX += relRect.x + relRect.width + MARGIN_X, PosY += relRect.y + relRect.height + MARGIN_Y) : direction === "below-lefter" ? (PosX += relRect.x - thisRect.width - MARGIN_X, PosY += relRect.y + relRect.height + MARGIN_Y) : direction === "upper-righter" ? (PosX += relRect.x + relRect.width + MARGIN_X, PosY += relRect.y - thisRect.height - MARGIN_Y) : direction === "upper-lefter" && (PosX += relRect.x - thisRect.width - MARGIN_X, PosY += relRect.y - thisRect.height - MARGIN_Y), {
      x: PosX,
      y: PosY
    };
  }
  __name(_GetPos, "_GetPos");
  function GetPopPosition({
    thisElement,
    relativeElement,
    //container,
    MARGIN_X,
    MARGIN_Y
  }) {
    let thisRect = thisElement.getBoundingClientRect(), relRect = relativeElement.getBoundingClientRect(), h = window.innerHeight, w = window.innerWidth, directions = ["below", "righter"];
    relRect.y + relRect.height + thisRect.height > h && (directions[0] = "upper"), relRect.x + relRect.width + thisRect.width > w && (directions[1] = "lefter");
    let direction = directions.join("-");
    return Object.assign(Object.assign({}, _GetPos(direction, relRect, thisRect, MARGIN_X, MARGIN_Y)), { direction });
  }
  __name(GetPopPosition, "GetPopPosition"), LibraryDOM2.GetPopPosition = GetPopPosition;
})(LibraryDOM || (LibraryDOM = {}));
var DelegateType;
(function(DelegateType2) {
  DelegateType2[DelegateType2.Select = 0] = "Select", DelegateType2[DelegateType2.Where = 1] = "Where", DelegateType2[DelegateType2.ToDictionary = 2] = "ToDictionary", DelegateType2[DelegateType2.SelectMany = 3] = "SelectMany", DelegateType2[DelegateType2.Order = 4] = "Order";
})(DelegateType || (DelegateType = {}));
function defaultComparer(a, b) {
  if (a > b)
    return 1;
  if (a < b)
    return -1;
  if (a === b)
    return 0;
}
__name(defaultComparer, "defaultComparer");
function rowGetterInner(item) {
  return {
    IsPassed: !0,
    IsMany: !1,
    Value: item
  };
}
__name(rowGetterInner, "rowGetterInner");
const _LuffLinq = class _LuffLinq {
  Select(selector) {
    return this._CallList.push({ Type: DelegateType.Select, Delegate: selector }), this;
  }
  SelectMany(selector) {
    return this._CallList.push({ Type: DelegateType.SelectMany, Delegate: selector }), this;
  }
  Where(predicate) {
    return this._CallList.push({ Type: DelegateType.Where, Delegate: predicate }), this;
  }
  ToDictionary(selectorKey, selectorValue) {
    selectorValue || (selectorValue = /* @__PURE__ */ __name((val) => val, "selectorValue"));
    let ar = this.ToList(), dict = {};
    for (let i = 0; i < ar.length; i++)
      dict[selectorKey(ar[i], i)] = selectorValue(ar[i], i);
    return dict;
  }
  ToLookUp(keySelector) {
    let lookHash = {}, ar = this.ToList();
    for (let item of ar) {
      const key = keySelector(item);
      key != null && (lookHash[key] ? lookHash[key].push(item) : lookHash[key] = [item]);
    }
    return lookHash;
  }
  Contains(item) {
    let getter = this._GetRowGetter(this._CallList);
    for (let i = 0; i < this._Data.length; i++) {
      let val = getter(this._Data[i]);
      if (val.IsPassed) {
        if (!val.IsMany && val.Value === item)
          return !0;
        if (val.IsMany) {
          for (let k = 0; k < val.Value.length; k++)
            if (val.Value[k] === item)
              return !0;
        }
      }
    }
    return !1;
  }
  GroupBy(keyGetter) {
    let items = this.ToList();
    const groups = [];
    for (let item of items) {
      let key = keyGetter(item), group;
      for (let g of groups)
        if (LibraryObject.CheckDirty(g.Key, key)) {
          group = g;
          break;
        }
      group || (group = [], group.Key = key, groups.push(group)), group.push(item);
    }
    return this._Data = groups, this;
  }
  OrderBy(keyGetter, comparer = defaultComparer) {
    return this._HasOrder = !0, this._CallList.push({ Type: DelegateType.Order, Delegate: /* @__PURE__ */ __name(function(item1, item2) {
      return comparer(keyGetter(item1), keyGetter(item2));
    }, "Delegate") }), this;
  }
  OrderByDescending(keyGetter, comparer = defaultComparer) {
    return this._HasOrder = !0, this._CallList.push({ Type: DelegateType.Order, Delegate: /* @__PURE__ */ __name(function(item1, item2) {
      return comparer(keyGetter(item2), keyGetter(item1));
    }, "Delegate") }), this;
  }
  AsEnumerable() {
    return this._Data = this.ToList(), this._HasOrder = !1, this._CallList = [], this;
  }
  static rowGetterInner(item) {
    return {
      IsPassed: !0,
      IsMany: !1,
      Value: item
    };
  }
  _QuickSortFilter(data, rowGetter, sorter) {
    if (data.length < 2 || !rowGetter && !sorter)
      return data;
    const pivotKey = Math.floor(data.length / 2), pivotValue = rowGetter(data[pivotKey]).Value;
    let left = [], right = [], equal = [];
    for (let i = 0; i < data.length; i++) {
      let item = data[i], valueItem = rowGetter(item);
      valueItem.IsPassed && (sorter && sorter(valueItem.Value, pivotValue) < 0 ? left.push(valueItem.Value) : sorter && sorter(valueItem.Value, pivotValue) > 0 ? right.push(valueItem.Value) : equal.push(valueItem.Value));
    }
    return this._QuickSortFilter(left, rowGetterInner, sorter).concat(equal, this._QuickSortFilter(right, rowGetterInner, sorter));
  }
  _GetRowGetter(cbX) {
    return /* @__PURE__ */ __name(function(item) {
      let itemResult = item, isPassed = !0, isMany = !1;
      for (let c = 0; c < cbX.length; c++) {
        let cb = cbX[c];
        if (cb.Type == DelegateType.Where) {
          const isItemArray = Array.isArray(itemResult);
          let where = cb.Delegate;
          if (!isItemArray)
            isPassed = where(itemResult);
          else {
            let subResult = [];
            for (let sumItem of itemResult)
              where(sumItem) && subResult.push(sumItem);
            itemResult = subResult;
          }
        } else if (cb.Type == DelegateType.Select || cb.Type == DelegateType.SelectMany) {
          let select = cb.Delegate;
          itemResult = select(itemResult), isMany = cb.Type == DelegateType.SelectMany;
        }
      }
      return {
        IsPassed: isPassed,
        Value: itemResult,
        IsMany: isMany
      };
    }, "getDataa");
  }
  _GetData(data, cbX, hasMany, sorter) {
    let rowGetter = this._GetRowGetter(cbX), resultArr;
    if (!hasMany && sorter)
      resultArr = this._QuickSortFilter(this._Data, rowGetter, sorter);
    else {
      let dataProcess = [];
      for (let r = 0; r < data.length; r++) {
        let rowPack = rowGetter(data[r]);
        rowPack.IsPassed && (rowPack.IsMany ? dataProcess.push(...rowPack.Value) : dataProcess.push(rowPack.Value));
      }
      resultArr = dataProcess, sorter && (resultArr = resultArr.sort(sorter));
    }
    return resultArr;
  }
  _GetFirst(isReverseDirection) {
    let getter = this._GetRowGetter(this._CallList), i = 0, cond = /* @__PURE__ */ __name(() => i < this._Data.length, "cond"), indexChanger = /* @__PURE__ */ __name(() => i++, "indexChanger"), isGo = !0;
    for (isReverseDirection && (i = this._Data.length - 1, cond = /* @__PURE__ */ __name(() => i >= 0, "cond"), indexChanger = /* @__PURE__ */ __name(() => i--, "indexChanger")); isGo; ) {
      let pack = getter(this._Data[i]);
      if (pack.IsPassed)
        return pack.IsMany ? pack.Value.length > 0 ? isReverseDirection ? pack.Value[pack.Value.length - 1] : pack.Value[0] : null : pack.Value;
      indexChanger(), isGo = cond();
    }
    return null;
  }
  ToList() {
    if (this._CallList.length < 1)
      return this._Data;
    let resultArr = this._Data, cbX = [], data = this._Data, hasMany = !1;
    for (let i = 0; i < this._CallList.length; i++) {
      let cb = this._CallList[i];
      cb.Type == DelegateType.Where || cb.Type == DelegateType.Select ? cbX.push(cb) : cb.Type == DelegateType.SelectMany ? (cbX.push(cb), hasMany = !0) : cb.Type == DelegateType.Order && (resultArr = this._GetData(data, cbX, hasMany, cb.Delegate), cbX = [], hasMany = !1);
    }
    return cbX.length > 0 && (resultArr = this._GetData(resultArr, cbX, hasMany, null)), resultArr;
  }
  FirstOrDefault() {
    return this._Data.length == 0 ? null : this._HasOrder ? this.ToList()[0] : this._GetFirst(!1);
  }
  LastOrDefault() {
    if (this._Data.length == 0)
      return null;
    if (!this._HasOrder)
      return this._GetFirst(!0);
    let res = this.ToList();
    return res[res.length - 1];
  }
  constructor(array) {
    this._CallList = [], this._HasOrder = !1, this._Data = array;
  }
};
__name(_LuffLinq, "LuffLinq");
let LuffLinq = _LuffLinq;
function luffLinq(arrayOrDict) {
  if (Array.isArray(arrayOrDict))
    return new LuffLinq(arrayOrDict);
  if (arrayOrDict instanceof Map) {
    let array2 = [];
    for (let k of arrayOrDict.keys())
      array2.push({ Key: k, Value: arrayOrDict.get(k) });
    return new LuffLinq(array2);
  }
  let array = Object.getOwnPropertyNames(arrayOrDict).map((key) => ({ Key: key, Value: arrayOrDict[key] }));
  return new LuffLinq(array);
}
__name(luffLinq, "luffLinq");
const _LuffListener = class _LuffListener {
  Run() {
    this.Stop(), this._Interval = setInterval(() => {
      this._Listen();
    }, this.Freq);
  }
  Stop() {
    clearInterval(this._Interval), clearTimeout(this._TimeOut);
  }
  _Listen() {
    this.Target || this.Stop();
    let Width = this.Target.clientWidth;
    if (Width !== this.Width)
      return this.Width = Width, this._OnEvent("width");
    let Height = this.Target.clientHeight;
    if (Height !== this.Height)
      return this.Height = Height, this._OnEvent("height");
  }
  _OnEvent(dimension) {
    clearTimeout(this._TimeOut), this._TimeOut = setTimeout(() => {
      this.OnEvent();
    }, this.Delay);
  }
  constructor({ Target = null, Type = "resize", Freq = 20, Delay = 0, OnEvent = /* @__PURE__ */ __name(() => {
  }, "OnEvent") } = {}) {
    this.Target = LibraryDOM.Select(Target), this.Target !== null && (this.Type = "resize", this.Freq = Freq, this.Delay = Delay, this.OnEvent = OnEvent, this._Interval = null, this._TimeOut = null, this.Width = this.Target.clientWidth, this.Height = this.Target.clientHeight, this._Timer = 0, this.Run());
  }
};
__name(_LuffListener, "LuffListener");
let LuffListener = _LuffListener;
const _State = class _State {
  constructor(ctor) {
    this._ID = LibraryNumber.GetID(), this._Property = "root", this._IsDisposed = !1, ctor.Context && (this._Context = ctor.Context, ctor.Context.AddDisposeCallback(() => this.Dispose()));
  }
  _GetChildStates() {
    const children = [], value = this.__SValue;
    if (value == null)
      return children;
    const type = PropTypes.GetType(value);
    if (type === "array")
      for (let i = 0; i < value.length; i++) {
        const child = this.__GetChildByKey(i);
        child instanceof _State && children.push(child);
      }
    else if (type === "object" && value.constructor.name === "Object")
      for (const k of Object.getOwnPropertyNames(value)) {
        const child = this.__GetChildByKey(k);
        child instanceof _State && children.push(child);
      }
    return children;
  }
  Dispose() {
    if (!this._IsDisposed) {
      this._IsDisposed = !0;
      for (const child of this._GetChildStates())
        child.Dispose(), delete this[child._Property];
      this._Subscribers = void 0, this.__SValue = void 0, this._Parent = void 0, this._Context = void 0;
    }
  }
  _GetFullPath() {
    let p = this._Parent, path = this._Property;
    for (; p; )
      path = p._Property + "." + path, p = p._Parent;
    return path;
  }
  _CollectSubscribers() {
    let ss = [];
    if (this._Subscribers)
      for (let fn2 of this._Subscribers)
        ss.push((changedState) => {
          fn2(this.__SValue, changedState);
        });
    return ss;
  }
  _OnChange(changedState, subscribes) {
    this._Subscribers && subscribes.push({ State: this, ChangedState: changedState });
  }
  _UpdateParents(changedState, subscribes) {
    let child = this, par = this._Parent;
    for (; par; )
      par._UpdateValue(child, changedState, subscribes), child = par, par = par._Parent;
    let usedStates = [];
    for (let s of subscribes)
      if (!usedStates.includes(s.State)) {
        usedStates.push(s.State);
        let ss = s.State._CollectSubscribers();
        for (let fn2 of ss)
          fn2(s.ChangedState);
      }
  }
  ForceUpdate() {
    this._Update(this.SValue);
  }
  AddOnChange(onChange, disposeContext) {
    this._AddOnChange(onChange, disposeContext);
  }
  _AddOnChange(onChange, disposeContext) {
    this._Subscribers || (this._Subscribers = []), this._Subscribers.push(onChange), disposeContext && disposeContext.AddDisposeCallback(() => {
      this.RemoveOnChange(onChange);
    });
  }
  RemoveOnChange(onChange) {
    this._Subscribers && LibraryArray.Remove(this._Subscribers, (x) => x === onChange);
  }
  _UpdateValue(childState, changedState, subscribes) {
    this.__SValue[childState._Property] = childState.__SValue, this._OnChange(changedState, subscribes);
  }
  // _UpdateParentsOld(changedState: State): void {
  //     let child : State = this;
  //     let par = this._Parent;
  //     while (par){
  //         par._UpdateValue(child, changedState);
  //         child = par;
  //         par = par._Parent;
  //     }
  // }
  __GetChildByKey(childName) {
    return childName === "" || childName == null || childName === null ? null : this[childName];
  }
  _TryRefreshChild(childProperty, obj, ss) {
    let child = this.__GetChildByKey(childProperty);
    return child && (Array.isArray(obj) && child instanceof StateArray || !Array.isArray(obj) && child instanceof StateSingle) ? (child.Refresh(obj, ss), !0) : !1;
  }
  _GetChildStateNew(child, propertyName) {
    let childState, childType = PropTypes.GetType(child), ctor = { State: child, Property: propertyName.toString(), Parent: this };
    return childType !== "array" ? childState = new StateSingle(ctor) : childState = new StateArray(ctor), childState;
  }
  _GetChildState(child, propertyName, ss) {
    let childState;
    return child instanceof _State ? childState = child : this._TryRefreshChild(propertyName, child, ss) ? childState = this.__GetChildByKey(propertyName) : childState = this._GetChildStateNew(child, propertyName), childState;
  }
  _CompileArray(state, ss) {
    this.__SValue = [];
    let ssLength = ss.length;
    for (let i = 0; i < state.length; i++) {
      let child = state[i], childState = this._GetChildState(child, i, ss);
      this.__SValue[i] = childState.__SValue, Object.defineProperty(this, i, {
        value: childState,
        configurable: !0
      });
    }
    ssLength < ss.length && this._OnChange(this, ss);
  }
  _Compile(state, ss) {
    let type = PropTypes.GetType(state);
    if (type === "array")
      this._CompileArray(state, ss);
    else if (type === "object") {
      if (state.constructor.name !== "Object") {
        this.__SValue = state;
        return;
      }
      let keys = Object.getOwnPropertyNames(state);
      for (let k of keys) {
        if (k === "_p") {
          console.error("[State] State passed as value", `
thisState: `, this, `
valueState`, state);
          continue;
        }
        let child = state[k], childState = this._GetChildState(child, k, ss);
        Object.defineProperty(this, k, {
          value: childState,
          configurable: !0
        });
      }
    } else
      ss.push({ State: this, ChangedState: this });
    this.__SValue = state;
  }
  _InitCtor(ctor) {
    this._Parent = ctor.Parent, this._Property = ctor.Property, this._Compile(ctor.State, []);
  }
  Refresh(newValue, ss) {
    (newValue !== this.__SValue || typeof newValue == "object") && (this._Compile(newValue, ss), this._OnChange(this, ss));
  }
  SubState(render, deps, disposeContext) {
    let renderState, renderValue = render(this.SValue);
    const onChange = /* @__PURE__ */ __name(() => {
      renderState.SValue = render(this.SValue);
    }, "onChange");
    if (Array.isArray(renderValue) ? renderState = new StateArray({
      State: render(this.SValue),
      Context: this._Context,
      Property: this._Property + "_SubState"
    }) : renderState = new StateSingle({
      State: render(this.SValue),
      Context: this._Context,
      Property: this._Property + "_SubState"
    }), this._AddOnChange(onChange, disposeContext), deps)
      for (let st of deps)
        st._AddOnChange && st._AddOnChange(onChange, disposeContext);
    return renderState;
  }
  SubStateArr(render, deps) {
    return this.SubState(render, deps);
  }
  ReplaceWith(newState) {
    newState.Name = this.Name, Object.defineProperty(this._Parent, this._Property, {
      value: newState,
      configurable: !0
    });
    let ss = [];
    this._OnChange(newState, ss), this._UpdateParents(newState, ss);
  }
  // TransactionBegin() : void {
  //     this.__SValuePrev = LibraryObject.Clone(this.__SValue);
  // }
  // TransactionRollBack() : void {
  //     if (this.__SValuePrev !== null) {
  //         this.__SValue = this.__SValuePrev;
  //         this.__SValuePrev = null;
  //     }
  // }
  _Update(value) {
    let ss = [];
    this._Compile(value, ss), this._OnChange(this, ss), this._UpdateParents(this, ss);
  }
  get SProperty() {
    return this._Property;
  }
  get SParentState() {
    return this._Parent;
  }
  get SValue() {
    return this.__SValue;
  }
  set _SValue(value) {
    (value !== this.__SValue || typeof value == "object") && this._Update(value);
  }
};
__name(_State, "State");
let State = _State;
const _StateSingle = class _StateSingle extends State {
  //public static IsTypeStrict : boolean = false;
  _GetChildByKey(key) {
    return this.__GetChildByKey(key);
  }
  valueOf() {
    return this.__SValue;
  }
  toString() {
    return String(this.__SValue);
  }
  SetProperty(key, item) {
    let ss = [], childState = this._GetChildState(item, key.toString(), ss);
    Object.defineProperty(this, key, {
      value: childState,
      configurable: !0
    }), this._OnChange(childState, ss), this._UpdateValue(childState, childState, ss), this._UpdateParents(childState, ss);
  }
  get SValue() {
    return this.__SValue;
  }
  set SValue(value) {
    this._SValue = value;
  }
  constructor(ctor) {
    super(ctor), this._InitCtor(ctor);
  }
};
__name(_StateSingle, "StateSingle");
let StateSingle = _StateSingle;
const _StateArray = class _StateArray extends State {
  // [Symbol.iterator]() {
  //     let index = -1;
  //     let data  = Object.keys(this.__SValue);
  //     return {
  //         next: () => ({ value: this._GetChildByKey(data[++index]), done: !(index in data) })
  //     };
  // };
  [Symbol.iterator]() {
    let index = -1;
    return {
      next: /* @__PURE__ */ __name(() => ({ value: this._GetChildByKey(++index), done: index >= this.__SValue.length }), "next")
    };
  }
  _GetChildByKey(key) {
    return this.__GetChildByKey(key);
  }
  get SValue() {
    return this.__SValue;
  }
  set SValue(value) {
    this._SValue = value;
  }
  _AutoFilterPredicateEmpty(item, index) {
    return !0;
  }
  _Sort() {
    this._AutoSortPredicate && (this.__SValue.sort(this._AutoSortPredicate), this._CompileArray(this.__SValue, []));
  }
  _DoFilter(predicate) {
    this.__SValue.splice(0);
    for (let i = 0; i < this._AutoFilterOriginal.length; i++) {
      const item = this._AutoFilterOriginal[i];
      predicate(item, i) && this.__SValue.push(item);
    }
  }
  _Filter() {
    this._AutoFilterPredicate && (this._DoFilter(this._AutoFilterPredicate), this._CompileArray(this.__SValue, []));
  }
  MakeSortable(compareFn) {
    this._AutoSortPredicate = compareFn, this._Sort();
  }
  MakeFilterable(predicate) {
    this._AutoFilterPredicate = predicate, !predicate && this._AutoFilterOriginal && (this._DoFilter(this._AutoFilterPredicateEmpty), this._AutoFilterOriginal = void 0), this._AutoFilterOriginal || (this._AutoFilterOriginal = [...this.__SValue]), this._Filter(), this._OnChange(this, []);
  }
  _RefreshValue() {
    let newValue = [];
    for (let i = 0; i < this.__SValue.length; i++)
      newValue.push(this[i].__SValue);
  }
  _UpdateValue(childState, changedState, subscribes) {
    this.__SValue[childState._Property] = childState.__SValue, this._Filter(), this._Sort(), this._OnChange(changedState, subscribes);
  }
  //[Symbol.iterator] = stateIterator;
  map(selector) {
    let obj = this, a = [], data = this.__SValue;
    for (let i = 0; i < data.length; i++)
      a.push(selector(obj[i].__SValue, i));
    return a;
  }
  mapState(selector) {
    let obj = this, a = [], data = this.__SValue;
    for (let i = 0; i < data.length; i++)
      a.push(selector(obj[i], i));
    return a;
  }
  filter(predicate) {
    let a = [], data = this.__SValue;
    for (let i = 0; i < data.length; i++) {
      const value = this[i].__SValue;
      predicate(value, i) && a.push(value);
    }
    return a;
  }
  filterState(predicate) {
    let a = [], data = this.__SValue;
    for (let i = 0; i < data.length; i++) {
      const st = this[i];
      predicate(st.__SValue, i) && a.push(st);
    }
    return a;
  }
  Where(delegate) {
    let a = [], data = this.__SValue;
    for (let i = 0; i < data.length; i++) {
      const state = this[i];
      delegate(state.__SValue, i) && a.push(state);
    }
    return new _StateArray({ State: a });
  }
  Select(delegate) {
    let obj = this, selected = [], data = this.__SValue;
    for (let i = 0; i < data.length; i++)
      typeof delegate == "string" ? selected.push(obj[i][delegate]) : selected.push(delegate(obj[i], i));
    return selected;
  }
  ToList() {
    return this.__SValue;
  }
  FirstOrDefault(predicate) {
    let obj = this;
    if (!predicate)
      return obj[0];
    let data = this.__SValue;
    for (let i = 0; i < data.length; i++)
      if (predicate(obj[i].__SValue, i))
        return obj[i];
    return null;
  }
  LastOrDefault(predicate) {
    let obj = this, data = this.__SValue;
    if (!predicate)
      return obj[data.length - 1];
    for (let i = data.length - 1; i >= 0; i--)
      if (predicate(obj[i].__SValue, i))
        return obj[i];
    return null;
  }
  Add(item) {
    let data = this.__SValue, i = data.length, ss = [], childState = this._GetChildState(item, i.toString(), ss);
    return Object.defineProperty(this, i, {
      value: childState,
      configurable: !0
    }), data.push(item), this._Filter(), this._Sort(), this._OnChange(this, ss), this._UpdateParents(this, ss), childState;
  }
  _Add(item, ss) {
    let data = this.__SValue, i = data.length, childState = this._GetChildState(item, i.toString(), ss);
    Object.defineProperty(this, i, {
      value: childState,
      configurable: !0
    }), data.push(item);
  }
  AddState(itemState) {
    let data = this.__SValue, i = data.length;
    Object.defineProperty(this, i, {
      value: itemState,
      configurable: !0
    }), data.push(itemState.SValue), itemState._Parent = this, itemState._Property = i, this._Filter(), this._Sort();
    let ss = [];
    this._OnChange(this, ss), this._UpdateParents(this, ss);
  }
  AddRange(items) {
    let ss = [];
    for (let item of items)
      this._Add(item, ss);
    this._Filter(), this._Sort(), this._OnChange(this, ss), this._UpdateParents(this, ss);
  }
  Remove(value) {
    let data = this.__SValue;
    if (LibraryArray.Remove(data, (v) => v === value) < 1)
      return;
    this._Filter(), this._Sort();
    let ss = [];
    this._CompileArray(data, ss), this._OnChange(this, ss), this._UpdateParents(this, ss);
  }
  RemoveAll(predicate) {
    let data = this.__SValue;
    if (LibraryArray.Remove(data, predicate) < 1)
      return;
    this._Filter(), this._Sort();
    let ss = [];
    this._CompileArray(data, ss), this._OnChange(this, ss), this._UpdateParents(this, ss);
  }
  Contains(item) {
    return this.SValue.includes(item);
  }
  MoveByIndex(indexFrom, indexTo) {
    if (indexFrom === indexTo)
      return;
    const st = this;
    let t = st[indexFrom];
    st[indexTo] = st[indexFrom], st[indexFrom] = t, this._RefreshValue();
  }
  valueOf() {
    return this.__SValue;
  }
  toString() {
    return String(this.__SValue);
  }
  get length() {
    return this.__SValue.length;
  }
  constructor(ctor) {
    super(ctor), this._InitCtor(ctor);
  }
};
__name(_StateArray, "StateArray");
let StateArray = _StateArray;
function getClosestStateArray(state) {
  let p = state;
  for (; p; ) {
    if (p._Parent instanceof StateArray)
      return { Item: p, StateArray: p._Parent };
    p = p._Parent;
  }
  return null;
}
__name(getClosestStateArray, "getClosestStateArray");
function concatString(separator, classList) {
  return classList.reduce((full, cls) => full + (cls ? separator + cls.valueOf() : ""));
}
__name(concatString, "concatString");
function stateStringConcatDefault(...classList) {
  return stateStringConcatFull(" ", ...classList);
}
__name(stateStringConcatDefault, "stateStringConcatDefault");
stateStringConcatDefault.WithSeparator = stateStringConcatFull;
function stateStringConcatFull(separator, ...classList) {
  if (classList.filter((cls) => cls instanceof State).length > 0) {
    let states = [];
    for (let cls of classList)
      cls instanceof State && states.push(cls);
    return states[0].SubState((_) => concatString(separator, classList), states.splice(1));
  } else
    return concatString(separator, classList);
}
__name(stateStringConcatFull, "stateStringConcatFull");
function trySubState(potentialState, selector) {
  return potentialState instanceof StateSingle || potentialState instanceof State || StateSingle.isPrototypeOf && StateArray.isPrototypeOf(potentialState) ? potentialState.SubState(selector) : selector(potentialState);
}
__name(trySubState, "trySubState");
function luffState(state, params = { State: "" }, context) {
  try {
    return state instanceof StateSingle || state instanceof State || StateSingle.isPrototypeOf && StateArray.isPrototypeOf(state) ? state : Array.isArray(state) ? new StateArray(Object.assign(Object.assign({}, params), { State: state, Context: context })) : new StateSingle(Object.assign(Object.assign({}, params), { State: state, Context: context }));
  } catch (e) {
    console.error("luffState"), console.error(e);
  }
}
__name(luffState, "luffState");
luffState.Concat = stateStringConcatDefault;
luffState.GetSubStateOrValue = trySubState;
luffState.GetSValueOrValue = function(potentialState) {
  return potentialState && (potentialState instanceof StateSingle || potentialState instanceof State || StateSingle.isPrototypeOf && StateArray.isPrototypeOf(potentialState) ? potentialState.SValue : potentialState);
};
luffState.TryAddOnChange = function(potentialState, onChange, disposeContext) {
  return potentialState && (potentialState instanceof StateSingle || potentialState instanceof State || StateSingle.isPrototypeOf && StateArray.isPrototypeOf(potentialState)) ? (potentialState.AddOnChange(onChange, disposeContext), !0) : !1;
};
luffState.ValueOf = function(potentialState) {
  return potentialState.valueOf();
};
luffState.IsState = function(potentialState) {
  return potentialState instanceof State;
};
function luffStateArr(state, params = { State: "" }) {
  return state instanceof State || StateArray.isPrototypeOf(state) ? state : new StateArray(Object.assign(Object.assign({}, params), { State: state }));
}
__name(luffStateArr, "luffStateArr");
const _React = class _React {
  static createElement(tag, attrs, children) {
    let el = {
      Tag: tag,
      Attributes: attrs,
      Children: []
    };
    for (let i = 2; i < arguments.length; i++) {
      let child = arguments[i];
      child != null && (typeof child == "string" || typeof child == "number" || child instanceof State ? child = {
        Tag: "textNode",
        Attributes: { textNode: child }
        //Children: []
      } : Array.isArray(child) && (child = {
        Tag: void 0,
        Children: child
      }), el.Children.push(child));
    }
    return el;
  }
};
__name(_React, "React");
let React = _React;
const _AppSettings = class _AppSettings {
};
__name(_AppSettings, "AppSettings");
let AppSettings = _AppSettings;
AppSettings.Route = {
  IsShowEmptyRouteLink: !0
};
AppSettings.IsLazyRenderEnabledByDefault = !1;
AppSettings.IsContentWithChildrenGroupsOpenFirstAlways = !1;
const _DialogTools = class _DialogTools {
  static GetDialogParams(dialogParams, ctx) {
    return dialogParams = Object.assign({ HasWrapper: !0, HasWrapperBG: !0, HasWrapperHandle: !0, WrapperClassCSS: "", IsHideOnOutsideClick: !1, IsGlobal: !1, OnOutsideClick: null, OnWrapperClick: /* @__PURE__ */ __name((e) => ctx.Hide(), "OnWrapperClick") }, dialogParams), dialogParams.Animation !== null && (dialogParams = Object.assign(Object.assign({}, dialogParams), { Animation: Object.assign({ Show: "l-animation_dialog-show", Hide: "l-animation_dialog-hide" }, dialogParams.Animation) })), dialogParams;
  }
  static GetDialogWrap(dialogParams, ctx) {
    let dialogWrap = {
      Element: ctx.DOM,
      ElementAnimate: ctx.DOM,
      WrapperBG: void 0
    };
    if (!dialogParams.HasWrapper)
      return dialogWrap;
    let wrapped = document.createElement("div");
    if (wrapped.classList.add("l-dialog-wrapper"), dialogParams.WrapperClassCSS.length > 0 && wrapped.classList.add(...dialogParams.WrapperClassCSS.split(" ")), dialogParams.IsGlobal && wrapped.classList.add("l-global"), dialogParams.HasWrapperBG) {
      let wrapperBG = document.createElement("div");
      wrapperBG.classList.add("l-dialog-wrapper-bg");
      let innerContent = document.createElement("div");
      if (innerContent.classList.add("l-dialog-wrapper-content"), ctx.DOM instanceof Element)
        innerContent.appendChild(ctx.DOM);
      else {
        let childrenDOM = ctx.GetChildrenDomElements();
        for (let c of childrenDOM)
          innerContent.appendChild(c);
        for (let c of ctx.Children)
          c._TargetDOM = innerContent;
      }
      wrapped.appendChild(wrapperBG), wrapped.appendChild(innerContent), dialogParams.HasWrapperHandle && wrapperBG.addEventListener("click", dialogParams.OnWrapperClick.bind(ctx)), dialogWrap.WrapperBG = wrapperBG, dialogWrap.ElementAnimate = innerContent;
    }
    return dialogWrap.Element = wrapped, dialogWrap;
  }
  static WrapDialogOld(dialogParams, ctx) {
    let htmlElement = ctx.DOM, wrapped = ctx.DOM, w = {
      HtmlElement: wrapped,
      BeforeShowDialog: void 0,
      HideDialog: void 0,
      AnimationDurationShow: 0,
      AnimationDurationHide: 0
    }, timeoutHide;
    if (dialogParams.Animation !== null && (w.AnimationDurationShow = LibraryCSS.GetDurationAnimation(dialogParams.Animation.Show), w.AnimationDurationHide = LibraryCSS.GetDurationAnimation(dialogParams.Animation.Hide)), dialogParams.HasWrapper) {
      if (wrapped = document.createElement("div"), wrapped.classList.add("l-dialog-wrapper"), dialogParams.IsGlobal && wrapped.classList.add("l-global"), dialogParams.HasWrapperBG) {
        let wrapperBG = document.createElement("div");
        wrapperBG.classList.add("l-dialog-wrapper-bg");
        let innerContent = document.createElement("div");
        innerContent.classList.add("l-dialog-wrapper-content"), innerContent.appendChild(htmlElement), wrapped.appendChild(wrapperBG), wrapped.appendChild(innerContent), dialogParams.HasWrapperHandle && wrapperBG.addEventListener("click", dialogParams.OnWrapperClick), w.HtmlElement = wrapped, w.BeforeShowDialog = () => {
          dialogParams && dialogParams.Animation && (innerContent.classList.remove(dialogParams.Animation.Hide), wrapperBG.style.display = "", dialogParams.Animation.Show && innerContent.classList.add(dialogParams.Animation.Show)), wrapped.style.display = "";
        }, w.HideDialog = () => {
          dialogParams && dialogParams.Animation ? (innerContent.classList.remove(dialogParams.Animation.Show), wrapperBG.style.display = "none", dialogParams.Animation.Hide && innerContent.classList.add(dialogParams.Animation.Hide), window.clearTimeout(timeoutHide), timeoutHide = window.setTimeout(() => {
            wrapped.style.display = "none", ctx.DOM.remove();
          }, w.AnimationDurationHide)) : wrapped.style.display = "none";
        };
      }
      return w;
    }
    return w.BeforeShowDialog = () => {
      dialogParams && dialogParams.Animation && (wrapped.classList.remove(dialogParams.Animation.Hide), dialogParams.Animation.Show && htmlElement.classList.add(dialogParams.Animation.Show)), wrapped.style.display = "";
    }, w.HideDialog = () => {
      dialogParams && dialogParams.Animation ? (wrapped.classList.remove(dialogParams.Animation.Show), dialogParams.Animation.Hide && wrapped.classList.add(dialogParams.Animation.Hide), window.clearTimeout(timeoutHide), timeoutHide = window.setTimeout(() => {
        wrapped.style.display = "none";
      }, w.AnimationDurationHide)) : wrapped.style.display = "none";
    }, w;
  }
};
__name(_DialogTools, "DialogTools");
let DialogTools = _DialogTools;
DialogTools.Container = document.body;
document.addEventListener("DOMContentLoaded", () => {
  DialogTools.Container = document.createElement("div"), DialogTools.Container.id = "l-dialogContainer-" + LibraryString.Random(10), document.body.appendChild(DialogTools.Container);
});
let idCounter = 0;
const documentListener = /* @__PURE__ */ __name(function(e) {
  const listeners = [...OutsideClickManager.Listeners];
  for (let listenerItem of listeners)
    listenerItem.Listener(e);
}, "documentListener");
function checkGlobalDialogs(eventTarget) {
  return !LibraryDOM.Closest(eventTarget, ".l-cb-offer-list");
}
__name(checkGlobalDialogs, "checkGlobalDialogs");
const _OutsideClickManager = class _OutsideClickManager {
  Add(elem, onOutsideClick) {
    if (!elem) {
      console.error("[LuffOutsideClickManager] elem is not defined", elem, onOutsideClick);
      return;
    }
    let outsideClickCheck = /* @__PURE__ */ __name((e) => {
      const eventTarget = e.target;
      eventTarget !== elem && !LibraryDOM.IsDescendant(eventTarget, elem) && !eventTarget.classList.contains("l-pop-log__close") && checkGlobalDialogs(eventTarget) && onOutsideClick(e);
    }, "outsideClickCheck");
    const listenerID = ++idCounter;
    return _OutsideClickManager.Listeners.push({
      ID: listenerID,
      Listener: outsideClickCheck
    }), listenerID;
  }
  Remove(id) {
    LibraryArray.Remove(_OutsideClickManager.Listeners, (x) => x.ID === id);
  }
  constructor() {
    document.addEventListener("mousedown", documentListener, { capture: !0 });
  }
};
__name(_OutsideClickManager, "OutsideClickManager");
let OutsideClickManager = _OutsideClickManager;
OutsideClickManager.Listeners = [];
const outsideClickManager = new OutsideClickManager();
let popLogInstanceCounter = 0;
function createElementFromString(string2, ownerTagName = "div") {
  let documentFragment = document.createDocumentFragment(), containerElement = document.createElement(ownerTagName);
  for (containerElement.innerHTML = string2; containerElement.childNodes[0]; )
    documentFragment.appendChild(containerElement.childNodes[0]);
  return Array.from(documentFragment.childNodes).find((x) => x.nodeName.indexOf("text") < 0);
}
__name(createElementFromString, "createElementFromString");
const _PopLog = class _PopLog {
  static ParseLink(text2) {
    return text2.replace ? text2.replace(_PopLog.RegexLink, (m, link, c, capt) => `<a class="a" href="${link}">${capt || link}</a>`) : text2;
  }
  _AddLine(text2, type = "", opt = {}) {
    text2 = _PopLog.ParseLink(text2), text2 = text2.replace(/\n/g, "<br>");
    const animationDuration = this._AnimationDuration, duration = opt.Duration === void 0 ? this._Duration : opt.Duration, templateDefault = `<div class="l-pop-log ${type}" style="transition-duration: ${animationDuration}ms;">
                                    <div class="l-pop-log__close"></div>
                                    <div class="l-pop-log__text">${text2}</div>  
                                    <div class="l-pop-log__life" style="transition-duration: ${duration}ms;"></div>
                                 </div>`, div = createElementFromString(templateDefault), lifeLine = div.querySelector(".l-pop-log__life"), buttonClose = div.querySelector(".l-pop-log__close"), elemContext = {
      DOM: div,
      Hide: /* @__PURE__ */ __name(() => {
        clearTimeout(destroyTimeout), div.style.opacity = "0", setTimeout(() => {
          div.remove();
        }, Math.round(animationDuration));
      }, "Hide")
    };
    buttonClose.addEventListener("click", elemContext.Hide), opt.OnClick && div.querySelector(".l-pop-log__text").addEventListener("click", (e) => {
      opt.OnClick(elemContext, e);
    });
    let destroyTimeout = setTimeout(() => {
      div.style.opacity = "0", setTimeout(() => {
        div.remove();
      }, animationDuration);
    }, duration);
    div.addEventListener("mouseover", () => {
      lifeLine.style.width = lifeLine.clientWidth + "px", clearTimeout(destroyTimeout);
    }), div.addEventListener("mouseleave", () => {
      const wp = div.clientWidth, w = lifeLine.clientWidth, TimeToDestroy = Math.round(w / wp * duration);
      lifeLine.style.width = "0", lifeLine.style.transitionDuration = TimeToDestroy + "ms", destroyTimeout = setTimeout(() => {
        div.style.opacity = "0", setTimeout(() => {
          div.remove();
        }, Math.round(animationDuration));
      }, TimeToDestroy);
    }), this._Block.appendChild(div), div.style.opacity = "1", setTimeout(function() {
      lifeLine.style.width = "0";
    }, 50);
  }
  constructor({ Target = document.body, AnimationDuration = _PopLog.DefaultSettings.AnimationDuration, Duration: Duration2 = _PopLog.DefaultSettings.Duration, Style: Style2 = {}, IsNewInstance = !1 } = {}) {
    popLogInstanceCounter++, this._AnimationDuration = AnimationDuration, this._Duration = Duration2, IsNewInstance || (this._Block = document.querySelector("#l-pop-log-hook-1")), (IsNewInstance || this._Block === null) && (this._Block = createElementFromString(`<div class="l-pop-log-hook" id="l-pop-log-hook-${popLogInstanceCounter}"></div>`)), Target.appendChild(this._Block);
  }
  Success(text2, opt = {}) {
    this._AddLine(text2, "success", opt), opt.LogItem && console.log(opt.LogItem);
  }
  Error(text2, opt = {}) {
    this._AddLine(text2, "error", opt), console.error(opt.LogItem ? opt.LogItem : text2);
  }
  Warn(text2, opt = {}) {
    this._AddLine(text2, "warning", opt), console.warn(opt.LogItem ? opt.LogItem : text2);
  }
  Notice(text2, opt = {}) {
    this._AddLine(text2, "notice", opt), opt.LogItem && console.log(opt.LogItem);
  }
  static Success(text2, opt = {}) {
    luffPop.Success(text2, opt), opt.LogItem && console.log(opt.LogItem);
  }
  static Error(text2, opt = {}) {
    luffPop.Error(text2, opt);
  }
  static Warn(text2, opt = {}) {
    luffPop.Warn(text2, opt);
  }
  static Notice(text2, opt = {}) {
    luffPop.Notice(text2, opt);
  }
  static _l() {
    return luffPop;
  }
};
__name(_PopLog, "PopLog");
let PopLog = _PopLog;
PopLog.DefaultSettings = {
  AnimationDuration: 200,
  Duration: 5e3
};
PopLog.RegexLink = new RegExp("\\[link=([\\s\\S]*?);?(title=([\\s\\S]*?))?\\]", "g");
let luffPop = new PopLog(), rootDOM;
const Application = {
  Debug: !1,
  Entry: null,
  IsRun: !1,
  RootElementID: "root",
  RootElement: null,
  RootComps: [],
  Settings: AppSettings,
  Run(entryContentRouteName) {
    if (Application.IsRun)
      return console.warn("Luff Application is already run");
    rootDOM = document.getElementById(Application.RootElementID), Application.RootElement = rootDOM, Application.IsRun = !0;
    const roots = [...AppRouter.ContentRoot];
    let perf = window.performance.now();
    for (let ctn of roots)
      ctn._InitializeComponent(), ctn.HasPermission && (ctn._GenerateDOM(), ctn._Mount(!0), ctn._IsShown && ctn._IsMount && ctn._Appear());
    this.RootComps = roots;
    let perAppend = window.performance.now();
    console.info("[Luff.Application.Perf] Build total: ", Math.round((perAppend - perf) * 100) / 100, "ms");
    let routeStat = 0;
    const savedPath = localStorage.getItem("LuffRoute" + document.location.href.split("#")[0]);
    if (AppRouter.Enabled && (savedPath && document.location.hash.length === 0 && (routeStat = AppRouter.GoTo(savedPath)), routeStat < 1 && (routeStat = AppRouter.OnPopState(void 0))), Application.Entry && routeStat < 1) {
      let ctn = AppRouter.ContentByRouteName[Application.Entry];
      console.log("Luff.Application.Entry", Application.Entry, ctn), ctn && ctn.Show();
    }
  },
  RestorePath() {
    document.location.hash = localStorage.getItem("LuffRoute"), localStorage.setItem("LuffRoute", "");
  },
  SavePath() {
    localStorage.setItem("LuffRoute" + document.location.href.split("#")[0], document.location.hash.substring(1));
  }
}, APP_ROUTE_ATTEMPTS_COUNT = 20, _Router = class _Router {
  static GetRoutePropsFromString(routeString) {
    const indexParam = routeString.lastIndexOf("/"), routeName = routeString.substring(0, indexParam), routeParam = routeString.substring(indexParam + 1);
    return [routeName, routeParam];
  }
  static GetRoutePropsFromContent(ctx) {
    const routeName = ctx.RouteName, routeParam = ctx._RouteParam !== void 0 ? ctx._RouteParam : "";
    return [routeName, routeParam];
  }
  get Enabled() {
    return this._Enabled;
  }
  // set Enabled(isEnabled: boolean) {
  //     this._Enabled = isEnabled;
  //     if (isEnabled)
  //         window.addEventListener('popstate', this.OnPopState);
  //     else
  //         window.removeEventListener('popstate', this.OnPopState);
  //
  // };
  Register(ctx) {
    ctx.GroupType, ctx.GroupType && (this.ContentsByGroupType[ctx.GroupType] || (this.ContentsByGroupType[ctx.GroupType] = []), this.ContentsByGroupType[ctx.GroupType].push(ctx)), ctx.ParentComponent || this.ContentRoot.push(ctx), this.ContentByRouteName[ctx.RouteName] = ctx;
  }
  UnRegister(ctx) {
    ctx.GroupType, ctx.GroupType && LibraryArray.Remove(this.ContentsByGroupType[ctx.GroupType], (x) => x === ctx), ctx.ParentComponent || LibraryArray.Remove(this.ContentRoot, (x) => x === ctx), LibraryArray.Remove(this.ContentRoot, (x) => x === ctx), delete this.ContentByRouteName[ctx.RouteName];
  }
  TryPush(ctxTo) {
    const [routeName, routeParam] = _Router.GetRoutePropsFromContent(ctxTo), path = `#${routeName}/${routeParam !== "" ? `${routeParam}` : ""}`;
    this.CurrentPath === routeName && this.CurrentParams === routeParam || (this.CurrentPath = routeName, this.CurrentParams = routeParam, this.CurrentContent = ctxTo, ctxTo._IsShown ? window.history.replaceState({ Param: routeParam, Content: routeName }, "", path) : window.history.pushState({ Param: routeParam, Content: routeName }, "", path));
  }
  Back(ctxFrom) {
    ctxFrom._RawContent.Dialog && (this.CurrentPath = void 0, this.CurrentParams = void 0, window.history.back());
  }
  OnPopState(e) {
    const routeString = location.hash.substring(1);
    if (!e || !e.state)
      return Application.Debug && console.log(`%c[Router]  Run new: ${routeString}`, "color: red;", e), this.GoTo(routeString);
    Application.Debug && console.log(`%c[Router]  Run back: ${routeString}`, "color: red;", e), this.GoTo(routeString, !0);
  }
  GoTo(routeString, isBack = !1, attemptCount = 0) {
    if (attemptCount++, Application.Debug && console.log(`%c[Router] GoTo:  ${routeString}`, "color: green;"), !routeString)
      return this.GoToDefault();
    const [routeName, routeParam] = _Router.GetRoutePropsFromString(routeString);
    let ctx = this.ContentByRouteName[routeName];
    if (!ctx) {
      let routeParent = routeName.substring(0, routeName.lastIndexOf("/"));
      for (; routeParent.length > 0 && !ctx; )
        ctx = this.ContentByRouteName[routeParent], routeParent = routeParent.substring(0, routeParent.lastIndexOf("/"));
      return !ctx || !ctx.HasPermission || attemptCount > APP_ROUTE_ATTEMPTS_COUNT ? this.GoToDefault() : (ctx._CheckLazy(), this.GoTo(routeString, isBack, attemptCount));
    }
    const currentContent = this.CurrentContent;
    isBack && currentContent && currentContent._IsShown && currentContent._RawContent.Dialog && currentContent !== ctx && currentContent._DoHide(), this.CurrentPath = routeString;
    const isNewOrEmptyRouteParam = ctx._RouteParam !== routeParam || routeParam.length === 0;
    return ctx && ctx.Permission.IsAllow && /*!ctx._IsShown ||*/
    isNewOrEmptyRouteParam ? (ctx._RouteParam = routeParam, routeParam ? (ctx.OnRoute(routeParam), 1) : (ctx.Show(!isBack), 1)) : this.GoToDefault();
  }
  GoToDefault() {
    this.CurrentContent = null;
    let defaultContent = AppRouter.ContentRoot.find((x) => x.Permission.IsAllow && (x.HasRoute || x.GroupType));
    return defaultContent || (defaultContent = AppRouter.ContentRoot.find((x) => !x._IsDialog)), defaultContent || (defaultContent = AppRouter.ContentRoot[0]), defaultContent.Show(), 0;
  }
  //############################
  constructor() {
    this._Enabled = !0, this.ContentsByGroupType = {}, this.ContentByRouteName = {}, this.ContentRoot = [], window.addEventListener("popstate", (event) => this.OnPopState(event));
  }
};
__name(_Router, "Router");
let Router = _Router;
Router.Settings = {
  Auto: !0
  //if true: any grouped Luff.Content will be mapped, except which got Route=false/null/undefined parameter
};
const _Route = class _Route {
  //OnInvalidRoute: () => void;
  OnNotPermittedRoute() {
    if (this.Content.Permission.OnDeny) {
      this.Content.Permission.OnDeny();
      return;
    }
    PopLog.Warn("[Luff.Permission] You have no permission to the unit", { LogItem: this.Content });
  }
  IsContainsElement(elem) {
    for (let routeLink of this.RouteLinks)
      if (routeLink.IsContainsElement(elem))
        return !0;
    return !1;
  }
  //private Entity: ILuffEntity;
  SetLinksActive(isActive) {
    for (let r of this.RouteLinks)
      r.SetActive(isActive);
  }
  AddRouteLink(routeLink) {
    this.RouteLinks.push(routeLink);
  }
  RemoveRouteLink(routeLink) {
    LibraryArray.Remove(this.RouteLinks, (x) => x === routeLink);
  }
  SetContent(content) {
    this.Content = content;
  }
  Toggle() {
    this.Content.Toggle();
  }
  GoWithParams(params) {
    this.Content._RouteParam = params, this.Content.OnRoute(params);
  }
  GetComponentRoute() {
    return this.Content ? this.Content.GetComponentRoute() : "";
  }
  Go() {
    if (!this.Content)
      throw new Error("[Luff.Route] Route has not bound to LuffContent");
    if (!this.Content.Permission.IsAllow)
      return this.OnNotPermittedRoute();
    this.SetLinksActive(!0), this.Content.Show();
  }
  CheckRouteLink() {
    this.RouteLinks.map((rLink) => rLink.CheckPermission());
  }
  // Back() : void {
  //     //console.log('[Luff.Route] Back', this.Content.RouteName);
  //     //this.SetLinksActive(false);
  //     AppRouter.Back(this.Content);
  // }
  // Activate() : void {
  //     console.log(`[Route.Activate] `, this.Content.RouteName);
  //     this.SetLinksActive(true);
  //     AppRouter.TryPush(this.Content);
  // }
  // Deactivate() : void {
  //     console.log(`[Route.Deactivate] `, this.Content.RouteName);
  //     this.SetLinksActive(false);
  //     //AppRouter.Back(this.Content);
  // }
  constructor(settings) {
    this.RouteLinks = [], this.IsRoutingEnabled = !0, settings = Object.assign({
      //IsShowControlOnEmptyContent: AppSettings.Route.IsShowEmptyRouteLink,
      DoNotUseRouter: !1
    }, settings), this.IsRoutingEnabled = !settings.DoNotUseRouter;
  }
};
__name(_Route, "Route");
let Route = _Route;
const AppRouter = new Router(), PERMISSION_NAME_WRITE = "Write", _ElementBase = class _ElementBase {
  //real react:
  render() {
    return null;
  }
  setState() {
  }
  forceUpdate() {
  }
  get _IsVisible() {
    return this._IsShown && this._IsMount;
  }
  AppendChild(elem) {
    return null;
  }
  AddDisposeCallback(cb) {
    this._BeforeDisposeCalls || (this._BeforeDisposeCalls = []), this._BeforeDisposeCalls.push(cb);
  }
  CreateState(state) {
    return luffState(state, void 0, this);
  }
  _SetProps(props) {
    props || (props = {});
    const defaultProps = this.constructor.defaultProps;
    if (defaultProps) {
      const keys = Object.getOwnPropertyNames(defaultProps);
      for (let k of keys)
        props[k] === void 0 && (props[k] = defaultProps[k]);
    }
    this.props = props;
  }
  _InitializeComponent(props) {
  }
  _RenderUpdate(renderNew) {
    console.error("[_RenderUpdate] not implemented", this);
  }
  Render() {
    return null;
  }
  RenderSafe() {
    try {
      return this.Render();
    } catch (e) {
      console.error("[Luff.Render] Error:" + this.GetComponentPath(!1)), console.error(e);
    }
  }
  GetComponentPathProcess(isExcludedCurrent, delimiter) {
    let path = "", p = this;
    for (isExcludedCurrent && (p = this.ParentComponent); p; )
      path = p.Name + (path.length > 0 ? delimiter + path : ""), p = p.ParentComponent;
    return path;
  }
  GetComponentPath(isExcludedCurrent) {
    return this.GetComponentPathProcess(isExcludedCurrent, " > ");
  }
  Hide() {
    this._HideTransitionFunction(), this._Disappear();
  }
  Show() {
    this._ShowTransitionFunction(), this._Appear();
  }
  GetComponentByName(name) {
    for (let ch of this.Children)
      if (ch.Name == name)
        return ch;
    for (let ch of this.Children) {
      const subChild = ch.GetComponentByName(name);
      if (subChild)
        return subChild;
    }
  }
  GetTargetRenderDOM() {
    let papa = this.ParentElement;
    for (papa._TargetRenderComp && (papa = papa._TargetRenderComp), papa.DOM === this.DOM && (papa = papa.ParentElement); papa; ) {
      if (typeof papa.Tag != "string" && !papa._IsShown)
        return null;
      if (papa.DOM && papa.DOM instanceof Element && papa.DOM !== this.DOM)
        return this._TargetDOM = papa.DOM, this.GetTargetRenderDOM = () => this._TargetDOM, this._TargetDOM;
      papa = papa.ParentElement;
    }
    return Application.RootElement;
  }
  GetClosestNonFragment() {
    let c = this, p = this.ParentElement;
    for (; p; ) {
      if (p.DOM instanceof Element && this.DOM !== p.DOM)
        return {
          Children: p.Children,
          CurrentIndex: p.Children.indexOf(c)
        };
      c = p, p = p.ParentElement;
    }
    return {
      Children: Application.RootComps,
      CurrentIndex: Application.RootComps.indexOf(c)
    };
  }
  FindFirstMount(startIndex, children) {
    if (!(startIndex >= children.length))
      for (let i = startIndex; i < children.length; i++) {
        let sibling = children[i];
        if (sibling._IsMount && !sibling._SpecialTargetToRender && sibling.DOM !== this.DOM) {
          if (!(sibling.DOM instanceof Element)) {
            let subSibling = this.FindFirstMount(0, sibling.Children);
            if (subSibling)
              return subSibling;
            continue;
          }
          return sibling;
        }
      }
  }
  GetNextSibling() {
    let c = this, p = this.ParentElement;
    for (; p; ) {
      if (this.DOM !== p.DOM) {
        let index = p.Children.indexOf(c), firstMount = this.FindFirstMount(index + 1, p.Children);
        if (firstMount)
          return firstMount.DOM;
        if (typeof p.Tag == "string")
          return;
      }
      c = p, p = p.ParentElement;
    }
  }
  GetFirstMountedDOM() {
    let childElement = this;
    for (; childElement && !(childElement.DOM instanceof Element); )
      childElement = childElement.Children.find((c) => c._IsMount);
    if (childElement)
      return childElement.DOM;
  }
  _Mount(isFirstMount = !1) {
    if (this._IsShown) {
      this._IsMount = !0;
      for (let ch of this.Children)
        ch._IsShown && ch._Mount(isFirstMount);
    }
  }
  _Dismount() {
    this._IsMount = !1;
    for (let ch of this.Children)
      ch._Dismount();
  }
  _HideTransitionFunction() {
    this._IsShown = !1, this._Dismount();
  }
  _ShowTransitionFunction() {
    this._IsShown = !0, this._Mount();
  }
  GetFirstParentDOM() {
    let parentElement = this.ParentElement;
    for (; !parentElement.DOM; )
      parentElement = parentElement.ParentElement;
    return parentElement.DOM;
  }
  GetFirstParentDOMElement() {
    let parentElement = this.ParentElement;
    if (!parentElement)
      return Application.RootElement;
    for (; !(parentElement.DOM instanceof HTMLElement); ) {
      if (!parentElement.ParentElement)
        return Application.RootElement;
      parentElement = parentElement.ParentElement;
    }
    return parentElement.DOM;
  }
  GetFirstDOM() {
    let childElement = this;
    for (; !childElement.DOM; )
      childElement = childElement.Children.find((c) => !c._IsDialog && !c._CompileNodeValue);
    return childElement.DOM;
  }
  GetFirstDOMElement() {
    let childElement = this;
    for (; !(childElement.DOM instanceof HTMLElement); )
      childElement = childElement.Children.find((c) => !c._IsDialog && !c._CompileNodeValue);
    return childElement.DOM;
  }
  GetChildrenDomElements() {
    let elements = [];
    for (let c of this.Children)
      c.DOM instanceof Element ? elements.push(c.DOM) : elements.push.apply(elements, c.GetChildrenDomElements());
    return elements;
  }
  _GenerateDOM() {
    return this._GenerateDOM = void 0, null;
  }
  OnAppear() {
  }
  OnDisappear() {
  }
  _Appear() {
    if (!this.IsAppeared) {
      this.IsAppeared = !0, this.OnAppear();
      for (let ch of this.Children)
        ch._IsShown && ch._Appear();
    }
  }
  _Disappear() {
    if (this.IsAppeared) {
      this.IsAppeared = !1, this.OnDisappear();
      for (let ch of this.Children)
        ch._IsShown && ch._Disappear();
    }
  }
  _CompileIsVisible(isVisible) {
    if (!(isVisible == null || !this.HasPermission))
      if (isVisible instanceof State) {
        let state = isVisible;
        this._IsHiddenByDefault = !state.SValue, this._IsShown = state.SValue;
        const isVisibleFn = /* @__PURE__ */ __name((isVisible2) => {
          isVisible2 ? (this._ShowTransitionFunction(), (!this.ParentElement || this.ParentElement.IsAppeared) && this._Appear()) : (this._HideTransitionFunction(), this._Disappear());
        }, "isVisibleFn");
        state.AddOnChange(isVisibleFn), this.AddDisposeCallback(() => state.RemoveOnChange(isVisibleFn));
      } else
        this._IsHiddenByDefault = !isVisible, this._IsShown = isVisible;
  }
  _RemoveComponent(from) {
    this.Render = null, this._GenerateDOM = null, this.ParentElement && LibraryArray.Remove(this.ParentElement.Children, (x) => x === this), this.ParentComponent && LibraryArray.Remove(this.ParentComponent.Children, (x) => x === this);
  }
  Dispose() {
    if (this._BeforeDisposeCalls && this._BeforeDisposeCalls.length > 0)
      for (const cb of this._BeforeDisposeCalls)
        cb();
    this.ParentElement && LibraryArray.Remove(this.ParentElement.Children, (x) => x === this), this.ParentComponent && LibraryArray.Remove(this.ParentComponent.Children, (x) => x === this);
    const chs = [...this.Children];
    for (let ch of chs)
      ch.Dispose();
    this._Dismount();
    let keys = Object.keys(this);
    for (let key of keys)
      delete this[key];
  }
  constructor(rawComponent) {
    var _a, _b, _c;
    if (this.DOM = null, this.ParentElement = null, this.ParentComponent = null, this.Children = [], this._IsShown = !0, this._IsMount = !1, this.HasPermission = !0, this.IsAppeared = !1, this._IsHiddenByDefault = !1, this._InnerIndex = (_a = rawComponent == null ? void 0 : rawComponent.InnerIndex) !== null && _a !== void 0 ? _a : 0, this._ID = LibraryNumber.GetID(), this._RawComponent = rawComponent, this.Name = this.constructor.name, rawComponent) {
      if (this.ParentElement = rawComponent.ParentElement, this.ParentComponent = rawComponent.ParentComponent, this.Tag = rawComponent.Tag, rawComponent.Attributes) {
        let name = rawComponent.Attributes.compName;
        name || (name = rawComponent.Attributes.name, name && this.Tag != "input" && this.ParentComponent && this.ParentComponent.Name != "RadioButton" && console.warn(`[Luff] attribute 'name' is deprecated for naming components, use 'compName'\r
${this.GetComponentPath(!0)} > ${name}`)), name && (this.Name = name), this.Name && rawComponent.ParentComponent && (rawComponent.ParentComponent.Components.AllByName[this.Name] = this);
        const permissionName = rawComponent.Attributes.permission;
        if (permissionName) {
          const permission = rawComponent.ParentComponent.Permission;
          this.HasPermission = permissionName !== PERMISSION_NAME_WRITE ? permission.IsAllowByRule(permissionName) : permission.IsAllowWrite;
          const isHide = (_c = (_b = permission.RuleGet(permissionName)) === null || _b === void 0 ? void 0 : _b.IsHide) !== null && _c !== void 0 ? _c : !0;
          if (!this.HasPermission && !isHide) {
            this.HasPermission = !0;
            const onDenyClick = permission.OnDenyClickGet();
            onDenyClick && (rawComponent.Attributes.onClick = (e) => {
              e.preventDefault(), e.stopPropagation(), onDenyClick(permissionName, this.ParentComponent);
            }), rawComponent.Attributes["data-permission-deny"] = "true", rawComponent.Attributes.disabled = !0;
          }
          if (!this.HasPermission)
            return;
          delete rawComponent.Attributes.permission;
        }
        this._CompileIsVisible(rawComponent.Attributes.isVisible);
      }
      this._SetProps(rawComponent.Attributes), this.props.children = rawComponent.Children;
    } else
      this._SetProps({});
  }
};
__name(_ElementBase, "ElementBase");
let ElementBase = _ElementBase;
const _CasualMountingBase = class _CasualMountingBase extends ElementBase {
  _Mount(isFirstMount = !1) {
    if (!this._IsShown || this._IsMount)
      return;
    if (this._IsMount = !0, !this.ParentElement) {
      Application.RootElement.appendChild(this.DOM);
      return;
    }
    let container = this.GetTargetRenderDOM();
    if (!container) {
      this._IsMount = !1;
      return;
    }
    if (isFirstMount) {
      try {
        container.appendChild(this.DOM);
      } catch {
        debugger;
      }
      return;
    }
    const nextDomTreeSibling = this.GetNextSibling();
    if (nextDomTreeSibling)
      try {
        container.insertBefore(this.DOM, nextDomTreeSibling);
      } catch {
        console.warn("[Mount] error CasualMountingBase"), container.appendChild(this.DOM);
      }
    else
      try {
        container.appendChild(this.DOM);
      } catch {
        debugger;
        console.warn("[Mount] error CasualMountingBase"), container.appendChild(this.DOM);
      }
  }
};
__name(_CasualMountingBase, "CasualMountingBase");
let CasualMountingBase = _CasualMountingBase;
const eventNames = [
  "onabort",
  "onblur",
  "oncancel",
  "oncanplay",
  "oncanplaythrough",
  "onchange",
  "onclick",
  "onclose",
  "oncontextmenu",
  "oncuechange",
  "ondblclick",
  "ondrag",
  "ondragend",
  "ondragenter",
  "ondragleave",
  "ondragover",
  "ondragstart",
  "ondrop",
  "ondurationchange",
  "onemptied",
  "onended",
  "onerror",
  "onfocus",
  "oninput",
  "oninvalid",
  "onkeydown",
  "onkeypress",
  "onkeyup",
  "onload",
  "onloadeddata",
  "onloadedmetadata",
  "onloadstart",
  "onmousedown",
  "onmouseenter",
  "onmouseleave",
  "onmousemove",
  "onmouseout",
  "onmouseover",
  "onmouseup",
  "onmousewheel",
  "onoperadetachedviewchange",
  "onoperadetachedviewcontrol",
  "onpause",
  "onplay",
  "onplaying",
  "onprogress",
  "onratechange",
  "onreset",
  "onresize",
  "onscroll",
  "onseeked",
  "onseeking",
  "onselect",
  "onstalled",
  "onsubmit",
  "onsuspend",
  "ontimeupdate",
  "ontoggle",
  "onvolumechange",
  "onwaiting",
  "onwheel",
  "onauxclick",
  "ongotpointercapture",
  "onlostpointercapture",
  "onpointerdown",
  "onpointermove",
  "onpointerup",
  "onpointercancel",
  "onpointerover",
  "onpointerout",
  "onpointerenter",
  "onpointerleave",
  "onbeforecopy",
  "onbeforecut",
  "onbeforepaste",
  "oncopy",
  "oncut",
  "onpaste",
  "onsearch",
  "onselectstart",
  "onwebkitfullscreenchange",
  "onwebkitfullscreenerror"
], SpecialProperties = ["value", "checked", "disabled", "selected", "indeterminate", "defaultchecked"], forbidden = ["children"], attNativeByReact = {
  className: "class",
  // colSpan: 'colspan',
  // rowSpan: 'rowspan',
  // onClick: 'onclick',
  // onChange: 'onchange',
  onDoubleClick: "ondblclick"
};
var AttributeType;
(function(AttributeType2) {
  AttributeType2[AttributeType2.Casual = 0] = "Casual", AttributeType2[AttributeType2.Property = 1] = "Property", AttributeType2[AttributeType2.StyleProperty = 2] = "StyleProperty", AttributeType2[AttributeType2.CSSVariable = 3] = "CSSVariable", AttributeType2[AttributeType2.ClassName = 4] = "ClassName";
})(AttributeType || (AttributeType = {}));
const _CasualComponent = class _CasualComponent extends CasualMountingBase {
  //private PermissionAttributeName: string = null;
  _SetClassName(className, isSet) {
    isSet ? this.DOM.classList.add(className) : this.DOM.classList.remove(className);
  }
  _SetAttribute(attName, attributeType, attValue) {
    switch (attributeType) {
      case AttributeType.Casual:
        return this.DOM.setAttribute(attName, attValue);
      case AttributeType.Property:
        return this.DOM[attName] = attValue;
      case AttributeType.StyleProperty:
        return this.DOM.style[attName] = attValue;
      case AttributeType.CSSVariable:
        return this.DOM.style.setProperty(attName, attValue);
      case AttributeType.ClassName:
        return this._SetClassName(attName, attValue);
    }
  }
  _RefreshAttributeValue(attName, attributeType) {
    if (!this.DOM)
      return;
    let att = this._AttributeByName[attName], attVal = att.Gen();
    att.LastVal !== attVal && (att.LastVal = attVal, this._SetAttribute(attName, attributeType, attVal));
  }
  _CompileSingleAttribute(attName, attValue, attributeType) {
    let gen;
    if (attName == "isVisible")
      return;
    if (eventNames.indexOf(attName.toLowerCase()) > -1) {
      this._EventListeners[attName.substring(2).toLowerCase()] = attValue;
      return;
    }
    if (typeof attValue == "object" && attValue.Tag && typeof attValue.Tag == "function" && attValue.Tag.prototype instanceof ElementBase && (attValue = ComponentFactory.Build(attValue, this, this.ParentComponent).Render()), attValue instanceof State) {
      let state = attValue;
      gen = /* @__PURE__ */ __name(() => state.SValue, "gen"), state._AddOnChange(() => this._RefreshAttributeValue(attName, attributeType));
    } else
      gen = /* @__PURE__ */ __name(() => attValue, "gen");
    const att = {
      Name: attName,
      Gen: gen,
      LastVal: gen(),
      Type: attributeType
    };
    this._Attributes.push(att), this._AttributeByName[attName] = att;
  }
  _CompileClassDictAttribute(classes) {
    const classNames = Object.getOwnPropertyNames(classes);
    for (let className of classNames) {
      let isClass2 = classes[className];
      this._CompileSingleAttribute(className, isClass2, AttributeType.ClassName);
    }
  }
  // private _CompileClassListAttribute(classes: Array<IObservableStateSimple<string>>) : void {
  //     const classList = luffState(classes.reduce((a, b) => a + ' ' + b,''));
  //     for (let st of classes) {
  //         st.AddOnChange(() => classList.SValue = classes.reduce((a, b) => a + ' ' + b,''));
  //     }
  //
  //
  //     for (let className of classNames) {
  //         let isClass = classes[className];
  //         this._CompileSingleAttribute(className, isClass, AttributeType.ClassName);
  //     }
  // }
  _CompileClassAttributes(attributes) {
    if (!attributes)
      return;
    let classAttValue = attributes.className;
    classAttValue || (classAttValue = attributes.class), classAttValue = classAttValue || "";
    const classDictAttValue = attributes.classDict, classListAttValue = attributes.classList;
    if (delete attributes.class, delete attributes.className, delete attributes.classDict, delete attributes.classList, !classDictAttValue && !classListAttValue) {
      this._CompileSingleAttribute("class", classAttValue, AttributeType.Casual);
      return;
    }
    classAttValue instanceof State || this._CompileClassDictAttribute(classDictAttValue);
    let deps = [];
    function getAtt() {
      let val = "";
      if (classAttValue instanceof State ? (val += classAttValue.SValue, deps.push(classAttValue)) : val += classAttValue, classDictAttValue) {
        const classNames = Object.getOwnPropertyNames(classDictAttValue);
        for (let className of classNames) {
          let isClass2 = classDictAttValue[className];
          isClass2 && (isClass2.SValue && (val += " " + className), deps.push(isClass2));
        }
      }
      return val;
    }
    __name(getAtt, "getAtt");
    let stateClass = luffState(getAtt.call(this));
    const onChange = /* @__PURE__ */ __name(() => stateClass.SValue = getAtt.call(this), "onChange");
    for (let dep of deps)
      !dep || !dep.AddOnChange || dep.AddOnChange(onChange);
    this._CompileSingleAttribute("class", stateClass, AttributeType.Casual);
  }
  _CompileStyleAttributes(styleAttribute) {
    let styleProps;
    if (styleAttribute instanceof State)
      if (typeof styleAttribute.SValue != "object") {
        this._CompileSingleAttribute("style", styleAttribute, AttributeType.Casual);
        return;
      } else
        styleProps = Object.getOwnPropertyNames(styleAttribute.SValue);
    else
      styleProps = Object.getOwnPropertyNames(styleAttribute);
    for (let attName of styleProps) {
      const attValue = styleAttribute[attName];
      this._CompileSingleAttribute(attName, attValue, attName.indexOf("--") === 0 ? AttributeType.CSSVariable : AttributeType.StyleProperty);
    }
  }
  _CompileAttributes() {
    this._CompileClassAttributes(this._RawComponent.Attributes);
    for (let attName in this._RawComponent.Attributes) {
      if (forbidden.includes(attName))
        continue;
      let attValue = this._RawComponent.Attributes[attName];
      if (attNativeByReact[attName] && (attName = attNativeByReact[attName]), attValue == null)
        continue;
      if (attName === "style" && typeof attValue == "object") {
        this._CompileStyleAttributes(attValue);
        continue;
      }
      if (attName === "classDict") {
        this._CompileClassDictAttribute(attValue);
        continue;
      }
      let attributeType = AttributeType.Casual;
      SpecialProperties.includes(attName) && (attributeType = AttributeType.Property), this._CompileSingleAttribute(attName, attValue, attributeType);
    }
  }
  _CompileChildren() {
    let i = 0;
    for (let child of this._RawComponent.Children) {
      let elem = ComponentFactory.Build(child, this, this.ParentComponent, i);
      elem && this.Children.push(elem), i++;
    }
  }
  _GenerateAttributes() {
    for (let att of this._Attributes)
      this._SetAttribute(att.Name, att.Type, att.Gen());
    if (Application.Debug) {
      if (this.DOM.setAttribute("data-comp-path", this.GetComponentPath(!0)), this.DOM.luffContent = this.ParentComponent, this.DOM.tagName == "INPUT") {
        if (this._RawComponent && this._RawComponent.Attributes) {
          let valState = this._RawComponent.Attributes.value ? this._RawComponent.Attributes.value : this._RawComponent.Attributes.checked;
          if (valState && valState._Property)
            this.DOM.setAttribute("data-state-key", valState._Property);
          else if (valState && !valState._Property) {
            const compKeys = Object.getOwnPropertyNames(this.ParentComponent);
            for (let key of compKeys)
              if (this.ParentComponent[key] === valState) {
                this.DOM.setAttribute("data-state-key", "this." + key);
                break;
              }
          }
        }
      } else if (this.Children) {
        const firstText = this.Children.find((c) => c.Tag == "textNode");
        firstText && firstText._TextState && firstText._TextState._Property && this.DOM.setAttribute("data-state-key", firstText._TextState._Property);
      }
    }
  }
  _GenerateEventListeners() {
    var _a;
    const dom = this.DOM, tag = this.Tag, type = (_a = this._AttributeByName.type) === null || _a === void 0 ? void 0 : _a.Gen();
    let resetValue;
    if (tag === "input")
      switch (type) {
        case "radio":
        case "checkbox":
          resetValue = /* @__PURE__ */ __name(function() {
            dom.checked = this.props.checked.SValue;
          }, "resetValue");
          break;
        case "text":
        case "number":
          resetValue = /* @__PURE__ */ __name(function() {
          }, "resetValue");
          break;
        case "password":
        case "email":
        case "tel":
        case "url":
        case "date":
        case "datetime-local":
        case "time":
        case "color":
        case "month":
        case "search":
        case "week":
          resetValue = /* @__PURE__ */ __name(function() {
            dom.value = this.props.value.SValue;
          }, "resetValue");
          break;
        default:
          resetValue = /* @__PURE__ */ __name(function() {
          }, "resetValue");
          break;
      }
    tag == "textarea" && (resetValue = /* @__PURE__ */ __name(function() {
    }, "resetValue"));
    for (let eventName of Object.getOwnPropertyNames(this._EventListeners)) {
      let fn2 = this._EventListeners[eventName];
      if (eventName == "change" && (tag === "input" || tag === "textarea")) {
        if (this._AttributeByName.value && dom.type === "text") {
          const onInput = /* @__PURE__ */ __name((e) => {
            const valuePrev = this._AttributeByName.value.Gen();
            let eventCloned = LibraryDOM.EventClone(e);
            eventCloned.preventDefault = () => e.preventDefault(), eventCloned.stopPropagation = () => e.stopPropagation();
            let caretPosition = dom.selectionStart;
            fn2.call(this.ParentComponent, eventCloned);
            const valueNew = this._AttributeByName.value.Gen();
            valuePrev === valueNew && caretPosition > 0 && caretPosition--, dom.value = valueNew, dom.setSelectionRange(caretPosition, caretPosition);
          }, "onInput");
          this.DOM.addEventListener("input", onInput);
          continue;
        }
        this.DOM.addEventListener("input", (e) => {
          fn2.call(this.ParentComponent, e), resetValue.call(this);
        });
        continue;
      }
      const wrappedFn = /* @__PURE__ */ __name((e) => {
        fn2.call(this.ParentComponent, e);
      }, "wrappedFn");
      this.DOM.addEventListener(eventName, wrappedFn), this._EventListeners[eventName] = wrappedFn;
    }
  }
  _GenerateChildren() {
    for (let ch of this.Children)
      ch.HasPermission && (ch._GenerateDOM(), ch._Mount(!0));
  }
  RemoveEventListeners() {
    for (let eventName of Object.getOwnPropertyNames(this._EventListeners)) {
      let fn2 = this._EventListeners[eventName];
      this.DOM.removeEventListener(eventName, fn2);
    }
  }
  Dispose() {
    this.RemoveEventListeners(), super.Dispose();
  }
  _Dismount() {
    this._IsMount = !1, this.DOM.remove();
  }
  _HideTransitionFunction() {
    this._IsShown = !1, this._Dismount();
  }
  _ShowTransitionFunction() {
    this._IsShown = !0, this._Mount();
  }
  _GenerateDOM() {
    return super._GenerateDOM(), this.DOM = document.createElement(this.Tag), this._GenerateAttributes(), this._GenerateEventListeners(), this._GenerateChildren(), this.DOM;
  }
  _RenderUpdate(renderNew) {
    this._RawComponent = renderNew, this._CompileAttributes(), this._GenerateAttributes(), this._GenerateEventListeners(), this._RenderUpdateChildren(renderNew.Children);
  }
  _RenderUpdateChildren(children) {
    if (children) {
      let used = [];
      for (let index = 0; index < children.length; index++) {
        let renderNewChild = children[index];
        if (!renderNewChild)
          continue;
        let current = this.Children.find((c2) => c2._InnerIndex == index);
        if (!current || current.Tag != renderNewChild.Tag) {
          console.log("[_RenderUpdateChildren]", this.GetComponentPath(!1), index);
          let newChild = ComponentFactory.Build(renderNewChild, this, this.ParentComponent, index);
          this.Children.splice(index, 0, newChild), newChild.HasPermission && (newChild._GenerateDOM(), newChild._ShowTransitionFunction(), newChild._Appear(), used.push(newChild));
          continue;
        }
        current._RenderUpdate(renderNewChild);
        let c = current;
        !c._IsHiddenByDefault && !c._IsDialog && (current._ShowTransitionFunction(), current._Appear()), used.push(current);
      }
      for (let c of this.Children)
        used.includes(c) || (c._HideTransitionFunction(), c._Disappear());
    }
  }
  constructor(rawComponent) {
    super(rawComponent), this._Attributes = [], this._AttributeByName = {}, this._EventListeners = {}, this.HasPermission && (this._CompileAttributes(), this._CompileChildren());
  }
};
__name(_CasualComponent, "CasualComponent");
let CasualComponent = _CasualComponent;
const _CasualFragmentComponent = class _CasualFragmentComponent extends ElementBase {
  _RenderUpdate(render) {
    this._RenderUpdateChildren(render.Children);
  }
  _RenderUpdateChildren(children) {
    if (children) {
      let used = [];
      for (let index = 0; index < children.length; index++) {
        let renderNewChild = children[index];
        if (!renderNewChild)
          continue;
        let current = this.Children.find((c2) => c2._InnerIndex == index);
        if (!current || current.Tag != renderNewChild.Tag) {
          console.log("[_RenderUpdateChildren]", this.GetComponentPath(!1), index);
          let newChild = ComponentFactory.Build(renderNewChild, this, this.ParentComponent, index);
          this.Children.splice(index, 0, newChild), newChild.HasPermission && (newChild._GenerateDOM(), newChild._ShowTransitionFunction(), newChild._Appear(), used.push(newChild));
          continue;
        }
        current._RenderUpdate(renderNewChild);
        let c = current;
        !c._IsHiddenByDefault && !c._IsDialog && (current._ShowTransitionFunction(), current._Appear()), used.push(current);
      }
      for (let c of this.Children)
        used.includes(c) || (c._HideTransitionFunction(), c._Disappear());
    }
  }
  _CompileChildren() {
    const children = this._RawComponent.Children;
    if (!children)
      return;
    let i = 0;
    for (let child of children) {
      let elem = ComponentFactory.Build(child, this, this.ParentComponent, i);
      elem && this.Children.push(elem), i++;
    }
  }
  _GenerateChildren() {
    for (let ch of this.Children)
      ch._GenerateDOM(), ch._Mount(!0);
  }
  _Mount(isFirstMount = !1) {
    if (this._IsShown) {
      if (this._IsMount = !0, isFirstMount) {
        const container = this.GetTargetRenderDOM();
        if (!container) {
          this._IsMount = !1;
          return;
        }
        container.appendChild(this.DOM);
        return;
      }
      super._Mount(isFirstMount);
    }
  }
  _GenerateDOM() {
    return super._GenerateDOM(), this.DOM = document.createDocumentFragment(), this._GenerateChildren(), this._IsHiddenByDefault && this._HideTransitionFunction(), this.DOM;
  }
  constructor(rawComponent) {
    super(rawComponent), this.HasPermission && this._CompileChildren();
  }
};
__name(_CasualFragmentComponent, "CasualFragmentComponent");
let CasualFragmentComponent = _CasualFragmentComponent;
const _CasualTextComponent = class _CasualTextComponent extends CasualMountingBase {
  _CompileNodeValue() {
    if (this._RawComponent) {
      const nodeValue = this._RawComponent.Attributes.textNode;
      if (nodeValue instanceof StateSingle) {
        this._IsDynamic = !0;
        let state = nodeValue;
        this._TextState = state, this._NodeValueGetter = () => state.SValue, state._AddOnChange(() => {
          this.Refresh();
        });
      } else Array.isArray(nodeValue) ? console.error(`[Luff] array has been passed as text component value 
`, nodeValue, this) : this._NodeValue = nodeValue;
    }
  }
  _RenderUpdate(renderNew) {
    this._RawComponent = renderNew, this._CompileNodeValue(), this.DOM.nodeValue = this._NodeValue;
  }
  _GenerateDOM() {
    return super._GenerateDOM(), this._IsDynamic && (this._NodeValue = this._NodeValueGetter()), (this._NodeValue === void 0 || this._NodeValue === null) && (this._NodeValue = ""), this.DOM = document.createTextNode(this._NodeValue), this.DOM;
  }
  Refresh() {
    if (!this.DOM || !this._IsDynamic)
      return;
    let newValue = this._NodeValueGetter();
    newValue == null && (newValue = ""), (this._NodeValue !== newValue || typeof newValue == "object") && (this._NodeValue = newValue, this.DOM.nodeValue = newValue);
  }
  constructor(rawComponent) {
    super(rawComponent), this.Tag = "textNode", this._NodeValueGetter = null, this._IsDynamic = !1, this._CompileNodeValue();
  }
};
__name(_CasualTextComponent, "CasualTextComponent");
let CasualTextComponent = _CasualTextComponent;
function isClass(func) {
  return typeof func == "function" && /^class\s/.test(Function.prototype.toString.call(func));
}
__name(isClass, "isClass");
const _ComponentFactory = class _ComponentFactory {
  static Build(renderElement, parentElement = null, parentComponent = null, innerIndex = 0) {
    let element;
    if (renderElement) {
      if (renderElement.Tag === "textNode")
        element = new CasualTextComponent({
          InnerIndex: innerIndex,
          Attributes: renderElement.Attributes,
          ParentElement: parentElement,
          ParentComponent: parentComponent
        });
      else if (renderElement instanceof StateSingle)
        element = new CasualTextComponent({
          InnerIndex: innerIndex,
          Attributes: { textNode: renderElement },
          ParentElement: parentElement,
          ParentComponent: parentComponent
        });
      else if (Array.isArray(renderElement))
        element = new CasualFragmentComponent({
          InnerIndex: innerIndex,
          ParentElement: parentElement,
          ParentComponent: parentComponent,
          Children: renderElement
        });
      else if (typeof renderElement.Tag == "string")
        element = new CasualComponent({
          InnerIndex: innerIndex,
          Tag: renderElement.Tag,
          Attributes: renderElement.Attributes,
          ParentElement: parentElement,
          ParentComponent: parentComponent,
          Children: renderElement.Children
        });
      else {
        if (renderElement instanceof ElementBase)
          return renderElement.ParentComponent = parentComponent, renderElement.ParentElement = parentElement, renderElement._InitializeComponent(), renderElement.AppendChild = (el) => appendChild(renderElement, el), renderElement;
        if (renderElement.Tag === void 0)
          element = new CasualFragmentComponent({
            InnerIndex: innerIndex,
            ParentElement: parentElement,
            ParentComponent: parentComponent,
            Children: renderElement.Children
          });
        else {
          const luffComponent = renderElement.Tag;
          isClass(luffComponent) && (element = new luffComponent({
            InnerIndex: innerIndex,
            Tag: renderElement.Tag,
            Attributes: renderElement.Attributes,
            ParentElement: parentElement,
            ParentComponent: parentComponent,
            Children: renderElement.Children
          }), element._InitializeComponent());
        }
      }
      if (!element.HasPermission) {
        element._RemoveComponent("factory");
        return;
      }
      return element.AppendChild = (el) => appendChild(element, el), element;
    }
  }
  static ConvertReact(children) {
    if (children)
      return children.map((c) => c && (c.Tag === "textNode" ? c.Attributes.textNode : {
        type: c.Tag,
        props: {
          children: _ComponentFactory.ConvertReact(c.Children)
        }
      }));
  }
};
__name(_ComponentFactory, "ComponentFactory");
let ComponentFactory = _ComponentFactory;
function appendChild($this, elem) {
  const isThisContent = !!$this._CheckLazy;
  let built = ComponentFactory.Build(elem, $this, isThisContent ? $this : $this.ParentComponent);
  return built._GenerateDOM(), built._Mount(!0), built._IsShown && built._IsMount && built._Appear(), $this.Children.push(built), built;
}
__name(appendChild, "appendChild");
var Select = LibraryDOM.Select;
function getDefaultCtor() {
  return {
    Target: document.body,
    SaveOriginalStylePosition: !1,
    BackgroundColor: "",
    CustomSvg: "",
    Size: [60, 60]
  };
}
__name(getDefaultCtor, "getDefaultCtor");
function DoArc(radius, maxAngle, cx, cy) {
  let d = " M " + (cx + radius) + " " + cy;
  for (let angle = 0; angle < maxAngle; angle++) {
    let rad = angle * (Math.PI / 180), x = cx + Math.cos(rad) * radius, y = cy + Math.sin(rad) * radius;
    d += " L " + x + " " + y;
  }
  return d;
}
__name(DoArc, "DoArc");
function getDOM() {
  let dom = document.createElement("div");
  return dom.classList.add("l-load-wrap"), dom.style.display = "none", dom;
}
__name(getDOM, "getDOM");
function getDefaultSpinner(radius) {
  return `
    <svg class="l-load-spinner" xmlns="http://www.w3.org/2000/svg">
    <path d="${DoArc(45, 160, radius, radius)}" class="l-spinner-arc l-spinner-arc-1" fill="none" stroke="#5c9baa" stroke-width="5"></path>
        <path d="${DoArc(37, 130, radius, radius)}" class="l-spinner-arc l-spinner-arc-2" fill="none" stroke="#45c971" stroke-width="5"></path>
        <path d="${DoArc(29, 100, radius, radius)}" class="l-spinner-arc l-spinner-arc-3" fill="none" stroke="#b54038" stroke-width="5"></path>
        <path d="${DoArc(21, 70, radius, radius)}" class="l-spinner-arc l-spinner-arc-4" fill="none" stroke="#777777" stroke-width="5"></path>
        </svg>
    `;
}
__name(getDefaultSpinner, "getDefaultSpinner");
let spinner = getDefaultSpinner(60);
const _LuffLoadNative = class _LuffLoadNative {
  //static DefaultSvg: string;
  static SetSpinner(spinnerHTML) {
    spinner = spinnerHTML;
  }
  get IsActive() {
    return this._IsActive;
  }
  Show() {
    clearTimeout(this._Timeout), clearTimeout(this._TimeoutHide), this._IsActive = !0, this._Timeout = window.setTimeout(() => {
      this.DOM.style.display = "";
    }, 70);
  }
  Hide() {
    clearTimeout(this._Timeout), clearTimeout(this._TimeoutHide), this._IsActive = !1, this._TimeoutHide = window.setTimeout(() => {
      this.DOM.style.display = "none";
    }, 250);
  }
  constructor(ctor = {}) {
    this._IsActive = !1, ctor = Object.assign(Object.assign({}, getDefaultCtor()), ctor), this._Target = Select(ctor.Target);
    const pos = getComputedStyle(this._Target).position.toLowerCase();
    pos !== "absolute" && pos !== "relative" && (this._Target.style.position = "relative"), this.DOM = getDOM(), ctor.BackgroundColor !== void 0 && (this.DOM.style.backgroundColor = ctor.BackgroundColor), ctor.Size[0], ctor.Size[1];
    let innerContent;
    ctor.CustomSvg ? innerContent = ctor.CustomSvg : innerContent = spinner, this.DOM.innerHTML = innerContent, this._Target.appendChild(this.DOM), this._Timeout = void 0, this._TimeoutHide = void 0;
  }
};
__name(_LuffLoadNative, "LuffLoadNative");
let LuffLoadNative = _LuffLoadNative;
const PermissionActionTypes = {
  Hide: 1,
  Remove: 2
};
let Default = {
  //Attribute: 'data-permission',
  IsHideControls: !0,
  OnDeny: /* @__PURE__ */ __name(() => {
  }, "OnDeny"),
  Roles: [],
  Write: [],
  Rules: {},
  Action: {
    Hide: /* @__PURE__ */ __name((Element2) => {
      Element2 && (Element2.style.display = "none");
    }, "Hide"),
    Show: /* @__PURE__ */ __name((Element2) => {
      Element2 && (Element2.style.display = "");
    }, "Show"),
    Remove: /* @__PURE__ */ __name((Element2) => {
      Element2 && Element2.remove();
    }, "Remove")
  },
  ActionType: PermissionActionTypes.Hide
};
const PermissionManSettings = {
  Strict: !1,
  Default
}, _LuffContentUserPermission = class _LuffContentUserPermission {
  constructor() {
    this.Roles = [], this.SubRolesByID = {};
  }
};
__name(_LuffContentUserPermission, "LuffContentUserPermission");
let LuffContentUserPermission = _LuffContentUserPermission;
const appUserPermission = new LuffContentUserPermission(), _PermissionManager = class _PermissionManager {
  get ContentPermission() {
    return this._ctor;
  }
  get IsAllow() {
    return this._IsAllow;
  }
  get IsAllowWrite() {
    return this._IsAllowWrite;
  }
  IsAllowByRule(rule) {
    return this._IsAllowByRule[rule] === void 0 ? this._Owner.ParentComponent ? this._Owner.ParentComponent.Permission.IsAllowByRule(rule) : !0 : this._IsAllowByRule[rule];
  }
  IsAllowWriteByRule(rule) {
    return this._IsAllowWriteByRule[rule] === void 0 ? !0 : this._IsAllowWriteByRule[rule];
  }
  get IsHideControls() {
    return this._ctor.IsHideControls;
  }
  get OnDeny() {
    return this._ctor.OnDeny;
  }
  OnDenyClickGet() {
    if (this._ctor.OnDenyClick)
      return this._ctor.OnDenyClick;
    let p = this._Owner;
    for (; p; ) {
      if (p.Permission._ctor.OnDenyClick)
        return p.Permission._ctor.OnDenyClick;
      p = p.ParentComponent;
    }
  }
  RuleGet(ruleName) {
    let p = this._Owner;
    for (; p; ) {
      if (p.Permission._ctor.Rules && p.Permission._ctor.Rules[ruleName])
        return p.Permission._ctor.Rules[ruleName];
      p = p.ParentComponent;
    }
  }
  _CheckRole(role) {
    const appUser = appUserPermission;
    return appUser.Roles.includes(role) || appUser.Roles.includes[role] && appUser.Roles.includes[role].length > 0;
  }
  _CheckRoles(RolesRequired) {
    if (!RolesRequired || RolesRequired.length < 1)
      return !0;
    for (let i = 0; i < RolesRequired.length; i++) {
      let Role = RolesRequired[i];
      if (this._CheckRole(Role))
        return !0;
    }
    return !1;
  }
  _HasMainPermission() {
    let RolesRequired = this._ctor.Roles;
    if (RolesRequired.length < 1)
      return !0;
    for (let i = 0; i < RolesRequired.length; i++) {
      let Role = RolesRequired[i];
      if (this._CheckRole(Role))
        return !0;
    }
    return !1;
  }
  _HasMainWritePermission() {
    let RolesRequired = this._ctor.Write;
    if (RolesRequired.length < 1)
      return !0;
    for (let i = 0; i < RolesRequired.length; i++) {
      let Role = RolesRequired[i];
      if (this._CheckRole(Role))
        return !0;
    }
    return !1;
  }
  Check() {
    this._IsAllow = (!this._Owner.ParentComponent || this._Owner.ParentComponent.Permission.IsAllow) && this._HasMainPermission(), this._IsAllowWrite = (!this._Owner.ParentComponent || this._Owner.ParentComponent.Permission.IsAllowWrite) && this.IsAllowWrite && this._HasMainWritePermission();
    for (let RuleName of Object.getOwnPropertyNames(this._ctor.Rules))
      this._IsAllowByRule[RuleName] = this._CheckRoles(this._ctor.Rules[RuleName].Roles), this._IsAllowWriteByRule[RuleName] = this._CheckRoles(this._ctor.Rules[RuleName].Write);
  }
  constructor(cfg, Owner) {
    this.RuleNames = [], this._IsAllow = !0, this._IsAllowWrite = !0, this._IsAllowByRule = {}, this._IsAllowWriteByRule = {}, this._Owner = Owner, cfg = Object.assign(Object.assign({}, Default), cfg);
    for (let RuleName of Object.getOwnPropertyNames(cfg.Rules))
      cfg.Rules[RuleName].Roles = cfg.Rules[RuleName].Roles !== void 0 ? cfg.Rules[RuleName].Roles : [], cfg.Rules[RuleName].Write = cfg.Rules[RuleName].Write !== void 0 ? cfg.Rules[RuleName].Write : [], cfg.Rules[RuleName].IsHide = cfg.Rules[RuleName].IsHide !== !1, this._IsAllowByRule[RuleName] = !0, this._IsAllowWriteByRule[RuleName] = !0, this.RuleNames.push(RuleName);
    this._ctor = cfg, this.Check();
  }
};
__name(_PermissionManager, "PermissionManager");
let PermissionManager = _PermissionManager;
PermissionManager.Settings = PermissionManSettings;
PermissionManager.Actions = PermissionActionTypes;
function getRouteName(ctx) {
  let p = ctx.ParentComponent, fullName = ctx.Name;
  for (; p; )
    p instanceof Content && (fullName = p.Name + "/" + fullName), p = p.ParentComponent;
  return fullName;
}
__name(getRouteName, "getRouteName");
const _Content = class _Content extends ElementBase {
  static AddStateSubscription(state, content, callBack) {
    const ctx = content, appear = ctx.OnAppear.bind(ctx), disappear = ctx.OnDisappear.bind(ctx);
    ctx.OnAppear = (function() {
      appear(), state.AddOnChange(callBack);
    }).bind(ctx), ctx.OnDisappear = (function() {
      disappear(), state.RemoveOnChange(callBack);
    }).bind(ctx);
  }
  AddStateSubscription(state, callBack) {
    _Content.AddStateSubscription(state, this, callBack);
  }
  get IsVisible() {
    let p = this;
    for (; p; ) {
      if (!p._IsShown)
        return !1;
      p = p.ParentElement;
    }
    return !0;
  }
  Render() {
    return null;
  }
  Ctor() {
    return {};
  }
  RenderForce() {
    this._RenderUpdate(null);
  }
  _RenderUpdate(render) {
    if (render || (render = this.RenderSafe()), typeof render.Tag == "string") {
      this.Children[0]._RenderUpdate(render);
      return;
    }
    if (this instanceof render.Tag) {
      this.Children[0]._RenderUpdate(this.RenderSafe());
      return;
    }
    if (render.Tag == CasualFragmentComponent) {
      this.Children[0]._RenderUpdate(render);
      return;
    }
    for (let i = 0; i < render.Children.length; i++) {
      let renderNewChild = render.Children[i];
      this.Children[i]._RenderUpdate(renderNewChild);
    }
    this.Children[0]._RenderUpdate(render);
  }
  GetComponentRoute() {
    return this.GetComponentPathProcess(!1, "/");
  }
  BeforeShow() {
  }
  BeforeHide() {
  }
  AfterShow() {
  }
  AfterHide() {
  }
  BeforeBuild() {
  }
  AfterBuild() {
  }
  /* #REGION #SHOW */
  Show(isCalledDirectly = !0) {
    this._CheckLazy(), this._HideSameGroupTypeContents();
    const ctx = this._GetEndContentToShow(), isChildWillBeShown = this !== ctx;
    isChildWillBeShown || this._ShowCheckRoute(isCalledDirectly), isChildWillBeShown && ctx.Show(), this._DoShow();
  }
  _GetEndContentToShow() {
    let firstChild = this._ChildrenContent.find((child) => (child._IsShown || AppSettings.IsContentWithChildrenGroupsOpenFirstAlways) && child._Route && child._Route.IsRoutingEnabled);
    if (firstChild)
      return firstChild._GetEndContentToShow();
    for (let child of this._ChildrenContent)
      if (
        /*child.GroupType && */
        child._Route && child._Route.IsRoutingEnabled && (firstChild || (firstChild = child), child._IsShown)
      )
        return child._GetEndContentToShow();
    return firstChild ? firstChild._GetEndContentToShow() : this;
  }
  _HideSameGroupTypeContents() {
    if (this.GroupType !== void 0) {
      const others = AppRouter.ContentsByGroupType[this.GroupType];
      for (let item of others)
        item !== this && item.ParentComponent === this.ParentComponent && item.Hide();
    }
  }
  _ShowCheckRoute(isCalledDirectly) {
    this._Route && this._Route.IsRoutingEnabled && isCalledDirectly && AppRouter.TryPush(this);
  }
  _IsShowingParentRequired() {
    return this.ParentComponent ? !(this._RawContent.Dialog && this._RawContent.Dialog.IsGlobal) : !1;
  }
  _GetFirstNotShownParent() {
    let p = this.ParentComponent;
    for (; p; ) {
      if (!p._IsShown)
        return p;
      p = p.ParentComponent;
    }
  }
  _DoShow() {
    if (this._IsShowingParentRequired()) {
      const closestParentToShow = this._GetFirstNotShownParent();
      closestParentToShow && (closestParentToShow._HideSameGroupTypeContents(), closestParentToShow._DoShow()), this.ParentComponent._IsMount || this.ParentComponent._DoShowAsync();
    }
    this._Route && this._Route.SetLinksActive(!0), !(this._IsShown && this._IsMount) && (this._IsShown = !0, this.BeforeShow(), this._DoShowAsync(), this._Appear(), this.AfterShow());
  }
  _HideTransitionFunction() {
    super._HideTransitionFunction();
  }
  _ShowTransitionFunction() {
    super._ShowTransitionFunction();
  }
  _DoShowAsync() {
    this._ShowTransitionFunction();
  }
  ShowByRoute() {
    this._Route.SetLinksActive(!0), this._HideSameGroupTypeContents(), this._DoShow();
  }
  /* #END REGION #SHOW */
  //##################################
  /* #REGION #HIDE */
  _HideCheckRoute() {
    this._Route && (this._Route.SetLinksActive(!1), this._Route.IsRoutingEnabled && this._RawContent.Dialog && AppRouter.Back(this));
  }
  Hide() {
    this._HideCheckRoute(), this._DoHide();
  }
  _DoHide() {
    this._IsShown && (this.BeforeHide(), this._Disappear(), this._HideTransitionFunction(), this.AfterHide());
  }
  // _HideTransitionFunction() {
  //     console.log(`_HideTransitionFunction`, this.Name);
  //     this._IsShown = false;
  //     for (let child of this.Children) {
  //         child._HideTransitionFunction();
  //     }
  //
  //     // if (this.DOM.style)
  //     //     this.DOM.style.display = 'none';
  // }
  /* #END REGION #HIDE */
  Toggle() {
    return this._IsShown ? this.Hide() : this.Show();
  }
  _SubscribeOutsideClickListener() {
    this._OutsideClickListener && !this._IsDialog && (this._OutsideClickListenerID = outsideClickManager.Add(this.DOM, this._OutsideClickListener));
  }
  _UnsubscribeOutsideClickListener() {
    this._OutsideClickListener && !this._IsDialog && outsideClickManager.Remove(this._OutsideClickListenerID);
  }
  _Appear() {
    if (!this.IsAppeared) {
      this._CheckLazy(), this.IsAppeared = !0, this._SubscribeOutsideClickListener(), this.OnAppear();
      for (let ch of this.Children)
        ch._IsShown && ch._Appear();
    }
  }
  _Disappear() {
    if (this.IsAppeared) {
      this.IsAppeared = !1, this._UnsubscribeOutsideClickListener(), this.OnDisappear();
      for (let ch of this.Children)
        ch._Disappear();
    }
  }
  OnAppear() {
  }
  OnDisappear() {
  }
  get HasRoute() {
    return this._Route !== void 0 && this._Route !== null;
  }
  get Permission() {
    return this._Permission;
  }
  GetComponentByName(name) {
    let comp = this.Components.AllByName[name];
    if (comp)
      return comp;
    for (let child of this._ChildrenContent)
      if (comp = child.GetComponentByName(name), comp)
        return comp;
  }
  ResetDialogAnimationShow(animationClassName) {
    this._IsShown && (this.DOM.classList.remove(this._RawContent.Dialog.Animation.Show), this.DOM.classList.add(animationClassName)), this._RawContent.Dialog.Animation.Show = animationClassName;
  }
  // _MakeNoWrap(dialogParams: ContentTypes.Dialog) {
  //     let mount = this.Mount.bind(this);
  //     let dismount = this.Dismount.bind(this);
  //     const dom = this.DOM;
  //     if (dialogParams.IsGlobal) {
  //         mount = () => {
  //             this._IsMount = true;
  //             DialogTools.Container.appendChild(dom);
  //         };
  //     }
  //     let isLocked = false;
  //     this.Mount = (isFirstMount) => {
  //         if (isLocked)
  //             return;
  //         if (isAnimateHide)
  //             dom.classList.remove(dialogParams.Animation.Hide);
  //         if (isAnimateShow)
  //             dom.classList.add(dialogParams.Animation.Show);
  //         mount(isFirstMount);
  //         if (dialogParams.OnOutsideClick) //FIXME crutch
  //             setTimeout(() => this._OutsideClickListenerID = outsideClickManager.Add(dom, this._OutsideClickListener), 0);
  //     };
  //     this.Dismount = () => {
  //         if (isLocked)
  //             return;
  //
  //         if (isAnimateShow)
  //             dom.classList.remove(dialogParams.Animation.Show);
  //         if (isAnimateHide) {
  //             dom.classList.add(dialogParams.Animation.Hide);
  //             window.clearTimeout(timeoutHide);
  //             isLocked = true;
  //             timeoutHide = window.setTimeout(() => {
  //                 dismount();
  //                 isLocked = false;
  //                 //wrapped.style.display = 'none';
  //             }, animationDurationHide);
  //         }
  //         else {
  //             dismount();
  //         }
  //         if (dialogParams.OnOutsideClick) {
  //             outsideClickManager.Remove(this._OutsideClickListenerID);
  //         }
  //     };
  //     return this.DOM;
  // }
  _MakeContentDialog() {
    this._IsDialog = !0, this._IsShown = !1, this._RawContent.Dialog = DialogTools.GetDialogParams(this._RawContent.Dialog, this);
    let dialogParams = this._RawContent.Dialog, timeoutHide;
    const isAnimateShow = dialogParams.Animation !== null && dialogParams.Animation && dialogParams.Animation.Show, isAnimateHide = dialogParams.Animation !== null && dialogParams.Animation && dialogParams.Animation.Hide;
    let animationDurationHide = 0;
    isAnimateShow && LibraryCSS.GetDurationAnimation(dialogParams.Animation.Show), isAnimateHide && (animationDurationHide = LibraryCSS.GetDurationAnimation(dialogParams.Animation.Hide)), dialogParams.IsHideOnOutsideClick && !dialogParams.OnOutsideClick && (this._OutsideClickListener = () => this.Hide()), dialogParams.OnOutsideClick && (this._OutsideClickListener = dialogParams.OnOutsideClick.bind(this)), dialogParams.IsGlobal && (this._SpecialTargetToRender = DialogTools.Container);
    let isLocked = !1;
    const dialogWrap = DialogTools.GetDialogWrap(dialogParams, this), wrapper = dialogWrap.Element;
    let doMount = /* @__PURE__ */ __name(() => {
      this._IsMount = !0, this.GetTargetRenderDOM().appendChild(wrapper);
    }, "doMount"), doDismount = /* @__PURE__ */ __name(() => {
      this._IsMount = !1, wrapper.remove();
    }, "doDismount");
    return dialogParams.IsGlobal && (doMount = /* @__PURE__ */ __name(() => {
      DialogTools.Container.appendChild(wrapper);
    }, "doMount")), this._Mount = () => {
      this._IsShown && (isAnimateHide && (dialogWrap.ElementAnimate.classList.remove(dialogParams.Animation.Hide), window.clearTimeout(timeoutHide), isLocked = !1), this._IsMount = !0, !isLocked && (dialogWrap.WrapperBG && wrapper.appendChild(dialogWrap.WrapperBG), isAnimateHide && dialogWrap.ElementAnimate.classList.remove(dialogParams.Animation.Hide), isAnimateShow && dialogWrap.ElementAnimate.classList.add(dialogParams.Animation.Show), doMount(), this._OutsideClickListener && setTimeout(() => this._OutsideClickListenerID = outsideClickManager.Add(wrapper, this._OutsideClickListener), 0)));
    }, this._Dismount = () => {
      isLocked || (dialogWrap.WrapperBG && dialogWrap.WrapperBG.remove(), isAnimateShow && dialogWrap.ElementAnimate.classList.remove(dialogParams.Animation.Show), isAnimateHide ? (dialogWrap.ElementAnimate.classList.add(dialogParams.Animation.Hide), window.clearTimeout(timeoutHide), isLocked = !0, timeoutHide = window.setTimeout(() => {
        doDismount(), isLocked = !1;
      }, animationDurationHide)) : doDismount(), this._OutsideClickListener && outsideClickManager.Remove(this._OutsideClickListenerID));
    }, this.DOM;
  }
  _GenerateDOM() {
    if (super._GenerateDOM(), !this.Render) {
      console.error("[Content] GenerateDOM", this);
      return;
    }
    if (this.BeforeBuild(), this._RawContent.GroupType && (!this._RawContent.Visible || !this.ParentComponent) ? this._IsShown = !1 : this._RawContent.GroupType && this._Route && AppRouter.ContentsByGroupType[this._RawContent.GroupType][0] === this && this._Route.SetLinksActive(!0), this._RawContent.IsLazyRenderEnabled === !0) {
      this._IsLazyRenderDone = !1;
      return;
    }
    this._TempRender = this.RenderSafe(), this._BeforeGenerateDOM(), this._IsHiddenByDefault && (this._IsShown = !1);
    let built = ComponentFactory.Build(this._TempRender, this, this);
    if (delete this._TempRender, !!built)
      return this.Children = [built], this.DOM = built._GenerateDOM(), this._AfterGenerateDOM(), this._RawContent.Dialog ? (this.DOM = this._MakeContentDialog(), this.AfterBuild(), this.DOM) : (this.AfterBuild(), this.DOM);
  }
  _CheckLazy() {
    if (this._IsLazyRenderDone)
      return;
    Application.Debug && console.log(`%c[Content] lazy check: ${this.GetComponentPath(!1)}`, "color: blueviolet;"), this._IsLazyRenderDone = !0;
    let render = this.RenderSafe();
    this._BeforeGenerateDOM();
    let built = ComponentFactory.Build(render, this, this);
    if (this.Children = [built], this.DOM = built._GenerateDOM(), this._AfterGenerateDOM(), this._RawContent.Dialog) {
      this.DOM = this._MakeContentDialog(), this.AfterBuild();
      return;
    }
    this.AfterBuild(), this._Mount(!0);
  }
  OnRoutePath(params) {
    this.Show();
  }
  OnRoute(params) {
    this.Show();
  }
  SetRouteParam(params) {
    this._RouteParam = params;
  }
  _Refresh() {
  }
  _BeforeGenerateDOM() {
  }
  _AfterGenerateDOM() {
    const ctor = this._RawContent;
    if (ctor.LoadTarget !== void 0)
      if (ctor.LoadTarget === "") {
        let target = this.DOM;
        (!target || target instanceof DocumentFragment) && (target = this.GetFirstParentDOMElement()), this.Load = new LuffLoadNative({
          Target: target
        });
      } else
        this.Load = new LuffLoadNative({
          Target: this.GetComponentByName(ctor.LoadTarget).GetFirstDOM()
        });
  }
  _InitCtor() {
    let ctor = this.Ctor();
    this._RawContent = ctor, this.Name = ctor.Name ? ctor.Name : this.Name, this.RouteName = getRouteName(this), this.GroupType = ctor.GroupType, ctor.Route && (this._Route = ctor.Route, ctor.Route.SetContent(this)), ctor.Target && console.warn('[Luff.Content] "ctor.Target" is experimental property'), AppSettings.IsLazyRenderEnabledByDefault && ctor.IsLazyRenderEnabled != !1 && ctor.Route && (this._RawContent.IsLazyRenderEnabled = !0), AppRouter.Register(this), this._InitCtor = null;
  }
  _RemoveComponent(c) {
    super._RemoveComponent(c), this._GenerateDOM = null, this.Render = null, AppRouter.UnRegister(this), this._InitializeComponent = void 0, this.RouteName && Application.Debug && console.log(`%c[Luff.Permission] Not allowed ${this.RouteName}`, "color: darkorange", this);
  }
  Dispose() {
    AppRouter.UnRegister(this), this.ParentComponent && LibraryArray.Remove(this.ParentComponent._ChildrenContent, (x) => x === this), this._Disappear(), super.Dispose();
  }
  _InitializeComponent(props) {
    const ctor = this._RawContent;
    if (!this.HasPermission || (this._Permission = new PermissionManager(ctor.Permission, this), this.HasPermission = this._Permission.IsAllow, this._Route && this._Route.CheckRouteLink(), !this.HasPermission))
      return;
    let contentState = ctor.State;
    this.props.state && (contentState = this.props.state), contentState && (this.State = luffState(contentState, {
      OnChange: /* @__PURE__ */ __name((newValue, changedState) => {
      }, "OnChange")
    })), ctor.Target && (this._TargetRenderComp = ctor.Target), ctor.OnOutSideClick && (this._OutsideClickListener = ctor.OnOutSideClick.bind(this)), this.ParentComponent && (this.ParentComponent._ChildrenContent.push(this), !this.ParentComponent.Components.AllByName[this.Name] ? this.ParentComponent.Components.AllByName[this.Name] = this : this.ParentComponent.Components.AllByName[this.Name + this._ID] = this), this._InitializeComponent = () => {
    };
  }
  // AddStateSubscribe<T>(state: IObservableState<T> | IObservableStateSimple<T> | IObservableStateArray<T>, onChange?: TLuffStateOnChange<T>) : void {
  //     state.AddOnChange((newVal, changedState) => {
  //         if (onChange)
  //             onChange(newVal, changedState);
  //         else
  //             this.Refresh();
  //
  //     });
  // }
  constructor(rawComponent) {
    super(rawComponent), this._IsDialog = !1, this._ChildrenContent = [], this._IsLazyRenderDone = !0, this._Permission = null, this.Components = {
      //ComboBox: {},
      Each: {},
      Element: {},
      AllByName: {}
    }, this._InitCtor();
  }
};
__name(_Content, "Content");
let Content = _Content;
Content.AppRouter = AppRouter;
Content.Load = LuffLoadNative;
Content.Permission = appUserPermission;
Content.OutsideChecks = [];
const _LuffLoad = class _LuffLoad extends ElementBase {
  Show() {
    this._Load.Show();
  }
  Hide() {
    this._Load.Hide();
  }
  _GenerateDOM() {
    return super._GenerateDOM(), this._Load = new LuffLoadNative({
      Target: this.ParentElement.GetFirstDOM(),
      CustomSvg: this.props.customSvg
    }), this.DOM = this._Load.DOM, this.DOM;
  }
};
__name(_LuffLoad, "LuffLoad");
let LuffLoad = _LuffLoad;
const _ComponentSimple = class _ComponentSimple extends ElementBase {
  _RenderUpdate(render) {
    if (render || (render = this.RenderSafe()), typeof render.Tag == "string") {
      this.Children[0]._RenderUpdate(render);
      return;
    }
    if (this instanceof render.Tag) {
      this.Children[0]._RenderUpdate(this.RenderSafe());
      return;
    }
    if (render.Tag == CasualFragmentComponent) {
      this.Children[0]._RenderUpdate(render);
      return;
    }
    for (let i = 0; i < render.Children.length; i++) {
      let renderNewChild = render.Children[i];
      this.Children[i]._RenderUpdate(renderNewChild);
    }
    this.Children[0]._RenderUpdate(render);
  }
  Render() {
    return null;
  }
  BeforeBuild() {
  }
  AfterBuild() {
  }
  _GenerateDOM() {
    super._GenerateDOM(), this._GenerateDOM = null, this.BeforeBuild();
    let renderElement = this.RenderSafe();
    if (!renderElement)
      return;
    const build = ComponentFactory.Build(renderElement, this, this.ParentComponent);
    if (!build) {
      this._RemoveComponent();
      return;
    }
    this.Children.push(build);
    const dom = build._GenerateDOM();
    return this.DOM = build.GetFirstDOM(), this.AfterBuild(), dom;
  }
  constructor(rawComponent) {
    super(rawComponent);
  }
};
__name(_ComponentSimple, "ComponentSimple");
let ComponentSimple = _ComponentSimple;
const _RouteLink = class _RouteLink extends ComponentSimple {
  SetActive(isActive) {
    if (!this.DOM) {
      console.warn("removed link");
      return;
    }
    this.DOM && (isActive ? this.DOM.classList.add(this.props.activeClass) : this.DOM.classList.remove(this.props.activeClass)), this.props.onChangeActive && this.props.onChangeActive(isActive, this);
  }
  IsContainsElement(elem) {
    return LibraryDOM.IsDescendant(elem, this.DOM);
  }
  AfterBuild(props) {
    this.DOM = this.GetFirstDOMElement(), this.DOM.addEventListener("click", () => {
      if (!(this.props.disabled && this.props.disabled.SValue)) {
        if (this.props.isUseToggle)
          return this.props.route.Toggle();
        this.props.route.Go();
      }
    });
    const ctx = this.props.route.Content;
    !AppSettings.Route.IsShowEmptyRouteLink && (!ctx || !ctx.Permission || ctx.Permission && !ctx.Permission.IsAllow) && this._Dismount();
  }
  CheckPermission() {
    const route = this.props.route, ctx = route.Content, permission = ctx.Permission;
    (AppSettings.Route.IsShowEmptyRouteLink || ctx && permission && permission.IsAllow) && (this._IsHiddenByDefault = !1, this.Show()), (!ctx || permission && !permission.IsAllow) && (route.RemoveRouteLink(this), this.props.onPermissionFailed && this.props.onPermissionFailed(this), permission.IsHideControls && this._Dismount());
  }
  Render() {
    const route = this.props.route;
    if (!route.Content)
      return this.props.children;
    const permission = route.Content.Permission;
    return permission && !permission.IsAllow && (route.RemoveRouteLink(this), this.props.onPermissionFailed && this.props.onPermissionFailed(this), permission.IsHideControls) ? null : this.props.children;
  }
  constructor(p) {
    super(p), this.props.route.AddRouteLink(this);
  }
};
__name(_RouteLink, "RouteLink");
let RouteLink = _RouteLink;
RouteLink.defaultProps = {
  activeClass: "active"
};
var SortDirectionType;
(function(SortDirectionType2) {
  SortDirectionType2[SortDirectionType2.Default = 0] = "Default", SortDirectionType2[SortDirectionType2.Up = 1] = "Up", SortDirectionType2[SortDirectionType2.Down = -1] = "Down";
})(SortDirectionType || (SortDirectionType = {}));
const collator = new Intl.Collator("en", { numeric: !0, sensitivity: "base" }), _EachSorterMan = class _EachSorterMan {
  GenSortControl(comparer) {
    const sortMan = this, _EachSorterXXX = class _EachSorterXXX extends EachSorter {
      static Sort(direction) {
      }
    };
    __name(_EachSorterXXX, "EachSorterXXX");
    let EachSorterXXX = _EachSorterXXX;
    return EachSorterXXX.SortMan = sortMan, EachSorterXXX.Sort = (direction) => {
      if (!this._Each)
        throw new Error('[Luff.Each] Missed "sortManager" prop of Each component');
      if (direction === 0) {
        this._Each.Sort(this._DefaultSort);
        return;
      }
      if (direction === 1) {
        this._Each.Sort(comparer);
        return;
      }
      this._Each.Sort((a, b) => comparer(a, b) * -1);
    }, EachSorterXXX;
  }
  GenSortControlByField(fieldName) {
    return this.GenSortControl(this.GetComparerByField(fieldName));
  }
  SetDefaultSort(fieldName) {
    this._DefaultSort = this.GetComparerByField(fieldName);
  }
  GetComparerByField(fieldName) {
    return (a, b) => {
      let valueA = a[fieldName], valueB = b[fieldName];
      return valueA && valueA.localeCompare ? collator.compare(valueA, valueB) : valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
    };
  }
  constructor(defaultSort) {
    this._SorterComps = [], this._DefaultSort = defaultSort;
  }
};
__name(_EachSorterMan, "EachSorterMan");
let EachSorterMan = _EachSorterMan;
const _ComponentSortControl = class _ComponentSortControl extends ComponentSimple {
  constructor() {
    super(...arguments), this.Direction = luffState(SortDirectionType.Default);
  }
  SwitchSort() {
    return this.Direction.SValue === SortDirectionType.Default ? this.Direction.SValue = SortDirectionType.Up : this.Direction.SValue === SortDirectionType.Up ? this.Direction.SValue = SortDirectionType.Down : this.Direction.SValue === SortDirectionType.Down && (this.Direction.SValue = SortDirectionType.Default), this.Direction.SValue;
  }
  Render() {
    const classSorter = this.Direction.SubState((d) => this.Direction.SValue === SortDirectionType.Default ? "l-sorter" : this.Direction.SValue === SortDirectionType.Up ? "l-sorter l-sorter-up" : "l-sorter l-sorter-down");
    return React.createElement("div", { class: classSorter, onClick: /* @__PURE__ */ __name(() => this.SwitchSort(), "onClick") });
  }
};
__name(_ComponentSortControl, "ComponentSortControl");
let ComponentSortControl = _ComponentSortControl;
const _EachSorter = class _EachSorter extends ComponentSimple {
  Render() {
    return this.props.children;
  }
  AfterBuild() {
    this.DOM = this.GetFirstDOMElement();
    const stylePosition = getComputedStyle(this.DOM).position.toLowerCase();
    stylePosition !== "absolute" && stylePosition !== "relative" && (this.DOM.style.position = "relative"), this.DOM.classList.add("l-sorter-container");
    const eachSorter = this.constructor;
    let sorterComponents = eachSorter.SortMan._SorterComps, sorterComponent = new ComponentSortControl();
    sorterComponents.push(sorterComponent);
    const oldSort = sorterComponent.SwitchSort.bind(sorterComponent);
    sorterComponent.SwitchSort = () => {
      for (let sComp of sorterComponents)
        sComp !== sorterComponent && (sComp.Direction.SValue = 0);
      let direction = oldSort();
      return eachSorter.Sort(direction), direction;
    };
    let sorterDom = sorterComponent._GenerateDOM();
    this.DOM.appendChild(sorterDom);
  }
};
__name(_EachSorter, "EachSorter");
let EachSorter = _EachSorter;
const _EachPaging = class _EachPaging {
  PrevPage() {
    if (this.Paging.Skip.SValue <= this.Paging.Take.SValue)
      return this.Paging.Skip.SValue = 0;
    this.Paging.Skip.SValue = this.Paging.Skip.SValue - this.Paging.Take.SValue;
  }
  NextPage() {
    this.Paging.Skip.SValue + this.Paging.Take.SValue >= this.Paging.Count.SValue || (this.Paging.Skip.SValue = this.Paging.Skip.SValue + this.Paging.Take.SValue);
  }
  LastPage() {
    const take = this.Paging.Take.SValue, lastPage = Math.ceil(this.Paging.Count.SValue / take) - 1;
    this.Paging.Skip.SValue = lastPage * take;
  }
  constructor(paging) {
    this._IsPagingRefreshLocked = !1, this.Paging = luffState(paging);
  }
};
__name(_EachPaging, "EachPaging");
let EachPaging = _EachPaging;
const _EachFilterMan = class _EachFilterMan {
  constructor() {
    this._SorterComps = [], this._deps = [], this._filters = [];
  }
  GenFilter(render) {
    const out = {
      Deps: [],
      Filter: void 0
    };
    let comp = render(out);
    if (!out.Filter)
      throw new Error("[Luff.Each] Missed 'Filter' property in outProps on generating custom filter");
    return this._filters.push(out.Filter), this._deps.push.apply(this._deps, out.Deps), comp;
  }
  GenFilterDate(fieldName, caption) {
    if (!___LuffGlobal.PeriodPicker)
      throw new Error("[Luff.Each] Filter manager's method 'GenFilterDate' requires 'luff-comp' library");
    const dateStart = luffState(null), dateFinish = luffState(null), dateView = dateFinish.SubState((df) => {
      const ds = dateStart.SValue;
      if (!df)
        return Culture.Current.Lang.ChoosePeriod;
      if (ds && df) {
        let luffDateStart = luffDate(ds), luffDateFinish = luffDate(df);
        return `${luffDateStart.Format(Culture.Current.DateFormat)} — ${luffDateFinish.Format(Culture.Current.DateFormat)}`;
      }
    });
    function callPeriodPicker() {
      const ds = dateStart.SValue, df = dateFinish.SValue;
      ___LuffGlobal.PeriodPicker.GlobalRangePicker.RunRange([ds, df], (dStart, dFinish) => {
        dateStart.SValue = dStart.Date, dateFinish.SValue = dFinish.Date;
      }, {
        isShowTimePick: !1
      });
    }
    __name(callPeriodPicker, "callPeriodPicker");
    function reset() {
      dateStart.SValue = null, dateFinish.SValue = null;
    }
    return __name(reset, "reset"), this._deps.push(dateFinish), this._filters.push((item) => {
      const ds = dateStart.SValue, df = dateFinish.SValue;
      if (!df)
        return !0;
      const dateValue = item[fieldName];
      return dateValue >= ds && dateValue <= df;
    }), React.createElement(
      "div",
      { className: "fu-item" },
      React.createElement("div", { className: "caption" }, caption),
      React.createElement("div", { className: "value", onClick: /* @__PURE__ */ __name(() => callPeriodPicker(), "onClick") }, dateView),
      React.createElement("div", { className: "fu-reset", onClick: /* @__PURE__ */ __name(() => reset(), "onClick"), isVisible: dateFinish.SubState((d) => !!d) }, " X ")
    );
  }
  GenFilterTextSearchCustom(caption, textState, filter) {
    const TextBox = ___LuffGlobal.Inputs.TextBox;
    if (!TextBox)
      throw new Error("[Luff.Each] Filter manager's method 'GenFilterTextSearch' requires 'luff-comp' library");
    return this._deps.push(textState), this._filters.push(filter), React.createElement(
      "div",
      { className: "fu-item" },
      React.createElement("div", { className: "caption" }, caption),
      React.createElement(
        "div",
        { className: "value" },
        React.createElement(TextBox, { value: textState, placeholder: "", className: "l-textbox-filter-search" })
      ),
      React.createElement("div", { className: "fu-reset", onClick: /* @__PURE__ */ __name(() => textState.SValue = "", "onClick"), isVisible: textState.SubState((t) => t.length > 0) }, " X ")
    );
  }
  GenFilterTextSearch(fieldNames, caption) {
    const TextBox = ___LuffGlobal.Inputs.TextBox;
    if (!TextBox)
      throw new Error("[Luff.Each] Filter manager's method 'GenFilterTextSearch' requires 'luff-comp' library");
    const text2 = luffState("");
    return this._deps.push(text2), this._filters.push((item) => {
      let textWhere = "";
      for (let fieldName of fieldNames)
        textWhere += item[fieldName];
      return LibraryString.IsTextIncludes(text2.SValue, textWhere);
    }), React.createElement(
      "div",
      { className: "fu-item" },
      React.createElement("div", { className: "caption" }, caption),
      React.createElement(
        "div",
        { className: "value" },
        React.createElement(TextBox, { value: text2, placeholder: "", className: "l-textbox-filter-search" })
      ),
      React.createElement("div", { className: "fu-reset", onClick: /* @__PURE__ */ __name(() => text2.SValue = "", "onClick"), isVisible: text2.SubState((t) => t.length > 0) }, " X ")
    );
  }
};
__name(_EachFilterMan, "EachFilterMan");
let EachFilterMan = _EachFilterMan;
const _Each = class _Each extends ElementBase {
  static GetSortManager(defaultSort) {
    return new EachSorterMan(defaultSort);
  }
  static GetFilterManager() {
    return new EachFilterMan();
  }
  static GetPaging(pageSize, itemsCount = 1) {
    return new EachPaging({
      Skip: 0,
      Take: pageSize,
      Count: itemsCount
    });
  }
  GetRenderedKeys() {
    return this._RenderedKeys;
  }
  GetFilteredKeys() {
    return this._FilteredKeys;
  }
  GetFilterPassedItems() {
    return this._StateArray.filter((x, index) => this._FilteredKeys.includes(index));
  }
  GetFilterNotPassedItems() {
    return this._StateArray.filter((x, index) => !this._FilteredKeys.includes(index));
  }
  GetFilterPassedItemsStates() {
    return this._StateArray.filterState((x, index) => this._FilteredKeys.includes(index));
  }
  GetFilterNotPassedItemsStates() {
    return this._StateArray.filterState((x, index) => !this._FilteredKeys.includes(index));
  }
  GetAllItems() {
    return Array.from(this._MapElements.values()).map((x) => x.Component);
  }
  GetDOMByItemState(itemState) {
    let item = this._MapElements.get(itemState);
    return item ? item.Component.GetFirstDOM() : null;
  }
  GetItemStateByIndex(index) {
    return this._StateArray[index];
  }
  _RenderUpdate(renderNew) {
    this.Refresh();
  }
  _GenerateItem(state, lineID, index) {
    const numState = this.CreateState(index), childItem = this._ChildRender(state, numState, this), childElement = ComponentFactory.Build(childItem, this, this.ParentComponent);
    childElement._GenerateDOM();
    const item = {
      Index: numState,
      LineID: lineID,
      Component: childElement
    };
    return this._MapElements.set(state, item), item;
  }
  _GenerateChildren() {
    this.Refresh();
  }
  _GenerateEmptyChildren() {
    if (this._CompEmptyList = [], !this._ChildEmptyRender)
      return;
    let childItem = this._ChildEmptyRender();
    const childElement = ComponentFactory.Build(childItem, this, this.ParentComponent);
    childElement._GenerateDOM(), this._CompEmptyList.push(childElement);
  }
  _HideItem(comp) {
    comp._HideTransitionFunction(), comp._Disappear();
  }
  _ShowItem(comp, isNew) {
    isNew && comp._IsHiddenByDefault || (comp._ShowTransitionFunction(), comp._Appear());
  }
  _ShowEmptyChildren() {
    this._HideEachChildren(), this._CompEmptyList.length === 0 && this._GenerateEmptyChildren();
    for (let ch of this._CompEmptyList)
      this._ShowItem(ch, !1);
  }
  _HideEmptyChildren() {
    for (let ch of this._CompEmptyList)
      this._HideItem(ch);
  }
  _HideEachChildren() {
    for (let ch of this._MapElements.values())
      this._HideItem(ch.Component);
  }
  _QuickSortFilter(objectKeys) {
    const data = this._StateArray.SValue;
    if (data == null)
      return [];
    if (objectKeys || (objectKeys = Array.from(this._StateArray.SValue.keys())), objectKeys.length < 1 || !this._FilterDelegate && !this._FilterByManager && !this._SortDelegate && !this._EachPaging)
      return objectKeys;
    const pivotKey = objectKeys[Math.floor(objectKeys.length / 2)], pivotValue = this._StateArray._GetChildByKey(pivotKey).SValue;
    let left = [], right = [], equal = [];
    for (let key of objectKeys) {
      let value = this._StateArray._GetChildByKey(key).SValue;
      this._FilterDelegate && !this._FilterDelegate(value, key) || this._FilterByManager && !this._FilterByManager(value, key) || (this._FilteredKeys.push(key), this._SortDelegate && this._SortDelegate(value, pivotValue) < 0 ? left.push(key) : this._SortDelegate && this._SortDelegate(value, pivotValue) > 0 ? right.push(key) : equal.push(key));
    }
    return this._QuickSortFilter(left).concat(equal, this._QuickSortFilter(right));
  }
  _GetKeysForRender(objectKeys) {
    this._FilteredKeys = [];
    let keys = this._QuickSortFilter(objectKeys);
    if (this._EachPaging) {
      const itemsCount = keys.length;
      this._EachPaging.Paging.Count.SValue = itemsCount;
      let skip = this._EachPaging.Paging.Skip.SValue, take = this._EachPaging.Paging.Take.SValue;
      skip > itemsCount && (skip = itemsCount - take), skip < 0 && (skip = 0), this._EachPaging.Paging.Skip.SValue !== skip && (this._EachPaging._IsPagingRefreshLocked = !0, this._EachPaging.Paging.Skip.SValue = skip, this._EachPaging._IsPagingRefreshLocked = !1), keys = keys.slice(skip, skip + take);
    }
    return this._RenderedKeys = keys, this._FilteredKeys = [...new Set(this._FilteredKeys)], keys;
  }
  _RenderKeys(filteredKeys, eachData, targetDOM) {
    filteredKeys.length === 0 ? this._ShowEmptyChildren() : this._HideEmptyChildren();
    let index = 0;
    if (this._EachPaging && (index = this._EachPaging.Paging.Skip.SValue + 1), this._IsStateToRowBindingMode) {
      for (let i = 0; i < eachData.length; i++) {
        let state = eachData._GetChildByKey(i), existsItem = this._MapElements.get(state);
        if (!filteredKeys.includes(i)) {
          existsItem && this._HideItem(existsItem.Component);
          continue;
        }
        if (existsItem) {
          const isVisibleProp = existsItem.Component.props.isVisible;
          (isVisibleProp === void 0 || isVisibleProp === !0 || isVisibleProp.SValue === !0) && this._ShowItem(existsItem.Component, !1);
          continue;
        }
        let valueState = eachData._GetChildByKey(i);
        if (!valueState) {
          console.error(`[Luff.Each] Probably value of StateArray has been changed not by set SValue. Or using .Add(item) to multiple StateArrays with the same value. 
Broken StateArray:`, eachData, `
Broken Each:`, this);
          continue;
        }
        if (valueState.SValue === void 0)
          continue;
        const newItem = this._GenerateItem(valueState, i, index);
        this._MapElements.set(valueState, newItem), this._ShowItem(newItem.Component, !0), index++;
      }
      let rendStates = /* @__PURE__ */ new Set();
      for (let i of filteredKeys) {
        let v = eachData._GetChildByKey(i);
        v && rendStates.add(v);
      }
      const generatedKeys2 = this._MapElements.keys();
      for (let key of generatedKeys2)
        if (console.log("Check", key._ID, key.SValue.WidgetTypeId), !rendStates.has(key)) {
          console.log("remove", key._ID, key.SValue.WidgetTypeId);
          const item = this._MapElements.get(key);
          this._HideItem(item.Component);
        }
      return;
    }
    const generatedKeys = this._MapElements.keys();
    let eachItems = {};
    for (let key of generatedKeys) {
      const item = this._MapElements.get(key);
      if (!filteredKeys.includes(item.LineID)) {
        this._HideItem(item.Component);
        continue;
      }
      eachItems[item.LineID] = item;
    }
    for (let key of filteredKeys) {
      const existsItem = eachItems[key];
      if (existsItem) {
        if (existsItem.Index.SValue = index, index++, this._HideItem(existsItem.Component), this._IsDynamicRenderModeEnabled) {
          existsItem.Component.Dispose();
          const childItem = this._ChildRender(eachData._GetChildByKey(key), existsItem.Index, this);
          existsItem.Component = ComponentFactory.Build(childItem, this, this.ParentComponent), existsItem.Component._GenerateDOM();
        }
        const isVisibleProp = existsItem.Component.props.isVisible;
        (isVisibleProp === void 0 || isVisibleProp === !0 || isVisibleProp.SValue === !0) && this._ShowItem(existsItem.Component, !1);
        continue;
      }
      let valueState = eachData._GetChildByKey(key);
      if (!valueState) {
        console.error(`[Luff.Each] Probably value of StateArray has been changed not by set SValue. Or using .Add(item) to multiple StateArrays with the same value. 
Broken StateArray:`, eachData, `
Broken Each:`, this);
        continue;
      }
      valueState.SValue !== void 0 && (eachItems[key] = this._GenerateItem(valueState, key, index), this._ShowItem(eachItems[key].Component, !0), index++);
    }
  }
  Refresh() {
    let targetDOM = this.GetTargetRenderDOM();
    if (!this._StateArray || this._StateArray.length === 0) {
      this._ShowEmptyChildren();
      return;
    }
    this._SortedKeys = this._GetKeysForRender(), this._RenderKeys(this._RenderedKeys, this._StateArray, targetDOM);
  }
  RefreshLite() {
    let EachData = this._StateArray, TargetDOM = this.GetTargetRenderDOM();
    if (!EachData || this._StateArray.length === 0) {
      this._ShowEmptyChildren();
      return;
    }
    this._RenderKeys(this._RenderedKeys, EachData, TargetDOM);
  }
  Sort(sorter) {
    this._SortDelegate = sorter, this._Sorted = !1, this._SortedKeys = this._GetKeysForRender(), this.RefreshLite();
  }
  Filter(filter = this._FilterDelegate) {
    this._FilterDelegate = filter, this._SortedKeys = this._GetKeysForRender(), this.RefreshLite();
  }
  _GenerateDOM() {
    if (super._GenerateDOM(), !this._StateArray || this._StateArray.length === 0) {
      this._GenerateEmptyChildren(), this._ShowEmptyChildren();
      return;
    }
    this._GenerateChildren();
  }
  constructor(rawComponent) {
    if (super(rawComponent), this._IsRefreshOnAnyChange = !1, this._IsDynamicRenderModeEnabled = !1, this._IsStateToRowBindingMode = !1, this._Sorted = !1, this._RenderedKeys = [], this._SortedKeys = [], this._FilteredKeys = [], this._ChildrenWhenEmpty = [], this._CompEmptyList = [], this._MapElements = /* @__PURE__ */ new Map(), !this.HasPermission)
      return;
    this._StateArray = rawComponent.Attributes.source, this._StateArray.AddOnChange((newValue, changedState) => {
      if (this._IsRefreshOnAnyChange) {
        this.Refresh();
        return;
      }
      changedState === this._StateArray && this.Refresh();
    }), this._IsRefreshOnAnyChange = rawComponent.Attributes.isRefreshOnAnyChange, this._IsRefreshOnAnyChange !== !0 && (this._IsRefreshOnAnyChange = !1), this._IsDynamicRenderModeEnabled = rawComponent.Attributes.isDynamicRenderModeEnabled, this._IsDynamicRenderModeEnabled !== !0 && (this._IsDynamicRenderModeEnabled = !1), this._IsStateToRowBindingMode = rawComponent.Attributes.isStateToRowBindingMode, this._IsStateToRowBindingMode !== !0 && (this._IsStateToRowBindingMode = !1), this._ChildRender = rawComponent.Attributes.render, this._ChildEmptyRender = rawComponent.Attributes.renderOnEmpty, this._EachPaging = rawComponent.Attributes.paging, this._EachPaging && (this._EachPaging.Paging.Skip.AddOnChange(() => {
      this._EachPaging._IsPagingRefreshLocked || this.Filter();
    }), this._EachPaging.Paging.Take.AddOnChange(() => {
      this._EachPaging._IsPagingRefreshLocked || this.Filter();
    }));
    const depOnChange = /* @__PURE__ */ __name(() => {
      this.Refresh();
    }, "depOnChange"), deps = rawComponent.Attributes.deps;
    if (deps)
      for (let dep of deps)
        dep.AddOnChange(depOnChange), this.AddDisposeCallback(() => dep.RemoveOnChange(depOnChange));
    const sortMan = rawComponent.Attributes.sortManager;
    sortMan && (sortMan._Each = this, this._SortDelegate = sortMan._DefaultSort), this._FilterDelegate = rawComponent.Attributes.filter;
    const filterMan = rawComponent.Attributes.filterManager;
    if (filterMan) {
      filterMan._Each = this;
      for (let dep of filterMan._deps)
        dep.AddOnChange(depOnChange), this.AddDisposeCallback(() => dep.RemoveOnChange(depOnChange));
      this._FilterByManager = (item, i) => {
        for (let f of filterMan._filters)
          if (!f(item, i))
            return !1;
        return !0;
      };
    }
  }
};
__name(_Each, "Each");
let Each = _Each;
const _FilePicker = class _FilePicker {
  Run(onChange) {
    this.ParamOnChange = onChange, this.InputFile.click();
  }
  constructor(ctor = {}) {
    this.InputFile = document.createElement("input"), this.InputFile.setAttribute("type", "file"), ctor.Accept && this.InputFile.setAttribute("accept", ctor.Accept), ctor.IsMultiple && this.InputFile.setAttribute("multiple", "multiple"), this.InputFile.addEventListener("change", () => {
      const files = Array.from(this.InputFile.files);
      if (this.InputFile.value = "", this.ParamOnChange) {
        this.ParamOnChange(files);
        return;
      }
      this.CtorOnChange && this.CtorOnChange(files);
    }), this.CtorOnChange = ctor.OnChange;
  }
};
__name(_FilePicker, "FilePicker");
let FilePicker = _FilePicker;
const _TConfirmOptions = class _TConfirmOptions {
  constructor() {
    this.Error = !1, this.CaptionColor = "", this.CaptionBackground = "", this.ButtonAgreeText = Culture.Current.Lang.Ok, this.ButtonCancelText = Culture.Current.Lang.Cancel, this.OnAgree = () => {
    }, this.OnCancel = void 0, this.Wrapper = !0;
  }
};
__name(_TConfirmOptions, "TConfirmOptions");
let TConfirmOptions = _TConfirmOptions;
function luffConfirm(Caption = "Achtung", Message = "", options) {
  options ? options = Object.assign(Object.assign({}, new TConfirmOptions()), options) : options = new TConfirmOptions(), document.activeElement.blur();
  let dialog = document.createElement("div");
  dialog.classList.add("l-confirm-dialog");
  let title = document.createElement("div");
  title.classList.add("cd-caption"), title.innerHTML = Caption, title.style.color = options.CaptionColor, title.style.background = options.CaptionBackground, dialog.appendChild(title);
  let msg = document.createElement("div");
  msg.classList.add("cd-text"), msg.innerHTML = Message, dialog.appendChild(msg);
  let buttons = document.createElement("div");
  buttons.classList.add("cd-buttons"), dialog.appendChild(buttons);
  let btnOk = document.createElement("div");
  if (btnOk.classList.add("l-button", "button", "cd-button", "btn-diag-confirm"), btnOk.innerHTML = options.ButtonAgreeText, btnOk.onclick = function() {
    options.OnAgree !== null && options.OnAgree !== void 0 && options.OnAgree(), wrap.remove(), dialog.remove();
  }, dialog.getElementsByClassName("cd-buttons")[0].appendChild(btnOk), options.OnCancel) {
    let btnCancel = document.createElement("div");
    btnCancel.classList.add("l-button", "button", "cd-button", "btn-diag-cancel"), btnCancel.innerHTML = options.ButtonCancelText, btnCancel.onclick = function() {
      options.OnCancel && options.OnCancel(), wrap.remove(), dialog.remove();
    }, dialog.getElementsByClassName("cd-buttons")[0].appendChild(btnCancel);
  }
  let wrap = document.createElement("div");
  wrap.classList.add("l-confirm-dialog-wrapper"), options.Wrapper && document.body.appendChild(wrap), document.body.appendChild(dialog);
}
__name(luffConfirm, "luffConfirm");
function luffConfirmPromise(caption, message, options) {
  return new Promise((resolve, reject) => {
    luffConfirm(caption, message, Object.assign(Object.assign({}, options), { OnAgree() {
      resolve(options.OnAgree());
    }, OnCancel: /* @__PURE__ */ __name(() => resolve(options.OnCancel ? options.OnCancel() : ""), "OnCancel") }));
  });
}
__name(luffConfirmPromise, "luffConfirmPromise");
var LibraryTree;
(function(LibraryTree2) {
  function IsExists(tree, subKey, searchFn) {
    for (let item of tree)
      if (searchFn(item) || IsExists(item[subKey], subKey, searchFn))
        return !0;
    return !1;
  }
  __name(IsExists, "IsExists"), LibraryTree2.IsExists = IsExists;
  function Flatten(tree, subKey, selector = (item) => item, lvl = 0) {
    let res = [], i = 0;
    for (let item of tree)
      res.push(selector(item, i, lvl)), i++, item[subKey] && res.push(...Flatten(item[subKey], subKey, selector, lvl++));
    return res;
  }
  __name(Flatten, "Flatten"), LibraryTree2.Flatten = Flatten;
  function Map2(tree, subKey, selector = (item) => item) {
    let res = [];
    for (let item of tree) {
      let newItem = selector(item);
      newItem[subKey] = Map2(item[subKey], subKey, selector), res.push(newItem);
    }
    return res;
  }
  __name(Map2, "Map"), LibraryTree2.Map = Map2;
  function Filter(tree, subKey, predicate, isDropBranch = !1) {
    let res = [];
    for (let item of tree) {
      let newItem;
      const isPassed = predicate(item);
      isPassed ? (newItem = Object.assign({}, item), newItem[subKey] = Filter(newItem[subKey], subKey, predicate), res.push(newItem)) : !isPassed && isDropBranch || !isPassed && !isDropBranch && res.push(...Filter(item[subKey], subKey, predicate));
    }
    return res;
  }
  __name(Filter, "Filter"), LibraryTree2.Filter = Filter;
  function Find(tree, subKey, predicate) {
    for (let item of tree) {
      if (predicate(item))
        return item;
      {
        let found = Find(item[subKey], subKey, predicate);
        if (found)
          return found;
      }
    }
    return null;
  }
  __name(Find, "Find"), LibraryTree2.Find = Find;
  function ForEachProcess(tree, subKey, action, parent, depth) {
    for (let item of tree) {
      if (action(item, parent, depth))
        break;
      ForEachProcess(item[subKey], subKey, action, item, depth + 1);
    }
  }
  __name(ForEachProcess, "ForEachProcess");
  function ForEach(tree, subKey, action) {
    for (let item of tree) {
      if (action(item, null, 0))
        break;
      ForEachProcess(item[subKey], subKey, action, item, 1);
    }
  }
  __name(ForEach, "ForEach"), LibraryTree2.ForEach = ForEach;
  function ForEachFromReverseProcess(tree, subKey, action, parent) {
    for (let item of tree)
      if (ForEachFromReverseProcess(item[subKey], subKey, action, item), action(item, parent))
        break;
  }
  __name(ForEachFromReverseProcess, "ForEachFromReverseProcess");
  function ForEachReverse(tree, subKey, action) {
    for (let item of tree)
      if (ForEachFromReverseProcess(item[subKey], subKey, action, item), action(item, null))
        break;
  }
  __name(ForEachReverse, "ForEachReverse"), LibraryTree2.ForEachReverse = ForEachReverse;
})(LibraryTree || (LibraryTree = {}));
const _DynamicRenderComponent = class _DynamicRenderComponent extends ElementBase {
  //private _Child: IElement;
  // private _HideItem(comp: IElement) : void {
  //     comp._HideTransitionFunction();
  //     comp._Disappear();
  // }
  // private _ShowItem(comp: IElement, isNew: boolean) : void {
  //     if (isNew && (comp as ElementBase)._IsHiddenByDefault)
  //         return;
  //
  //     comp._ShowTransitionFunction();
  //     comp._Appear();
  // }
  _RenderUpdate(render) {
    const chs = [...this.Children];
    for (const ch of chs)
      ch.Dispose();
    this._RenderChildren();
  }
  Refresh() {
    this._RenderUpdate(this.props.render());
  }
  _RenderChildren() {
    const rendered = this.props.render();
    if (Array.isArray(rendered)) {
      for (let sub of rendered)
        this.AppendChild(sub);
      return;
    }
    this.AppendChild(rendered);
  }
  _GenerateDOM() {
    super._GenerateDOM(), this._RenderChildren();
  }
  constructor(rawComponent) {
    if (super(rawComponent), !this.HasPermission)
      return;
    const deps = rawComponent.Attributes.deps;
    if (deps)
      for (let dep of deps)
        dep.AddOnChange((c) => {
          this.Refresh();
        });
  }
};
__name(_DynamicRenderComponent, "DynamicRenderComponent");
let DynamicRenderComponent = _DynamicRenderComponent;
const _RawHtmlComponent = class _RawHtmlComponent extends CasualMountingBase {
  _Dismount() {
    this._IsMount = !1, this.DOM.remove();
  }
  _GenerateDOM() {
    return this._GenerateDOM = null, this.DOM = this.props.html, this.DOM;
  }
};
__name(_RawHtmlComponent, "RawHtmlComponent");
let RawHtmlComponent = _RawHtmlComponent;
var Luff;
(function(Luff2) {
  Luff2.createElement = React.createElement, Luff2.ComponentBuilder = ComponentFactory.Build, Luff2.Content = Content, Luff2.ComponentSimple = ComponentSimple, Luff2.State = luffState, Luff2.StateArr = luffStateArr, Luff2.Application = Application, Luff2.Date = luffDate, Luff2.Linq = luffLinq, Luff2.Array = LibraryArray, Luff2.Tree = LibraryTree, Luff2.DOM = LibraryDOM, Luff2.String = LibraryString, Luff2.Blob = LibraryBlob, Luff2.Number = LibraryNumber, Luff2.Object = LibraryObject, Luff2.Culture = Culture, Luff2.Settings = AppSettings, Luff2.Pop = PopLog, Luff2.RunConfirm = luffConfirm, Luff2.RunConfirmPromise = luffConfirmPromise, Luff2.Load = LuffLoadNative, Luff2.Fragment = CasualFragmentComponent;
  function Perf(callback, caption = "") {
    let v1 = window.performance.now();
    callback();
    let perf = window.performance.now() - v1;
    return console.log(`[Perf] ${caption}: ` + perf), perf;
  }
  __name(Perf, "Perf"), Luff2.Perf = Perf;
})(Luff || (Luff = {}));
window.___LuffGlobal = {
  PeriodPicker: void 0,
  Inputs: {}
};
const Luff$1 = Luff;
export {
  Application,
  ComponentFactory,
  ComponentSimple,
  Culture,
  DynamicRenderComponent,
  Each,
  EachPaging,
  EachSorter,
  ElementBase,
  FilePicker,
  luffDate as LDate,
  LibraryArray,
  LibraryBlob,
  LibraryDOM,
  LibraryNumber,
  LibraryObject,
  LibraryString,
  LibraryTree,
  LuffDate,
  LuffListener,
  LuffLoad,
  PropTypes,
  RawHtmlComponent,
  React,
  Route,
  RouteLink,
  State,
  StateArray,
  Luff$1 as default,
  getClosestStateArray,
  luffDate,
  luffLinq,
  luffState,
  luffStateArr
};
//# sourceMappingURL=index.js.map
